import { BaseEntity, EntitySaveOptions, EntityDeleteOptions, CompositeKey, ValidationResult, ValidationErrorInfo, ValidationErrorType, Metadata, ProviderType, DatabaseProviderBase, RunView } from "@memberjunction/core";
import { RegisterClass } from "@memberjunction/global";
import { z } from "zod";

     
 
/**
 * zod schema definition for the entity MemberSuite: Batches
 */
export const membersuiteBatchSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    BankReconciliation: z.string().nullable().describe(`
        * * Field Name: BankReconciliation
        * * Display Name: Bank Reconciliation
        * * SQL Data Type: uniqueidentifier`),
    Description: z.string().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: nvarchar(MAX)`),
    DatePosted: z.date().nullable().describe(`
        * * Field Name: DatePosted
        * * Display Name: Date Posted
        * * SQL Data Type: date`),
    DateClosed: z.date().nullable().describe(`
        * * Field Name: DateClosed
        * * Display Name: Date Closed
        * * SQL Data Type: date`),
    DateExported: z.date().nullable().describe(`
        * * Field Name: DateExported
        * * Display Name: Date Exported
        * * SQL Data Type: datetime2`),
    ClosedBy: z.string().nullable().describe(`
        * * Field Name: ClosedBy
        * * Display Name: Closed By
        * * SQL Data Type: uniqueidentifier`),
    PostedBy: z.string().nullable().describe(`
        * * Field Name: PostedBy
        * * Display Name: Posted By
        * * SQL Data Type: uniqueidentifier`),
    FiscalYear: z.string().nullable().describe(`
        * * Field Name: FiscalYear
        * * Display Name: Fiscal Year
        * * SQL Data Type: uniqueidentifier`),
    FiscalPeriod: z.number().nullable().describe(`
        * * Field Name: FiscalPeriod
        * * Display Name: Fiscal Period
        * * SQL Data Type: bigint`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Status: z.string().nullable().describe(`
        * * Field Name: Status
        * * Display Name: Status
        * * SQL Data Type: nvarchar(100)`),
    DateVerified: z.date().nullable().describe(`
        * * Field Name: DateVerified
        * * Display Name: Date Verified
        * * SQL Data Type: date`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    ControlTotal: z.number().nullable().describe(`
        * * Field Name: ControlTotal
        * * Display Name: Control Total
        * * SQL Data Type: decimal(19, 4)`),
    ControlCount: z.number().nullable().describe(`
        * * Field Name: ControlCount
        * * Display Name: Control Count
        * * SQL Data Type: bigint`),
    RestrictAccess: z.boolean().nullable().describe(`
        * * Field Name: RestrictAccess
        * * Display Name: Restrict Access
        * * SQL Data Type: bit`),
    PostAutomatically: z.boolean().nullable().describe(`
        * * Field Name: PostAutomatically
        * * Display Name: Post Automatically
        * * SQL Data Type: bit`),
    DateToAutomaticallyClose: z.date().nullable().describe(`
        * * Field Name: DateToAutomaticallyClose
        * * Display Name: Date To Automatically Close
        * * SQL Data Type: datetime2`),
    RecurringBatchDefinition: z.string().nullable().describe(`
        * * Field Name: RecurringBatchDefinition
        * * Display Name: Recurring Batch Definition
        * * SQL Data Type: uniqueidentifier`),
    ClosedByName: z.string().nullable().describe(`
        * * Field Name: ClosedByName
        * * Display Name: Closed By Name
        * * SQL Data Type: nvarchar(500)`),
    PostedByName: z.string().nullable().describe(`
        * * Field Name: PostedByName
        * * Display Name: Posted By Name
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteBatchEntityType = z.infer<typeof membersuiteBatchSchema>;

/**
 * zod schema definition for the entity MemberSuite: Business Units
 */
export const membersuiteBusinessUnitSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    Description: z.string().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: nvarchar(MAX)`),
    BaseCurrency: z.string().nullable().describe(`
        * * Field Name: BaseCurrency
        * * Display Name: Base Currency
        * * SQL Data Type: nvarchar(500)`),
    DisplayAddress: z.string().nullable().describe(`
        * * Field Name: DisplayAddress
        * * Display Name: Display Address
        * * SQL Data Type: nvarchar(MAX)`),
    GenerateInvoicesOnZeroDollarOrders: z.boolean().nullable().describe(`
        * * Field Name: GenerateInvoicesOnZeroDollarOrders
        * * Display Name: Generate Invoices On Zero Dollar Orders
        * * SQL Data Type: bit`),
    DefaultInvoiceType: z.string().nullable().describe(`
        * * Field Name: DefaultInvoiceType
        * * Display Name: Default Invoice Type
        * * SQL Data Type: uniqueidentifier`),
    IsDefault: z.boolean().nullable().describe(`
        * * Field Name: IsDefault
        * * Display Name: Is Default
        * * SQL Data Type: bit`),
    StartOfFiscalYear: z.string().nullable().describe(`
        * * Field Name: StartOfFiscalYear
        * * Display Name: Start Of Fiscal Year
        * * SQL Data Type: nvarchar(100)`),
    FinancialSoftwarePackage: z.string().nullable().describe(`
        * * Field Name: FinancialSoftwarePackage
        * * Display Name: Financial Software Package
        * * SQL Data Type: nvarchar(100)`),
    DefaultInvoiceTemplate: z.string().nullable().describe(`
        * * Field Name: DefaultInvoiceTemplate
        * * Display Name: Default Invoice Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultOrderTemplate: z.string().nullable().describe(`
        * * Field Name: DefaultOrderTemplate
        * * Display Name: Default Order Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultPaymentReceiptTemplate: z.string().nullable().describe(`
        * * Field Name: DefaultPaymentReceiptTemplate
        * * Display Name: Default Payment Receipt Template
        * * SQL Data Type: uniqueidentifier`),
    InvoiceReport: z.string().nullable().describe(`
        * * Field Name: InvoiceReport
        * * Display Name: Invoice Report
        * * SQL Data Type: uniqueidentifier`),
    PaymentReceiptReport: z.string().nullable().describe(`
        * * Field Name: PaymentReceiptReport
        * * Display Name: Payment Receipt Report
        * * SQL Data Type: uniqueidentifier`),
    DefaultInventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: DefaultInventoryCostingMethod
        * * Display Name: Default Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    DefaultWriteOffMethod: z.string().nullable().describe(`
        * * Field Name: DefaultWriteOffMethod
        * * Display Name: Default Write Off Method
        * * SQL Data Type: nvarchar(100)`),
    BatchDownloadMethod: z.string().nullable().describe(`
        * * Field Name: BatchDownloadMethod
        * * Display Name: Batch Download Method
        * * SQL Data Type: nvarchar(100)`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    BatchDownloadTemplate: z.string().nullable().describe(`
        * * Field Name: BatchDownloadTemplate
        * * Display Name: Batch Download Template
        * * SQL Data Type: uniqueidentifier`),
    VerifyControlValuesWhenPostingBatches: z.boolean().nullable().describe(`
        * * Field Name: VerifyControlValuesWhenPostingBatches
        * * Display Name: Verify Control Values When Posting Batches
        * * SQL Data Type: bit`),
    EnableWordBasedInvoicesAndReceipts: z.boolean().nullable().describe(`
        * * Field Name: EnableWordBasedInvoicesAndReceipts
        * * Display Name: Enable Word Based Invoices And Receipts
        * * SQL Data Type: bit`),
    DoNotAllowPartialPaymentsInPortal: z.boolean().nullable().describe(`
        * * Field Name: DoNotAllowPartialPaymentsInPortal
        * * Display Name: Do Not Allow Partial Payments In Portal
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteBusinessUnitEntityType = z.infer<typeof membersuiteBusinessUnitSchema>;

/**
 * zod schema definition for the entity MemberSuite: COGS Entries
 */
export const membersuiteCOGSEntrySchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    OrderLineItemID: z.string().nullable().describe(`
        * * Field Name: OrderLineItemID
        * * Display Name: Order Line Item ID
        * * SQL Data Type: nvarchar(500)`),
    StockItemInventory: z.string().nullable().describe(`
        * * Field Name: StockItemInventory
        * * Display Name: Stock Item Inventory
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    FiscalYear: z.string().nullable().describe(`
        * * Field Name: FiscalYear
        * * Display Name: Fiscal Year
        * * SQL Data Type: uniqueidentifier`),
    FiscalPeriod: z.number().nullable().describe(`
        * * Field Name: FiscalPeriod
        * * Display Name: Fiscal Period
        * * SQL Data Type: bigint`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    UnitCost: z.number().nullable().describe(`
        * * Field Name: UnitCost
        * * Display Name: Unit Cost
        * * SQL Data Type: decimal(19, 4)`),
    Quantity: z.number().nullable().describe(`
        * * Field Name: Quantity
        * * Display Name: Quantity
        * * SQL Data Type: bigint`),
    FulfillmentTransaction: z.string().nullable().describe(`
        * * Field Name: FulfillmentTransaction
        * * Display Name: Fulfillment Transaction
        * * SQL Data Type: uniqueidentifier`),
    ReturnTransaction: z.string().nullable().describe(`
        * * Field Name: ReturnTransaction
        * * Display Name: Return Transaction
        * * SQL Data Type: uniqueidentifier`),
    InventoryReceipt: z.string().nullable().describe(`
        * * Field Name: InventoryReceipt
        * * Display Name: Inventory Receipt
        * * SQL Data Type: uniqueidentifier`),
    TotalCost: z.number().nullable().describe(`
        * * Field Name: TotalCost
        * * Display Name: Total Cost
        * * SQL Data Type: decimal(19, 4)`),
    Description: z.string().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: nvarchar(500)`),
    ParentCOGSEntry: z.string().nullable().describe(`
        * * Field Name: ParentCOGSEntry
        * * Display Name: Parent COGS Entry
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteCOGSEntryEntityType = z.infer<typeof membersuiteCOGSEntrySchema>;

/**
 * zod schema definition for the entity MemberSuite: Cancellation Fee Products
 */
export const membersuiteCancellationFeeProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteCancellationFeeProductEntityType = z.infer<typeof membersuiteCancellationFeeProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Change Memo Line Items
 */
export const membersuiteChangeMemoLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    quantity: z.number().nullable().describe(`
        * * Field Name: quantity
        * * Display Name: quantity
        * * SQL Data Type: bigint`),
    invoiceLineItemID: z.string().describe(`
        * * Field Name: invoiceLineItemID
        * * Display Name: invoice Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    description: z.string().nullable().describe(`
        * * Field Name: description
        * * Display Name: description
        * * SQL Data Type: nvarchar(500)`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteChangeMemoLineItemEntityType = z.infer<typeof membersuiteChangeMemoLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Chapter Dues Products
 */
export const membersuiteChapterDuesProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    MembershipOrganization: z.string().nullable().describe(`
        * * Field Name: MembershipOrganization
        * * Display Name: Membership Organization
        * * SQL Data Type: uniqueidentifier`),
    Chapter: z.string().nullable().describe(`
        * * Field Name: Chapter
        * * Display Name: Chapter
        * * SQL Data Type: uniqueidentifier`),
    MembershipType: z.string().nullable().describe(`
        * * Field Name: MembershipType
        * * Display Name: Membership Type
        * * SQL Data Type: uniqueidentifier`),
    RenewsWith: z.string().nullable().describe(`
        * * Field Name: RenewsWith
        * * Display Name: Renews With
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteChapterDuesProductEntityType = z.infer<typeof membersuiteChapterDuesProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Credit Line Items
 */
export const membersuiteCreditLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    paymentLineItemID: z.string().describe(`
        * * Field Name: paymentLineItemID
        * * Display Name: payment Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    Credit: z.string().nullable().describe(`
        * * Field Name: Credit
        * * Display Name: Credit
        * * SQL Data Type: uniqueidentifier`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteCreditLineItemEntityType = z.infer<typeof membersuiteCreditLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Credit Memos
 */
export const membersuiteCreditMemoSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    Invoice: z.string().nullable().describe(`
        * * Field Name: Invoice
        * * Display Name: Invoice
        * * SQL Data Type: uniqueidentifier`),
    ExchangeRate: z.number().nullable().describe(`
        * * Field Name: ExchangeRate
        * * Display Name: Exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteCreditMemoEntityType = z.infer<typeof membersuiteCreditMemoSchema>;

/**
 * zod schema definition for the entity MemberSuite: Credits
 */
export const membersuiteCreditSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    LiabilityGLAccount: z.string().nullable().describe(`
        * * Field Name: LiabilityGLAccount
        * * Display Name: Liability GL Account
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    InvoiceInstructions: z.string().nullable().describe(`
        * * Field Name: InvoiceInstructions
        * * Display Name: Invoice Instructions
        * * SQL Data Type: nvarchar(100)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    AmountUsed: z.number().nullable().describe(`
        * * Field Name: AmountUsed
        * * Display Name: Amount Used
        * * SQL Data Type: decimal(19, 4)`),
    Owner: z.string().nullable().describe(`
        * * Field Name: Owner
        * * Display Name: Owner
        * * SQL Data Type: uniqueidentifier`),
    PaymentLineItemID: z.string().nullable().describe(`
        * * Field Name: PaymentLineItemID
        * * Display Name: Payment Line Item ID
        * * SQL Data Type: nvarchar(500)`),
    Payment: z.string().nullable().describe(`
        * * Field Name: Payment
        * * Display Name: Payment
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    TransactionID: z.string().nullable().describe(`
        * * Field Name: TransactionID
        * * Display Name: Transaction ID
        * * SQL Data Type: nvarchar(500)`),
    ExchangeRate: z.number().nullable().describe(`
        * * Field Name: ExchangeRate
        * * Display Name: Exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteCreditEntityType = z.infer<typeof membersuiteCreditSchema>;

/**
 * zod schema definition for the entity MemberSuite: Debit Memos
 */
export const membersuiteDebitMemoSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    Invoice: z.string().nullable().describe(`
        * * Field Name: Invoice
        * * Display Name: Invoice
        * * SQL Data Type: uniqueidentifier`),
    ExchangeRate: z.number().nullable().describe(`
        * * Field Name: ExchangeRate
        * * Display Name: Exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteDebitMemoEntityType = z.infer<typeof membersuiteDebitMemoSchema>;

/**
 * zod schema definition for the entity MemberSuite: Discount Products
 */
export const membersuiteDiscountProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteDiscountProductEntityType = z.infer<typeof membersuiteDiscountProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Due To Due From Entries
 */
export const membersuiteDueToDueFromEntrySchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    FromBusinessUnit: z.string().nullable().describe(`
        * * Field Name: FromBusinessUnit
        * * Display Name: From Business Unit
        * * SQL Data Type: uniqueidentifier`),
    ToBusinessUnit: z.string().nullable().describe(`
        * * Field Name: ToBusinessUnit
        * * Display Name: To Business Unit
        * * SQL Data Type: uniqueidentifier`),
    AccountsReceivableAccount: z.string().nullable().describe(`
        * * Field Name: AccountsReceivableAccount
        * * Display Name: Accounts Receivable Account
        * * SQL Data Type: uniqueidentifier`),
    LiabilityAccount: z.string().nullable().describe(`
        * * Field Name: LiabilityAccount
        * * Display Name: Liability Account
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteDueToDueFromEntryEntityType = z.infer<typeof membersuiteDueToDueFromEntrySchema>;

/**
 * zod schema definition for the entity MemberSuite: Fiscal Years
 */
export const membersuiteFiscalYearSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    Year: z.number().nullable().describe(`
        * * Field Name: Year
        * * Display Name: Year
        * * SQL Data Type: bigint`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    IsClosed: z.boolean().nullable().describe(`
        * * Field Name: IsClosed
        * * Display Name: Is Closed
        * * SQL Data Type: bit`),
    ClosedBy: z.string().nullable().describe(`
        * * Field Name: ClosedBy
        * * Display Name: Closed By
        * * SQL Data Type: uniqueidentifier`),
    StartDate: z.date().nullable().describe(`
        * * Field Name: StartDate
        * * Display Name: Start Date
        * * SQL Data Type: date`),
    EndDate: z.date().nullable().describe(`
        * * Field Name: EndDate
        * * Display Name: End Date
        * * SQL Data Type: date`),
    ClosedByName: z.string().nullable().describe(`
        * * Field Name: ClosedByName
        * * Display Name: Closed By Name
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteFiscalYearEntityType = z.infer<typeof membersuiteFiscalYearSchema>;

/**
 * zod schema definition for the entity MemberSuite: Fundraising Products
 */
export const membersuiteFundraisingProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    Campaign: z.string().nullable().describe(`
        * * Field Name: Campaign
        * * Display Name: Campaign
        * * SQL Data Type: uniqueidentifier`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Appeal: z.string().nullable().describe(`
        * * Field Name: Appeal
        * * Display Name: Appeal
        * * SQL Data Type: uniqueidentifier`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    GiftSubType: z.string().nullable().describe(`
        * * Field Name: GiftSubType
        * * Display Name: Gift Sub Type
        * * SQL Data Type: uniqueidentifier`),
    Fund: z.string().nullable().describe(`
        * * Field Name: Fund
        * * Display Name: Fund
        * * SQL Data Type: uniqueidentifier`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteFundraisingProductEntityType = z.infer<typeof membersuiteFundraisingProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: GL Accounts
 */
export const membersuiteGLAccountSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    Description: z.string().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteGLAccountEntityType = z.infer<typeof membersuiteGLAccountSchema>;

/**
 * zod schema definition for the entity MemberSuite: Individuals
 */
export const membersuiteIndividualSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Nickname: z.string().nullable().describe(`
        * * Field Name: Nickname
        * * Display Name: Nickname
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    MiddleName: z.string().nullable().describe(`
        * * Field Name: MiddleName
        * * Display Name: Middle Name
        * * SQL Data Type: nvarchar(500)`),
    EmailAddress: z.string().nullable().describe(`
        * * Field Name: EmailAddress
        * * Display Name: Email Address
        * * SQL Data Type: nvarchar(256)`),
    FirstName: z.string().nullable().describe(`
        * * Field Name: FirstName
        * * Display Name: First Name
        * * SQL Data Type: nvarchar(500)`),
    LastName: z.string().nullable().describe(`
        * * Field Name: LastName
        * * Display Name: Last Name
        * * SQL Data Type: nvarchar(500)`),
    PaymentGatewayID: z.string().nullable().describe(`
        * * Field Name: PaymentGatewayID
        * * Display Name: Payment Gateway ID
        * * SQL Data Type: nvarchar(500)`),
    Status: z.string().nullable().describe(`
        * * Field Name: Status
        * * Display Name: Status
        * * SQL Data Type: uniqueidentifier`),
    IneligibleFunds: z.string().nullable().describe(`
        * * Field Name: IneligibleFunds
        * * Display Name: Ineligible Funds
        * * SQL Data Type: uniqueidentifier`),
    TaxExempt: z.boolean().nullable().describe(`
        * * Field Name: TaxExempt
        * * Display Name: Tax Exempt
        * * SQL Data Type: bit`),
    DefaultCreditTerms: z.string().nullable().describe(`
        * * Field Name: DefaultCreditTerms
        * * Display Name: Default Credit Terms
        * * SQL Data Type: uniqueidentifier`),
    PreferredAddressType: z.string().nullable().describe(`
        * * Field Name: PreferredAddressType
        * * Display Name: Preferred Address Type
        * * SQL Data Type: uniqueidentifier`),
    PreferredPhoneNumberType: z.string().nullable().describe(`
        * * Field Name: PreferredPhoneNumberType
        * * Display Name: Preferred Phone Number Type
        * * SQL Data Type: uniqueidentifier`),
    DonorLevel: z.string().nullable().describe(`
        * * Field Name: DonorLevel
        * * Display Name: Donor Level
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    WebSite: z.string().nullable().describe(`
        * * Field Name: WebSite
        * * Display Name: Web Site
        * * SQL Data Type: nvarchar(512)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    NRDSID: z.number().nullable().describe(`
        * * Field Name: NRDSID
        * * Display Name: Nrdsid
        * * SQL Data Type: bigint`),
    FacebookProfile: z.string().nullable().describe(`
        * * Field Name: FacebookProfile
        * * Display Name: Facebook Profile
        * * SQL Data Type: nvarchar(500)`),
    FacebookId: z.string().nullable().describe(`
        * * Field Name: FacebookId
        * * Display Name: Facebook Id
        * * SQL Data Type: nvarchar(500)`),
    TwitterHandle: z.string().nullable().describe(`
        * * Field Name: TwitterHandle
        * * Display Name: Twitter Handle
        * * SQL Data Type: nvarchar(500)`),
    TwitterId: z.string().nullable().describe(`
        * * Field Name: TwitterId
        * * Display Name: Twitter Id
        * * SQL Data Type: nvarchar(500)`),
    LinkedInProfile: z.string().nullable().describe(`
        * * Field Name: LinkedInProfile
        * * Display Name: Linked In Profile
        * * SQL Data Type: nvarchar(500)`),
    LinkedInId: z.string().nullable().describe(`
        * * Field Name: LinkedInId
        * * Display Name: Linked In Id
        * * SQL Data Type: nvarchar(500)`),
    GooglePlusUrl: z.string().nullable().describe(`
        * * Field Name: GooglePlusUrl
        * * Display Name: Google Plus Url
        * * SQL Data Type: nvarchar(500)`),
    GooglePlusId: z.string().nullable().describe(`
        * * Field Name: GooglePlusId
        * * Display Name: Google Plus Id
        * * SQL Data Type: nvarchar(500)`),
    InstagramProfile: z.string().nullable().describe(`
        * * Field Name: InstagramProfile
        * * Display Name: Instagram Profile
        * * SQL Data Type: nvarchar(500)`),
    InstagramId: z.string().nullable().describe(`
        * * Field Name: InstagramId
        * * Display Name: Instagram Id
        * * SQL Data Type: nvarchar(500)`),
    DoNotEmail: z.boolean().nullable().describe(`
        * * Field Name: DoNotEmail
        * * Display Name: Do Not Email
        * * SQL Data Type: bit`),
    CommunicationsLastVerified: z.date().nullable().describe(`
        * * Field Name: CommunicationsLastVerified
        * * Display Name: Communications Last Verified
        * * SQL Data Type: datetime2`),
    CommunicationsLastVerifiedFrom: z.string().nullable().describe(`
        * * Field Name: CommunicationsLastVerifiedFrom
        * * Display Name: Communications Last Verified From
        * * SQL Data Type: nvarchar(500)`),
    DoNotFax: z.boolean().nullable().describe(`
        * * Field Name: DoNotFax
        * * Display Name: Do Not Fax
        * * SQL Data Type: bit`),
    DoNotMail: z.boolean().nullable().describe(`
        * * Field Name: DoNotMail
        * * Display Name: Do Not Mail
        * * SQL Data Type: bit`),
    Age: z.number().nullable().describe(`
        * * Field Name: Age
        * * Display Name: Age
        * * SQL Data Type: bigint`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: uniqueidentifier`),
    DateOfBirth: z.date().nullable().describe(`
        * * Field Name: DateOfBirth
        * * Display Name: Date Of Birth
        * * SQL Data Type: date`),
    EmailAddress2: z.string().nullable().describe(`
        * * Field Name: EmailAddress2
        * * Display Name: Email Address 2
        * * SQL Data Type: nvarchar(256)`),
    EmailAddress3: z.string().nullable().describe(`
        * * Field Name: EmailAddress3
        * * Display Name: Email Address 3
        * * SQL Data Type: nvarchar(256)`),
    Title: z.string().nullable().describe(`
        * * Field Name: Title
        * * Display Name: Title
        * * SQL Data Type: nvarchar(500)`),
    Prefix: z.string().nullable().describe(`
        * * Field Name: Prefix
        * * Display Name: Prefix
        * * SQL Data Type: nvarchar(500)`),
    Suffix: z.string().nullable().describe(`
        * * Field Name: Suffix
        * * Display Name: Suffix
        * * SQL Data Type: nvarchar(500)`),
    Designation: z.string().nullable().describe(`
        * * Field Name: Designation
        * * Display Name: Designation
        * * SQL Data Type: nvarchar(500)`),
    Company: z.string().nullable().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(500)`),
    SeasonalAddressStart: z.date().nullable().describe(`
        * * Field Name: SeasonalAddressStart
        * * Display Name: Seasonal Address Start
        * * SQL Data Type: date`),
    SeasonalAddressEnd: z.date().nullable().describe(`
        * * Field Name: SeasonalAddressEnd
        * * Display Name: Seasonal Address End
        * * SQL Data Type: date`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    SortName: z.string().nullable().describe(`
        * * Field Name: SortName
        * * Display Name: Sort Name
        * * SQL Data Type: nvarchar(500)`),
    Image: z.number().nullable().describe(`
        * * Field Name: Image
        * * Display Name: Image
        * * SQL Data Type: decimal(19, 4)`),
    PrimaryOrganization__rtg: z.string().nullable().describe(`
        * * Field Name: PrimaryOrganization__rtg
        * * Display Name: Primary Organization Rtg
        * * SQL Data Type: uniqueidentifier`),
    Gender__c: z.string().nullable().describe(`
        * * Field Name: Gender__c
        * * Display Name: Gender C
        * * SQL Data Type: nvarchar(500)`),
    SpouseName__c: z.string().nullable().describe(`
        * * Field Name: SpouseName__c
        * * Display Name: Spouse Name C
        * * SQL Data Type: nvarchar(500)`),
    Bio__c: z.string().nullable().describe(`
        * * Field Name: Bio__c
        * * Display Name: Bio C
        * * SQL Data Type: nvarchar(MAX)`),
    MaritalStatus__c: z.string().nullable().describe(`
        * * Field Name: MaritalStatus__c
        * * Display Name: Marital Status C
        * * SQL Data Type: nvarchar(500)`),
    MembershipCategory__c: z.string().nullable().describe(`
        * * Field Name: MembershipCategory__c
        * * Display Name: Membership Category C
        * * SQL Data Type: nvarchar(500)`),
    NRDSID__c: z.string().nullable().describe(`
        * * Field Name: NRDSID__c
        * * Display Name: Nrdsid C
        * * SQL Data Type: nvarchar(500)`),
    IsRetired__c: z.boolean().nullable().describe(`
        * * Field Name: IsRetired__c
        * * Display Name: Is Retired C
        * * SQL Data Type: bit`),
    TerminationDate__c: z.date().nullable().describe(`
        * * Field Name: TerminationDate__c
        * * Display Name: Termination Date C
        * * SQL Data Type: date`),
    LastDuesPaymentDate__c: z.date().nullable().describe(`
        * * Field Name: LastDuesPaymentDate__c
        * * Display Name: Last Dues Payment Date C
        * * SQL Data Type: date`),
    OriginalJoinDate__c: z.date().nullable().describe(`
        * * Field Name: OriginalJoinDate__c
        * * Display Name: Original Join Date C
        * * SQL Data Type: date`),
    DoNotCall__c: z.boolean().nullable().describe(`
        * * Field Name: DoNotCall__c
        * * Display Name: Do Not Call C
        * * SQL Data Type: bit`),
    WhyCreatingAccount_Other__c: z.string().nullable().describe(`
        * * Field Name: WhyCreatingAccount_Other__c
        * * Display Name: Why Creating Account Other C
        * * SQL Data Type: nvarchar(500)`),
    SchoolAttending__c: z.string().nullable().describe(`
        * * Field Name: SchoolAttending__c
        * * Display Name: School Attending C
        * * SQL Data Type: nvarchar(500)`),
    AnticipatedGradDate__c: z.date().nullable().describe(`
        * * Field Name: AnticipatedGradDate__c
        * * Display Name: Anticipated Grad Date C
        * * SQL Data Type: date`),
    Major__c: z.string().nullable().describe(`
        * * Field Name: Major__c
        * * Display Name: Major C
        * * SQL Data Type: nvarchar(500)`),
    Placeholder_DoNOTDelete__c: z.string().nullable().describe(`
        * * Field Name: Placeholder_DoNOTDelete__c
        * * Display Name: Placeholder Do NOT Delete C
        * * SQL Data Type: nvarchar(500)`),
    AreasofPractice__c: z.string().nullable().describe(`
        * * Field Name: AreasofPractice__c
        * * Display Name: Areasof Practice C
        * * SQL Data Type: nvarchar(500)`),
    SIOR_Dues_Paid_Through__c: z.date().nullable().describe(`
        * * Field Name: SIOR_Dues_Paid_Through__c
        * * Display Name: Sior Dues Paid Through C
        * * SQL Data Type: date`),
    SIORFunctionRole__c: z.string().nullable().describe(`
        * * Field Name: SIORFunctionRole__c
        * * Display Name: SIOR Function Role C
        * * SQL Data Type: nvarchar(500)`),
    SIOR_Join_Date__c: z.date().nullable().describe(`
        * * Field Name: SIOR_Join_Date__c
        * * Display Name: Sior Join Date C
        * * SQL Data Type: date`),
    Home_Address: z.string().nullable().describe(`
        * * Field Name: Home_Address
        * * Display Name: Home Address
        * * SQL Data Type: nvarchar(500)`),
    Work_Address: z.string().nullable().describe(`
        * * Field Name: Work_Address
        * * Display Name: Work Address
        * * SQL Data Type: nvarchar(500)`),
    Mobile_PhoneNumber: z.string().nullable().describe(`
        * * Field Name: Mobile_PhoneNumber
        * * Display Name: Mobile Phone Number
        * * SQL Data Type: nvarchar(64)`),
    Work_PhoneNumber: z.string().nullable().describe(`
        * * Field Name: Work_PhoneNumber
        * * Display Name: Work Phone Number
        * * SQL Data Type: nvarchar(64)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company_Virtual: z.string().describe(`
        * * Field Name: Company_Virtual
        * * Display Name: Company Virtual
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteIndividualEntityType = z.infer<typeof membersuiteIndividualSchema>;

/**
 * zod schema definition for the entity MemberSuite: Invoice Line Items
 */
export const membersuiteInvoiceLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    invoiceLineItemID: z.string().describe(`
        * * Field Name: invoiceLineItemID
        * * Display Name: invoice Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    orderLineItemID: z.string().nullable().describe(`
        * * Field Name: orderLineItemID
        * * Display Name: order Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    isVoid: z.boolean().nullable().describe(`
        * * Field Name: isVoid
        * * Display Name: is Void
        * * SQL Data Type: bit`),
    originalTotal: z.number().nullable().describe(`
        * * Field Name: originalTotal
        * * Display Name: original Total
        * * SQL Data Type: decimal(19, 4)`),
    arglAccount: z.string().nullable().describe(`
        * * Field Name: arglAccount
        * * Display Name: argl Account
        * * SQL Data Type: nvarchar(500)`),
    accountingProject: z.string().nullable().describe(`
        * * Field Name: accountingProject
        * * Display Name: accounting Project
        * * SQL Data Type: nvarchar(500)`),
    revenueGLAccount: z.string().nullable().describe(`
        * * Field Name: revenueGLAccount
        * * Display Name: revenue GL Account
        * * SQL Data Type: nvarchar(500)`),
    hasBeenCOGSRecognized: z.boolean().nullable().describe(`
        * * Field Name: hasBeenCOGSRecognized
        * * Display Name: has Been COGS Recognized
        * * SQL Data Type: bit`),
    billingScheduleEntryID: z.string().nullable().describe(`
        * * Field Name: billingScheduleEntryID
        * * Display Name: billing Schedule Entry ID
        * * SQL Data Type: nvarchar(500)`),
    optional: z.boolean().nullable().describe(`
        * * Field Name: optional
        * * Display Name: optional
        * * SQL Data Type: bit`),
    revenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: revenueRecognitionTemplate
        * * Display Name: revenue Recognition Template
        * * SQL Data Type: nvarchar(500)`),
    amountPaid: z.number().nullable().describe(`
        * * Field Name: amountPaid
        * * Display Name: amount Paid
        * * SQL Data Type: decimal(19, 4)`),
    balanceDue: z.number().nullable().describe(`
        * * Field Name: balanceDue
        * * Display Name: balance Due
        * * SQL Data Type: decimal(19, 4)`),
    amountWrittenOff: z.number().nullable().describe(`
        * * Field Name: amountWrittenOff
        * * Display Name: amount Written Off
        * * SQL Data Type: decimal(19, 4)`),
    amountRefunded: z.number().nullable().describe(`
        * * Field Name: amountRefunded
        * * Display Name: amount Refunded
        * * SQL Data Type: decimal(19, 4)`),
    lateFeeRule: z.string().nullable().describe(`
        * * Field Name: lateFeeRule
        * * Display Name: late Fee Rule
        * * SQL Data Type: nvarchar(500)`),
    amountToPayUponCreation: z.number().nullable().describe(`
        * * Field Name: amountToPayUponCreation
        * * Display Name: amount To Pay Upon Creation
        * * SQL Data Type: decimal(19, 4)`),
    billingMaster: z.boolean().nullable().describe(`
        * * Field Name: billingMaster
        * * Display Name: billing Master
        * * SQL Data Type: bit`),
    product: z.string().nullable().describe(`
        * * Field Name: product
        * * Display Name: product
        * * SQL Data Type: nvarchar(500)`),
    quantity: z.number().nullable().describe(`
        * * Field Name: quantity
        * * Display Name: quantity
        * * SQL Data Type: bigint`),
    unitPrice: z.number().nullable().describe(`
        * * Field Name: unitPrice
        * * Display Name: unit Price
        * * SQL Data Type: decimal(19, 4)`),
    description: z.string().nullable().describe(`
        * * Field Name: description
        * * Display Name: description
        * * SQL Data Type: nvarchar(500)`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    Invoice: z.string().nullable().describe(`
        * * Field Name: Invoice
        * * Display Name: Invoice
        * * SQL Data Type: uniqueidentifier`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteInvoiceLineItemEntityType = z.infer<typeof membersuiteInvoiceLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Invoices
 */
export const membersuiteInvoiceSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    IsVoid: z.boolean().nullable().describe(`
        * * Field Name: IsVoid
        * * Display Name: Is Void
        * * SQL Data Type: bit`),
    BillTo: z.string().nullable().describe(`
        * * Field Name: BillTo
        * * Display Name: Bill To
        * * SQL Data Type: uniqueidentifier`),
    ConvertedFromProForma: z.date().nullable().describe(`
        * * Field Name: ConvertedFromProForma
        * * Display Name: Converted From Pro Forma
        * * SQL Data Type: date`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    DueDate: z.date().nullable().describe(`
        * * Field Name: DueDate
        * * Display Name: Due Date
        * * SQL Data Type: date`),
    BillingAddress: z.string().nullable().describe(`
        * * Field Name: BillingAddress
        * * Display Name: Billing Address
        * * SQL Data Type: nvarchar(500)`),
    Terms: z.string().nullable().describe(`
        * * Field Name: Terms
        * * Display Name: Terms
        * * SQL Data Type: uniqueidentifier`),
    PurchaseOrderNumber: z.string().nullable().describe(`
        * * Field Name: PurchaseOrderNumber
        * * Display Name: Purchase Order Number
        * * SQL Data Type: nvarchar(500)`),
    CustomerMessage: z.string().nullable().describe(`
        * * Field Name: CustomerMessage
        * * Display Name: Customer Message
        * * SQL Data Type: nvarchar(MAX)`),
    BalanceDue: z.number().nullable().describe(`
        * * Field Name: BalanceDue
        * * Display Name: Balance Due
        * * SQL Data Type: decimal(19, 4)`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: uniqueidentifier`),
    AmountPaid: z.number().nullable().describe(`
        * * Field Name: AmountPaid
        * * Display Name: Amount Paid
        * * SQL Data Type: decimal(19, 4)`),
    AmountWrittenOff: z.number().nullable().describe(`
        * * Field Name: AmountWrittenOff
        * * Display Name: Amount Written Off
        * * SQL Data Type: decimal(19, 4)`),
    AmountRefunded: z.number().nullable().describe(`
        * * Field Name: AmountRefunded
        * * Display Name: Amount Refunded
        * * SQL Data Type: decimal(19, 4)`),
    ProForma: z.boolean().nullable().describe(`
        * * Field Name: ProForma
        * * Display Name: Pro Forma
        * * SQL Data Type: bit`),
    InsertionOrder: z.string().nullable().describe(`
        * * Field Name: InsertionOrder
        * * Display Name: Insertion Order
        * * SQL Data Type: uniqueidentifier`),
    ExchangeRate: z.number().nullable().describe(`
        * * Field Name: ExchangeRate
        * * Display Name: Exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    HideInPortal: z.boolean().nullable().describe(`
        * * Field Name: HideInPortal
        * * Display Name: Hide In Portal
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteInvoiceEntityType = z.infer<typeof membersuiteInvoiceSchema>;

/**
 * zod schema definition for the entity MemberSuite: Late Fee Products
 */
export const membersuiteLateFeeProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteLateFeeProductEntityType = z.infer<typeof membersuiteLateFeeProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Legacy Products
 */
export const membersuiteLegacyProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteLegacyProductEntityType = z.infer<typeof membersuiteLegacyProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Membership Dues Products
 */
export const membersuiteMembershipDuesProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    InitialStatus: z.string().nullable().describe(`
        * * Field Name: InitialStatus
        * * Display Name: Initial Status
        * * SQL Data Type: uniqueidentifier`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    DropStatus: z.string().nullable().describe(`
        * * Field Name: DropStatus
        * * Display Name: Drop Status
        * * SQL Data Type: uniqueidentifier`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    ExpirationType: z.string().nullable().describe(`
        * * Field Name: ExpirationType
        * * Display Name: Expiration Type
        * * SQL Data Type: nvarchar(100)`),
    Availability: z.string().nullable().describe(`
        * * Field Name: Availability
        * * Display Name: Availability
        * * SQL Data Type: nvarchar(100)`),
    StartDate: z.date().nullable().describe(`
        * * Field Name: StartDate
        * * Display Name: Start Date
        * * SQL Data Type: date`),
    SellForNextYearAfter: z.date().nullable().describe(`
        * * Field Name: SellForNextYearAfter
        * * Display Name: Sell For Next Year After
        * * SQL Data Type: date`),
    SetDatesBasedOnPaymentDate: z.boolean().nullable().describe(`
        * * Field Name: SetDatesBasedOnPaymentDate
        * * Display Name: Set Dates Based On Payment Date
        * * SQL Data Type: bit`),
    SellForNextMonthAfterDay: z.number().nullable().describe(`
        * * Field Name: SellForNextMonthAfterDay
        * * Display Name: Sell For Next Month After Day
        * * SQL Data Type: bigint`),
    StartDay: z.number().nullable().describe(`
        * * Field Name: StartDay
        * * Display Name: Start Day
        * * SQL Data Type: bigint`),
    AllowMidMonthExpirations: z.boolean().nullable().describe(`
        * * Field Name: AllowMidMonthExpirations
        * * Display Name: Allow Mid Month Expirations
        * * SQL Data Type: bit`),
    TermLength: z.number().nullable().describe(`
        * * Field Name: TermLength
        * * Display Name: Term Length
        * * SQL Data Type: bigint`),
    TermType: z.string().nullable().describe(`
        * * Field Name: TermType
        * * Display Name: Term Type
        * * SQL Data Type: nvarchar(100)`),
    UpdateDatesWhen: z.string().nullable().describe(`
        * * Field Name: UpdateDatesWhen
        * * Display Name: Update Dates When
        * * SQL Data Type: nvarchar(100)`),
    RequiresApproval: z.boolean().nullable().describe(`
        * * Field Name: RequiresApproval
        * * Display Name: Requires Approval
        * * SQL Data Type: bit`),
    RenewalTerms: z.string().nullable().describe(`
        * * Field Name: RenewalTerms
        * * Display Name: Renewal Terms
        * * SQL Data Type: uniqueidentifier`),
    ProFormaRenewalInvoices: z.boolean().nullable().describe(`
        * * Field Name: ProFormaRenewalInvoices
        * * Display Name: Pro Forma Renewal Invoices
        * * SQL Data Type: bit`),
    GracePeriod: z.number().nullable().describe(`
        * * Field Name: GracePeriod
        * * Display Name: Grace Period
        * * SQL Data Type: bigint`),
    BillPrimaryOrganization: z.boolean().nullable().describe(`
        * * Field Name: BillPrimaryOrganization
        * * Display Name: Bill Primary Organization
        * * SQL Data Type: bit`),
    ReinstatementPeriod: z.number().nullable().describe(`
        * * Field Name: ReinstatementPeriod
        * * Display Name: Reinstatement Period
        * * SQL Data Type: bigint`),
    ReceivesMemberBenefits: z.boolean().nullable().describe(`
        * * Field Name: ReceivesMemberBenefits
        * * Display Name: Receives Member Benefits
        * * SQL Data Type: bit`),
    MembershipType: z.string().nullable().describe(`
        * * Field Name: MembershipType
        * * Display Name: Membership Type
        * * SQL Data Type: uniqueidentifier`),
    RenewsWith: z.string().nullable().describe(`
        * * Field Name: RenewsWith
        * * Display Name: Renews With
        * * SQL Data Type: uniqueidentifier`),
    InitialBillingEmail: z.string().nullable().describe(`
        * * Field Name: InitialBillingEmail
        * * Display Name: Initial Billing Email
        * * SQL Data Type: uniqueidentifier`),
    FirstReminderEmail: z.string().nullable().describe(`
        * * Field Name: FirstReminderEmail
        * * Display Name: First Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    SecondReminderEmail: z.string().nullable().describe(`
        * * Field Name: SecondReminderEmail
        * * Display Name: Second Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    ThirdReminderEmail: z.string().nullable().describe(`
        * * Field Name: ThirdReminderEmail
        * * Display Name: Third Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    DropEmail: z.string().nullable().describe(`
        * * Field Name: DropEmail
        * * Display Name: Drop Email
        * * SQL Data Type: uniqueidentifier`),
    InvoicePercentage: z.number().nullable().describe(`
        * * Field Name: InvoicePercentage
        * * Display Name: Invoice Percentage
        * * SQL Data Type: decimal(19, 4)`),
    InvoiceType: z.string().nullable().describe(`
        * * Field Name: InvoiceType
        * * Display Name: Invoice Type
        * * SQL Data Type: uniqueidentifier`),
    AutoRenew: z.boolean().nullable().describe(`
        * * Field Name: AutoRenew
        * * Display Name: Auto Renew
        * * SQL Data Type: bit`),
    ResumeMode: z.string().nullable().describe(`
        * * Field Name: ResumeMode
        * * Display Name: Resume Mode
        * * SQL Data Type: nvarchar(100)`),
    ChapterMode: z.string().nullable().describe(`
        * * Field Name: ChapterMode
        * * Display Name: Chapter Mode
        * * SQL Data Type: nvarchar(100)`),
    ChapterPostalCodeMappingMode: z.string().nullable().describe(`
        * * Field Name: ChapterPostalCodeMappingMode
        * * Display Name: Chapter Postal Code Mapping Mode
        * * SQL Data Type: nvarchar(100)`),
    SectionMode: z.string().nullable().describe(`
        * * Field Name: SectionMode
        * * Display Name: Section Mode
        * * SQL Data Type: nvarchar(100)`),
    AutomaticallyUpdateChapter: z.boolean().nullable().describe(`
        * * Field Name: AutomaticallyUpdateChapter
        * * Display Name: Automatically Update Chapter
        * * SQL Data Type: bit`),
    MembershipOrganization: z.string().nullable().describe(`
        * * Field Name: MembershipOrganization
        * * Display Name: Membership Organization
        * * SQL Data Type: uniqueidentifier`),
    UseFreshJoinDateForReinstatedMembers: z.boolean().nullable().describe(`
        * * Field Name: UseFreshJoinDateForReinstatedMembers
        * * Display Name: Use Fresh Join Date For Reinstated Members
        * * SQL Data Type: bit`),
    GiveRenewalPricingDuringReinstatementPeriod: z.boolean().nullable().describe(`
        * * Field Name: GiveRenewalPricingDuringReinstatementPeriod
        * * Display Name: Give Renewal Pricing During Reinstatement Period
        * * SQL Data Type: bit`),
    UseCurrentDateAsBasisForExpirationOfReinstatedMembership: z.boolean().nullable().describe(`
        * * Field Name: UseCurrentDateAsBasisForExpirationOfReinstatedMembership
        * * Display Name: Use Current Date As Basis For Expiration Of Reinstated Membership
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    WasLocalIDGenerated: z.boolean().nullable().describe(`
        * * Field Name: WasLocalIDGenerated
        * * Display Name: Was Local ID Generated
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteMembershipDuesProductEntityType = z.infer<typeof membersuiteMembershipDuesProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Merchandises
 */
export const membersuiteMerchandiseSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    ShortDescription: z.number().nullable().describe(`
        * * Field Name: ShortDescription
        * * Display Name: Short Description
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteMerchandiseEntityType = z.infer<typeof membersuiteMerchandiseSchema>;

/**
 * zod schema definition for the entity MemberSuite: Miscellaneous Products
 */
export const membersuiteMiscellaneousProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteMiscellaneousProductEntityType = z.infer<typeof membersuiteMiscellaneousProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Order Line Items
 */
export const membersuiteOrderLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    quantityShipped: z.number().nullable().describe(`
        * * Field Name: quantityShipped
        * * Display Name: quantity Shipped
        * * SQL Data Type: bigint`),
    quantityCancelled: z.number().nullable().describe(`
        * * Field Name: quantityCancelled
        * * Display Name: quantity Cancelled
        * * SQL Data Type: bigint`),
    quantityPendingReturn: z.number().nullable().describe(`
        * * Field Name: quantityPendingReturn
        * * Display Name: quantity Pending Return
        * * SQL Data Type: bigint`),
    quantityReturned: z.number().nullable().describe(`
        * * Field Name: quantityReturned
        * * Display Name: quantity Returned
        * * SQL Data Type: bigint`),
    weight: z.number().nullable().describe(`
        * * Field Name: weight
        * * Display Name: weight
        * * SQL Data Type: decimal(19, 4)`),
    optional: z.boolean().nullable().describe(`
        * * Field Name: optional
        * * Display Name: optional
        * * SQL Data Type: bit`),
    warehouse: z.string().nullable().describe(`
        * * Field Name: warehouse
        * * Display Name: warehouse
        * * SQL Data Type: nvarchar(500)`),
    lateFeeRule: z.string().nullable().describe(`
        * * Field Name: lateFeeRule
        * * Display Name: late Fee Rule
        * * SQL Data Type: nvarchar(500)`),
    overrideMemberPricingTo: z.string().nullable().describe(`
        * * Field Name: overrideMemberPricingTo
        * * Display Name: override Member Pricing To
        * * SQL Data Type: nvarchar(500)`),
    productLinkageID: z.string().nullable().describe(`
        * * Field Name: productLinkageID
        * * Display Name: product Linkage ID
        * * SQL Data Type: nvarchar(500)`),
    type: z.number().nullable().describe(`
        * * Field Name: type
        * * Display Name: type
        * * SQL Data Type: bigint`),
    priceOverride: z.boolean().nullable().describe(`
        * * Field Name: priceOverride
        * * Display Name: price Override
        * * SQL Data Type: bit`),
    overrideReason: z.string().nullable().describe(`
        * * Field Name: overrideReason
        * * Display Name: override Reason
        * * SQL Data Type: nvarchar(500)`),
    overrideShipTo: z.string().nullable().describe(`
        * * Field Name: overrideShipTo
        * * Display Name: override Ship To
        * * SQL Data Type: nvarchar(500)`),
    overrideShipToAddressType: z.string().nullable().describe(`
        * * Field Name: overrideShipToAddressType
        * * Display Name: override Ship To Address Type
        * * SQL Data Type: nvarchar(500)`),
    status: z.number().nullable().describe(`
        * * Field Name: status
        * * Display Name: status
        * * SQL Data Type: bigint`),
    billingTemplate: z.string().nullable().describe(`
        * * Field Name: billingTemplate
        * * Display Name: billing Template
        * * SQL Data Type: nvarchar(500)`),
    revenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: revenueRecognitionTemplate
        * * Display Name: revenue Recognition Template
        * * SQL Data Type: nvarchar(500)`),
    fulfillmentDate: z.date().nullable().describe(`
        * * Field Name: fulfillmentDate
        * * Display Name: fulfillment Date
        * * SQL Data Type: datetime2`),
    wasGeneratedAutomatically: z.boolean().nullable().describe(`
        * * Field Name: wasGeneratedAutomatically
        * * Display Name: was Generated Automatically
        * * SQL Data Type: bit`),
    orderLineItemID: z.string().describe(`
        * * Field Name: orderLineItemID
        * * Display Name: order Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    linkedOrderLineItemID: z.string().nullable().describe(`
        * * Field Name: linkedOrderLineItemID
        * * Display Name: linked Order Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    amountPaid: z.number().nullable().describe(`
        * * Field Name: amountPaid
        * * Display Name: amount Paid
        * * SQL Data Type: decimal(19, 4)`),
    amountPendingCapture: z.number().nullable().describe(`
        * * Field Name: amountPendingCapture
        * * Display Name: amount Pending Capture
        * * SQL Data Type: decimal(19, 4)`),
    amountRefunded: z.number().nullable().describe(`
        * * Field Name: amountRefunded
        * * Display Name: amount Refunded
        * * SQL Data Type: decimal(19, 4)`),
    balanceDue: z.number().nullable().describe(`
        * * Field Name: balanceDue
        * * Display Name: balance Due
        * * SQL Data Type: decimal(19, 4)`),
    discounts: z.number().nullable().describe(`
        * * Field Name: discounts
        * * Display Name: discounts
        * * SQL Data Type: decimal(19, 4)`),
    umbrellaProduct: z.string().nullable().describe(`
        * * Field Name: umbrellaProduct
        * * Display Name: umbrella Product
        * * SQL Data Type: nvarchar(500)`),
    skipLineItemProcessing: z.boolean().nullable().describe(`
        * * Field Name: skipLineItemProcessing
        * * Display Name: skip Line Item Processing
        * * SQL Data Type: bit`),
    billingRunTargetRecordID: z.string().nullable().describe(`
        * * Field Name: billingRunTargetRecordID
        * * Display Name: billing Run Target Record ID
        * * SQL Data Type: nvarchar(500)`),
    tieredRegistrationPricingRule: z.string().nullable().describe(`
        * * Field Name: tieredRegistrationPricingRule
        * * Display Name: tiered Registration Pricing Rule
        * * SQL Data Type: nvarchar(500)`),
    parentOrderLineItemID: z.string().nullable().describe(`
        * * Field Name: parentOrderLineItemID
        * * Display Name: parent Order Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    product: z.string().nullable().describe(`
        * * Field Name: product
        * * Display Name: product
        * * SQL Data Type: nvarchar(500)`),
    quantity: z.number().nullable().describe(`
        * * Field Name: quantity
        * * Display Name: quantity
        * * SQL Data Type: bigint`),
    unitPrice: z.number().nullable().describe(`
        * * Field Name: unitPrice
        * * Display Name: unit Price
        * * SQL Data Type: decimal(19, 4)`),
    description: z.string().nullable().describe(`
        * * Field Name: description
        * * Display Name: description
        * * SQL Data Type: nvarchar(500)`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteOrderLineItemEntityType = z.infer<typeof membersuiteOrderLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Orders
 */
export const membersuiteOrderSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    AmountDueNow: z.number().nullable().describe(`
        * * Field Name: AmountDueNow
        * * Display Name: Amount Due Now
        * * SQL Data Type: decimal(19, 4)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    HasGeneratedCEUCredits: z.boolean().nullable().describe(`
        * * Field Name: HasGeneratedCEUCredits
        * * Display Name: Has Generated CEU Credits
        * * SQL Data Type: bit`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    TrackingNumber: z.string().nullable().describe(`
        * * Field Name: TrackingNumber
        * * Display Name: Tracking Number
        * * SQL Data Type: nvarchar(500)`),
    ShipDate: z.date().nullable().describe(`
        * * Field Name: ShipDate
        * * Display Name: Ship Date
        * * SQL Data Type: date`),
    CustomerNotes: z.string().nullable().describe(`
        * * Field Name: CustomerNotes
        * * Display Name: Customer Notes
        * * SQL Data Type: nvarchar(MAX)`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    Warehouse: z.string().nullable().describe(`
        * * Field Name: Warehouse
        * * Display Name: Warehouse
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    ShipTo: z.string().nullable().describe(`
        * * Field Name: ShipTo
        * * Display Name: Ship To
        * * SQL Data Type: uniqueidentifier`),
    BillTo: z.string().nullable().describe(`
        * * Field Name: BillTo
        * * Display Name: Bill To
        * * SQL Data Type: uniqueidentifier`),
    PaymentMethod: z.string().nullable().describe(`
        * * Field Name: PaymentMethod
        * * Display Name: Payment Method
        * * SQL Data Type: nvarchar(100)`),
    PaymentReferenceNumber: z.string().nullable().describe(`
        * * Field Name: PaymentReferenceNumber
        * * Display Name: Payment Reference Number
        * * SQL Data Type: nvarchar(500)`),
    HasBeenQueued: z.boolean().nullable().describe(`
        * * Field Name: HasBeenQueued
        * * Display Name: Has Been Queued
        * * SQL Data Type: bit`),
    ProcessingStartTime: z.date().nullable().describe(`
        * * Field Name: ProcessingStartTime
        * * Display Name: Processing Start Time
        * * SQL Data Type: datetime2`),
    ProcessingEndTime: z.date().nullable().describe(`
        * * Field Name: ProcessingEndTime
        * * Display Name: Processing End Time
        * * SQL Data Type: datetime2`),
    ProcessingDuration: z.number().nullable().describe(`
        * * Field Name: ProcessingDuration
        * * Display Name: Processing Duration
        * * SQL Data Type: bigint`),
    BalanceDue: z.number().nullable().describe(`
        * * Field Name: BalanceDue
        * * Display Name: Balance Due
        * * SQL Data Type: decimal(19, 4)`),
    AmountPaid: z.number().nullable().describe(`
        * * Field Name: AmountPaid
        * * Display Name: Amount Paid
        * * SQL Data Type: decimal(19, 4)`),
    AmountPendingCapture: z.number().nullable().describe(`
        * * Field Name: AmountPendingCapture
        * * Display Name: Amount Pending Capture
        * * SQL Data Type: decimal(19, 4)`),
    AmountRefunded: z.number().nullable().describe(`
        * * Field Name: AmountRefunded
        * * Display Name: Amount Refunded
        * * SQL Data Type: decimal(19, 4)`),
    PreProcessingIdentifier: z.string().nullable().describe(`
        * * Field Name: PreProcessingIdentifier
        * * Display Name: Pre Processing Identifier
        * * SQL Data Type: nvarchar(500)`),
    PreProcessingHash: z.string().nullable().describe(`
        * * Field Name: PreProcessingHash
        * * Display Name: Pre Processing Hash
        * * SQL Data Type: nvarchar(500)`),
    CashAccount: z.string().nullable().describe(`
        * * Field Name: CashAccount
        * * Display Name: Cash Account
        * * SQL Data Type: uniqueidentifier`),
    CreditCardNumber: z.string().nullable().describe(`
        * * Field Name: CreditCardNumber
        * * Display Name: Credit Card Number
        * * SQL Data Type: nvarchar(500)`),
    ACHAccountNumber: z.string().nullable().describe(`
        * * Field Name: ACHAccountNumber
        * * Display Name: ACH Account Number
        * * SQL Data Type: nvarchar(500)`),
    ACHRoutingNumber: z.string().nullable().describe(`
        * * Field Name: ACHRoutingNumber
        * * Display Name: ACH Routing Number
        * * SQL Data Type: nvarchar(500)`),
    WebSECCode: z.string().nullable().describe(`
        * * Field Name: WebSECCode
        * * Display Name: Web SEC Code
        * * SQL Data Type: nvarchar(100)`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    CreditCardExpirationDate: z.date().nullable().describe(`
        * * Field Name: CreditCardExpirationDate
        * * Display Name: Credit Card Expiration Date
        * * SQL Data Type: date`),
    CreditCardAuthorizationID: z.string().nullable().describe(`
        * * Field Name: CreditCardAuthorizationID
        * * Display Name: Credit Card Authorization ID
        * * SQL Data Type: nvarchar(500)`),
    CreditCardType: z.string().nullable().describe(`
        * * Field Name: CreditCardType
        * * Display Name: Credit Card Type
        * * SQL Data Type: nvarchar(100)`),
    ProcessOrderEvenIfPaymentFails: z.boolean().nullable().describe(`
        * * Field Name: ProcessOrderEvenIfPaymentFails
        * * Display Name: Process Order Even If Payment Fails
        * * SQL Data Type: bit`),
    CCVCode: z.string().nullable().describe(`
        * * Field Name: CCVCode
        * * Display Name: CCV Code
        * * SQL Data Type: nvarchar(500)`),
    IgnoreMissingDemographics: z.boolean().nullable().describe(`
        * * Field Name: IgnoreMissingDemographics
        * * Display Name: Ignore Missing Demographics
        * * SQL Data Type: bit`),
    ShippingAddress: z.string().nullable().describe(`
        * * Field Name: ShippingAddress
        * * Display Name: Shipping Address
        * * SQL Data Type: nvarchar(500)`),
    BillingAddress: z.string().nullable().describe(`
        * * Field Name: BillingAddress
        * * Display Name: Billing Address
        * * SQL Data Type: nvarchar(500)`),
    BillingEmailAddress: z.string().nullable().describe(`
        * * Field Name: BillingEmailAddress
        * * Display Name: Billing Email Address
        * * SQL Data Type: nvarchar(500)`),
    Status: z.string().nullable().describe(`
        * * Field Name: Status
        * * Display Name: Status
        * * SQL Data Type: nvarchar(100)`),
    Discounts: z.number().nullable().describe(`
        * * Field Name: Discounts
        * * Display Name: Discounts
        * * SQL Data Type: decimal(19, 4)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    InvoiceType: z.string().nullable().describe(`
        * * Field Name: InvoiceType
        * * Display Name: Invoice Type
        * * SQL Data Type: uniqueidentifier`),
    IsCreditCardEncrypted: z.boolean().nullable().describe(`
        * * Field Name: IsCreditCardEncrypted
        * * Display Name: Is Credit Card Encrypted
        * * SQL Data Type: bit`),
    ShippingOverride: z.boolean().nullable().describe(`
        * * Field Name: ShippingOverride
        * * Display Name: Shipping Override
        * * SQL Data Type: bit`),
    TaxOverride: z.boolean().nullable().describe(`
        * * Field Name: TaxOverride
        * * Display Name: Tax Override
        * * SQL Data Type: bit`),
    BillingRunActivityID: z.string().nullable().describe(`
        * * Field Name: BillingRunActivityID
        * * Display Name: Billing Run Activity ID
        * * SQL Data Type: nvarchar(500)`),
    UseProFormaInvoices: z.boolean().nullable().describe(`
        * * Field Name: UseProFormaInvoices
        * * Display Name: Use Pro Forma Invoices
        * * SQL Data Type: bit`),
    InvoiceTerms: z.string().nullable().describe(`
        * * Field Name: InvoiceTerms
        * * Display Name: Invoice Terms
        * * SQL Data Type: uniqueidentifier`),
    SuppressConfirmationEmails: z.boolean().nullable().describe(`
        * * Field Name: SuppressConfirmationEmails
        * * Display Name: Suppress Confirmation Emails
        * * SQL Data Type: bit`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    PurchaseOrderNumber: z.string().nullable().describe(`
        * * Field Name: PurchaseOrderNumber
        * * Display Name: Purchase Order Number
        * * SQL Data Type: nvarchar(500)`),
    ShippingMethod: z.string().nullable().describe(`
        * * Field Name: ShippingMethod
        * * Display Name: Shipping Method
        * * SQL Data Type: uniqueidentifier`),
    SavePaymentMethod: z.boolean().nullable().describe(`
        * * Field Name: SavePaymentMethod
        * * Display Name: Save Payment Method
        * * SQL Data Type: bit`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    SavedPaymentMethod: z.string().nullable().describe(`
        * * Field Name: SavedPaymentMethod
        * * Display Name: Saved Payment Method
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    HideInPortal: z.boolean().nullable().describe(`
        * * Field Name: HideInPortal
        * * Display Name: Hide In Portal
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteOrderEntityType = z.infer<typeof membersuiteOrderSchema>;

/**
 * zod schema definition for the entity MemberSuite: Organizations
 */
export const membersuiteOrganizationSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    SortName: z.string().nullable().describe(`
        * * Field Name: SortName
        * * Display Name: Sort Name
        * * SQL Data Type: nvarchar(500)`),
    BillingContactName: z.string().nullable().describe(`
        * * Field Name: BillingContactName
        * * Display Name: Billing Contact Name
        * * SQL Data Type: nvarchar(500)`),
    FirstName: z.string().nullable().describe(`
        * * Field Name: FirstName
        * * Display Name: First Name
        * * SQL Data Type: nvarchar(500)`),
    LastName: z.string().nullable().describe(`
        * * Field Name: LastName
        * * Display Name: Last Name
        * * SQL Data Type: nvarchar(500)`),
    PaymentGatewayID: z.string().nullable().describe(`
        * * Field Name: PaymentGatewayID
        * * Display Name: Payment Gateway ID
        * * SQL Data Type: nvarchar(500)`),
    Status: z.string().nullable().describe(`
        * * Field Name: Status
        * * Display Name: Status
        * * SQL Data Type: uniqueidentifier`),
    IneligibleFunds: z.string().nullable().describe(`
        * * Field Name: IneligibleFunds
        * * Display Name: Ineligible Funds
        * * SQL Data Type: uniqueidentifier`),
    TaxExempt: z.boolean().nullable().describe(`
        * * Field Name: TaxExempt
        * * Display Name: Tax Exempt
        * * SQL Data Type: bit`),
    DefaultCreditTerms: z.string().nullable().describe(`
        * * Field Name: DefaultCreditTerms
        * * Display Name: Default Credit Terms
        * * SQL Data Type: uniqueidentifier`),
    PreferredAddressType: z.string().nullable().describe(`
        * * Field Name: PreferredAddressType
        * * Display Name: Preferred Address Type
        * * SQL Data Type: uniqueidentifier`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: uniqueidentifier`),
    DonorLevel: z.string().nullable().describe(`
        * * Field Name: DonorLevel
        * * Display Name: Donor Level
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    WebSite: z.string().nullable().describe(`
        * * Field Name: WebSite
        * * Display Name: Web Site
        * * SQL Data Type: nvarchar(512)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    NRDSID: z.number().nullable().describe(`
        * * Field Name: NRDSID
        * * Display Name: Nrdsid
        * * SQL Data Type: bigint`),
    FacebookProfile: z.string().nullable().describe(`
        * * Field Name: FacebookProfile
        * * Display Name: Facebook Profile
        * * SQL Data Type: nvarchar(500)`),
    FacebookId: z.string().nullable().describe(`
        * * Field Name: FacebookId
        * * Display Name: Facebook Id
        * * SQL Data Type: nvarchar(500)`),
    TwitterHandle: z.string().nullable().describe(`
        * * Field Name: TwitterHandle
        * * Display Name: Twitter Handle
        * * SQL Data Type: nvarchar(500)`),
    TwitterId: z.string().nullable().describe(`
        * * Field Name: TwitterId
        * * Display Name: Twitter Id
        * * SQL Data Type: nvarchar(500)`),
    LinkedInProfile: z.string().nullable().describe(`
        * * Field Name: LinkedInProfile
        * * Display Name: Linked In Profile
        * * SQL Data Type: nvarchar(500)`),
    LinkedInId: z.string().nullable().describe(`
        * * Field Name: LinkedInId
        * * Display Name: Linked In Id
        * * SQL Data Type: nvarchar(500)`),
    GooglePlusUrl: z.string().nullable().describe(`
        * * Field Name: GooglePlusUrl
        * * Display Name: Google Plus Url
        * * SQL Data Type: nvarchar(500)`),
    GooglePlusId: z.string().nullable().describe(`
        * * Field Name: GooglePlusId
        * * Display Name: Google Plus Id
        * * SQL Data Type: nvarchar(500)`),
    InstagramProfile: z.string().nullable().describe(`
        * * Field Name: InstagramProfile
        * * Display Name: Instagram Profile
        * * SQL Data Type: nvarchar(500)`),
    InstagramId: z.string().nullable().describe(`
        * * Field Name: InstagramId
        * * Display Name: Instagram Id
        * * SQL Data Type: nvarchar(500)`),
    BillingContactPhoneNumber: z.string().nullable().describe(`
        * * Field Name: BillingContactPhoneNumber
        * * Display Name: Billing Contact Phone Number
        * * SQL Data Type: nvarchar(500)`),
    EmailAddress: z.string().nullable().describe(`
        * * Field Name: EmailAddress
        * * Display Name: Email Address
        * * SQL Data Type: nvarchar(256)`),
    JobPostingsAvailable: z.number().nullable().describe(`
        * * Field Name: JobPostingsAvailable
        * * Display Name: Job Postings Available
        * * SQL Data Type: bigint`),
    ResumeAccessUntil: z.date().nullable().describe(`
        * * Field Name: ResumeAccessUntil
        * * Display Name: Resume Access Until
        * * SQL Data Type: datetime2`),
    PreferredPhoneNumberType: z.string().nullable().describe(`
        * * Field Name: PreferredPhoneNumberType
        * * Display Name: Preferred Phone Number Type
        * * SQL Data Type: uniqueidentifier`),
    ChFin_TotalRevenue__c: z.string().nullable().describe(`
        * * Field Name: ChFin_TotalRevenue__c
        * * Display Name: Ch Fin Total Revenue C
        * * SQL Data Type: nvarchar(500)`),
    ChFin_TotalExpenses__c: z.string().nullable().describe(`
        * * Field Name: ChFin_TotalExpenses__c
        * * Display Name: Ch Fin Total Expenses C
        * * SQL Data Type: nvarchar(500)`),
    ChFin_NetAssets__c: z.string().nullable().describe(`
        * * Field Name: ChFin_NetAssets__c
        * * Display Name: Ch Fin Net Assets C
        * * SQL Data Type: nvarchar(500)`),
    ChFin_FiledTaxReturn__c: z.boolean().nullable().describe(`
        * * Field Name: ChFin_FiledTaxReturn__c
        * * Display Name: Ch Fin Filed Tax Return C
        * * SQL Data Type: bit`),
    ChFin_GroupExemption__c: z.boolean().nullable().describe(`
        * * Field Name: ChFin_GroupExemption__c
        * * Display Name: Ch Fin Group Exemption C
        * * SQL Data Type: bit`),
    ChOff_ElectiveDateBegin__c: z.string().nullable().describe(`
        * * Field Name: ChOff_ElectiveDateBegin__c
        * * Display Name: Ch Off Elective Date Begin C
        * * SQL Data Type: nvarchar(500)`),
    ChOff_ElectiveDateEnd__c: z.string().nullable().describe(`
        * * Field Name: ChOff_ElectiveDateEnd__c
        * * Display Name: Ch Off Elective Date End C
        * * SQL Data Type: nvarchar(500)`),
    ChOff_Office__c: z.string().nullable().describe(`
        * * Field Name: ChOff_Office__c
        * * Display Name: Ch Off Office C
        * * SQL Data Type: nvarchar(500)`),
    ChOff_Term__c: z.string().nullable().describe(`
        * * Field Name: ChOff_Term__c
        * * Display Name: Ch Off Term C
        * * SQL Data Type: nvarchar(500)`),
    ChJur_County__c: z.string().nullable().describe(`
        * * Field Name: ChJur_County__c
        * * Display Name: Ch Jur County C
        * * SQL Data Type: nvarchar(500)`),
    ChJur_State__c: z.string().nullable().describe(`
        * * Field Name: ChJur_State__c
        * * Display Name: Ch Jur State C
        * * SQL Data Type: nvarchar(500)`),
    ChJur_Country__c: z.string().nullable().describe(`
        * * Field Name: ChJur_Country__c
        * * Display Name: Ch Jur Country C
        * * SQL Data Type: nvarchar(500)`),
    ChSpon_Year__c: z.string().nullable().describe(`
        * * Field Name: ChSpon_Year__c
        * * Display Name: Ch Spon Year C
        * * SQL Data Type: nvarchar(500)`),
    ChSpon_SponsorID__c: z.string().nullable().describe(`
        * * Field Name: ChSpon_SponsorID__c
        * * Display Name: Ch Spon Sponsor IDC
        * * SQL Data Type: nvarchar(500)`),
    ChSpon_SponsorLevel__c: z.string().nullable().describe(`
        * * Field Name: ChSpon_SponsorLevel__c
        * * Display Name: Ch Spon Sponsor Level C
        * * SQL Data Type: nvarchar(500)`),
    ChSpon_Rate__c: z.string().nullable().describe(`
        * * Field Name: ChSpon_Rate__c
        * * Display Name: Ch Spon Rate C
        * * SQL Data Type: nvarchar(500)`),
    ChByl_BylawsCurrent__c: z.boolean().nullable().describe(`
        * * Field Name: ChByl_BylawsCurrent__c
        * * Display Name: Ch Byl Bylaws Current C
        * * SQL Data Type: bit`),
    ChByl_ApprovalNotes__c: z.string().nullable().describe(`
        * * Field Name: ChByl_ApprovalNotes__c
        * * Display Name: Ch Byl Approval Notes C
        * * SQL Data Type: nvarchar(500)`),
    ChFin_FiscalYearBegin__c: z.date().nullable().describe(`
        * * Field Name: ChFin_FiscalYearBegin__c
        * * Display Name: Ch Fin Fiscal Year Begin C
        * * SQL Data Type: date`),
    ChFin_FiscalYearEnd__c: z.date().nullable().describe(`
        * * Field Name: ChFin_FiscalYearEnd__c
        * * Display Name: Ch Fin Fiscal Year End C
        * * SQL Data Type: date`),
    ChByl_ApprovalDate__c: z.date().nullable().describe(`
        * * Field Name: ChByl_ApprovalDate__c
        * * Display Name: Ch Byl Approval Date C
        * * SQL Data Type: date`),
    Mailing_Address: z.string().nullable().describe(`
        * * Field Name: Mailing_Address
        * * Display Name: Mailing Address
        * * SQL Data Type: nvarchar(500)`),
    Work_Address: z.string().nullable().describe(`
        * * Field Name: Work_Address
        * * Display Name: Work Address
        * * SQL Data Type: nvarchar(500)`),
    MainOffice_PhoneNumber: z.string().nullable().describe(`
        * * Field Name: MainOffice_PhoneNumber
        * * Display Name: Main Office Phone Number
        * * SQL Data Type: nvarchar(64)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteOrganizationEntityType = z.infer<typeof membersuiteOrganizationSchema>;

/**
 * zod schema definition for the entity MemberSuite: Payment Line Items
 */
export const membersuitePaymentLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    paymentLineItemID: z.string().describe(`
        * * Field Name: paymentLineItemID
        * * Display Name: payment Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    type: z.number().nullable().describe(`
        * * Field Name: type
        * * Display Name: type
        * * SQL Data Type: bigint`),
    invoice: z.string().nullable().describe(`
        * * Field Name: invoice
        * * Display Name: invoice
        * * SQL Data Type: nvarchar(500)`),
    invoiceLineItemID: z.string().nullable().describe(`
        * * Field Name: invoiceLineItemID
        * * Display Name: invoice Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    currencyCode: z.string().nullable().describe(`
        * * Field Name: currencyCode
        * * Display Name: currency Code
        * * SQL Data Type: nvarchar(500)`),
    exchangeRate: z.number().nullable().describe(`
        * * Field Name: exchangeRate
        * * Display Name: exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    invoiceLineItemTotalAtTheTimeOfPayment: z.number().nullable().describe(`
        * * Field Name: invoiceLineItemTotalAtTheTimeOfPayment
        * * Display Name: invoice Line Item Total At The Time Of Payment
        * * SQL Data Type: decimal(19, 4)`),
    invoiceLineItemBalanceDueAtTheTimeOfPayment: z.number().nullable().describe(`
        * * Field Name: invoiceLineItemBalanceDueAtTheTimeOfPayment
        * * Display Name: invoice Line Item Balance Due At The Time Of Payment
        * * SQL Data Type: decimal(19, 4)`),
    invoiceLineItemBalanceDueAfterPayment: z.number().nullable().describe(`
        * * Field Name: invoiceLineItemBalanceDueAfterPayment
        * * Display Name: invoice Line Item Balance Due After Payment
        * * SQL Data Type: decimal(19, 4)`),
    amountRefunded: z.number().nullable().describe(`
        * * Field Name: amountRefunded
        * * Display Name: amount Refunded
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    Payment: z.string().nullable().describe(`
        * * Field Name: Payment
        * * Display Name: Payment
        * * SQL Data Type: uniqueidentifier`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuitePaymentLineItemEntityType = z.infer<typeof membersuitePaymentLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Payments
 */
export const membersuitePaymentSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    CreditCardType: z.string().nullable().describe(`
        * * Field Name: CreditCardType
        * * Display Name: Credit Card Type
        * * SQL Data Type: nvarchar(100)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    PaymentMethod: z.string().nullable().describe(`
        * * Field Name: PaymentMethod
        * * Display Name: Payment Method
        * * SQL Data Type: nvarchar(100)`),
    ReferenceNumber: z.string().nullable().describe(`
        * * Field Name: ReferenceNumber
        * * Display Name: Reference Number
        * * SQL Data Type: nvarchar(500)`),
    Owner: z.string().nullable().describe(`
        * * Field Name: Owner
        * * Display Name: Owner
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    PaymentThatThisTransactionReverses: z.string().nullable().describe(`
        * * Field Name: PaymentThatThisTransactionReverses
        * * Display Name: Payment That This Transaction Reverses
        * * SQL Data Type: uniqueidentifier`),
    BankReconciliation: z.string().nullable().describe(`
        * * Field Name: BankReconciliation
        * * Display Name: Bank Reconciliation
        * * SQL Data Type: uniqueidentifier`),
    IsVoid: z.boolean().nullable().describe(`
        * * Field Name: IsVoid
        * * Display Name: Is Void
        * * SQL Data Type: bit`),
    AmountPendingCapture: z.number().nullable().describe(`
        * * Field Name: AmountPendingCapture
        * * Display Name: Amount Pending Capture
        * * SQL Data Type: decimal(19, 4)`),
    CashAccount: z.string().nullable().describe(`
        * * Field Name: CashAccount
        * * Display Name: Cash Account
        * * SQL Data Type: uniqueidentifier`),
    TransactionID: z.string().nullable().describe(`
        * * Field Name: TransactionID
        * * Display Name: Transaction ID
        * * SQL Data Type: nvarchar(500)`),
    CreditCardLastFiveDigits: z.string().nullable().describe(`
        * * Field Name: CreditCardLastFiveDigits
        * * Display Name: Credit Card Last Five Digits
        * * SQL Data Type: nvarchar(500)`),
    WasAutomaticallyGenerated: z.boolean().nullable().describe(`
        * * Field Name: WasAutomaticallyGenerated
        * * Display Name: Was Automatically Generated
        * * SQL Data Type: bit`),
    AmountReconciled: z.number().nullable().describe(`
        * * Field Name: AmountReconciled
        * * Display Name: Amount Reconciled
        * * SQL Data Type: decimal(19, 4)`),
    CurrencyFluctuationAdjustment: z.number().nullable().describe(`
        * * Field Name: CurrencyFluctuationAdjustment
        * * Display Name: Currency Fluctuation Adjustment
        * * SQL Data Type: decimal(19, 4)`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    WebSECCode: z.string().nullable().describe(`
        * * Field Name: WebSECCode
        * * Display Name: Web SEC Code
        * * SQL Data Type: nvarchar(100)`),
    Status: z.string().nullable().describe(`
        * * Field Name: Status
        * * Display Name: Status
        * * SQL Data Type: nvarchar(500)`),
    PayoutID: z.string().nullable().describe(`
        * * Field Name: PayoutID
        * * Display Name: Payout ID
        * * SQL Data Type: nvarchar(500)`),
    PayoutStatus: z.string().nullable().describe(`
        * * Field Name: PayoutStatus
        * * Display Name: Payout Status
        * * SQL Data Type: nvarchar(500)`),
    PayoutFee: z.number().nullable().describe(`
        * * Field Name: PayoutFee
        * * Display Name: Payout Fee
        * * SQL Data Type: decimal(19, 4)`),
    PayoutNet: z.number().nullable().describe(`
        * * Field Name: PayoutNet
        * * Display Name: Payout Net
        * * SQL Data Type: decimal(19, 4)`),
    PayoutAvailableOn: z.date().nullable().describe(`
        * * Field Name: PayoutAvailableOn
        * * Display Name: Payout Available On
        * * SQL Data Type: datetime2`),
    PayoutCreatedAt: z.date().nullable().describe(`
        * * Field Name: PayoutCreatedAt
        * * Display Name: Payout Created At
        * * SQL Data Type: datetime2`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuitePaymentEntityType = z.infer<typeof membersuitePaymentSchema>;

/**
 * zod schema definition for the entity MemberSuite: Products
 */
export const membersuiteProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    Description: z.string().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: nvarchar(MAX)`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteProductEntityType = z.infer<typeof membersuiteProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Refund Line Items
 */
export const membersuiteRefundLineItemSchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    paymentLineItemID: z.string().describe(`
        * * Field Name: paymentLineItemID
        * * Display Name: payment Line Item ID
        * * SQL Data Type: uniqueidentifier`),
    total: z.number().nullable().describe(`
        * * Field Name: total
        * * Display Name: total
        * * SQL Data Type: decimal(19, 4)`),
    totalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: totalInBaseCurrency
        * * Display Name: total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    Refund: z.string().nullable().describe(`
        * * Field Name: Refund
        * * Display Name: Refund
        * * SQL Data Type: uniqueidentifier`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteRefundLineItemEntityType = z.infer<typeof membersuiteRefundLineItemSchema>;

/**
 * zod schema definition for the entity MemberSuite: Refunds
 */
export const membersuiteRefundSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    InvoiceInstructions: z.string().nullable().describe(`
        * * Field Name: InvoiceInstructions
        * * Display Name: Invoice Instructions
        * * SQL Data Type: nvarchar(100)`),
    Credit: z.string().nullable().describe(`
        * * Field Name: Credit
        * * Display Name: Credit
        * * SQL Data Type: uniqueidentifier`),
    Payment: z.string().nullable().describe(`
        * * Field Name: Payment
        * * Display Name: Payment
        * * SQL Data Type: uniqueidentifier`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    BankReconciliation: z.string().nullable().describe(`
        * * Field Name: BankReconciliation
        * * Display Name: Bank Reconciliation
        * * SQL Data Type: uniqueidentifier`),
    TransactionID: z.string().nullable().describe(`
        * * Field Name: TransactionID
        * * Display Name: Transaction ID
        * * SQL Data Type: nvarchar(500)`),
    ExchangeRate: z.number().nullable().describe(`
        * * Field Name: ExchangeRate
        * * Display Name: Exchange Rate
        * * SQL Data Type: decimal(19, 4)`),
    IgnorePaymentGatewayErrors: z.boolean().nullable().describe(`
        * * Field Name: IgnorePaymentGatewayErrors
        * * Display Name: Ignore Payment Gateway Errors
        * * SQL Data Type: bit`),
    AmountReconciled: z.number().nullable().describe(`
        * * Field Name: AmountReconciled
        * * Display Name: Amount Reconciled
        * * SQL Data Type: decimal(19, 4)`),
    CurrencyFluctuationAdjustment: z.number().nullable().describe(`
        * * Field Name: CurrencyFluctuationAdjustment
        * * Display Name: Currency Fluctuation Adjustment
        * * SQL Data Type: decimal(19, 4)`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    PayoutID: z.string().nullable().describe(`
        * * Field Name: PayoutID
        * * Display Name: Payout ID
        * * SQL Data Type: nvarchar(500)`),
    PayoutStatus: z.string().nullable().describe(`
        * * Field Name: PayoutStatus
        * * Display Name: Payout Status
        * * SQL Data Type: nvarchar(500)`),
    PayoutFee: z.number().nullable().describe(`
        * * Field Name: PayoutFee
        * * Display Name: Payout Fee
        * * SQL Data Type: decimal(19, 4)`),
    PayoutNet: z.number().nullable().describe(`
        * * Field Name: PayoutNet
        * * Display Name: Payout Net
        * * SQL Data Type: decimal(19, 4)`),
    PayoutAvailableOn: z.date().nullable().describe(`
        * * Field Name: PayoutAvailableOn
        * * Display Name: Payout Available On
        * * SQL Data Type: datetime2`),
    PayoutCreatedAt: z.date().nullable().describe(`
        * * Field Name: PayoutCreatedAt
        * * Display Name: Payout Created At
        * * SQL Data Type: datetime2`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteRefundEntityType = z.infer<typeof membersuiteRefundSchema>;

/**
 * zod schema definition for the entity MemberSuite: Registration Fees
 */
export const membersuiteRegistrationFeeSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    CancellationFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: CancellationFeeRuleSet
        * * Display Name: Cancellation Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    TieredRegistrationPricingRuleSet: z.string().nullable().describe(`
        * * Field Name: TieredRegistrationPricingRuleSet
        * * Display Name: Tiered Registration Pricing Rule Set
        * * SQL Data Type: uniqueidentifier`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    IsGuestRegistration: z.boolean().nullable().describe(`
        * * Field Name: IsGuestRegistration
        * * Display Name: Is Guest Registration
        * * SQL Data Type: bit`),
    Event: z.string().nullable().describe(`
        * * Field Name: Event
        * * Display Name: Event
        * * SQL Data Type: uniqueidentifier`),
    CustomerType: z.string().nullable().describe(`
        * * Field Name: CustomerType
        * * Display Name: Customer Type
        * * SQL Data Type: nvarchar(100)`),
    RequiresApproval: z.boolean().nullable().describe(`
        * * Field Name: RequiresApproval
        * * Display Name: Requires Approval
        * * SQL Data Type: bit`),
    Agenda: z.string().nullable().describe(`
        * * Field Name: Agenda
        * * Display Name: Agenda
        * * SQL Data Type: uniqueidentifier`),
    RegistrantCategory: z.string().nullable().describe(`
        * * Field Name: RegistrantCategory
        * * Display Name: Registrant Category
        * * SQL Data Type: uniqueidentifier`),
    RegistrantClass: z.string().nullable().describe(`
        * * Field Name: RegistrantClass
        * * Display Name: Registrant Class
        * * SQL Data Type: uniqueidentifier`),
    EarlyRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: EarlyRegistrationPrice
        * * Display Name: Early Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    LateRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: LateRegistrationPrice
        * * Display Name: Late Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    PreRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: PreRegistrationPrice
        * * Display Name: Pre Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    MemberEarlyRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: MemberEarlyRegistrationPrice
        * * Display Name: Member Early Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    MemberLateRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: MemberLateRegistrationPrice
        * * Display Name: Member Late Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    MemberPreRegistrationPrice: z.number().nullable().describe(`
        * * Field Name: MemberPreRegistrationPrice
        * * Display Name: Member Pre Registration Price
        * * SQL Data Type: decimal(19, 4)`),
    RestrictByMembershipType: z.boolean().nullable().describe(`
        * * Field Name: RestrictByMembershipType
        * * Display Name: Restrict By Membership Type
        * * SQL Data Type: bit`),
    RestrictSessionsByTimeSlots: z.boolean().nullable().describe(`
        * * Field Name: RestrictSessionsByTimeSlots
        * * Display Name: Restrict Sessions By Time Slots
        * * SQL Data Type: bit`),
    RestrictSessionsByTracks: z.boolean().nullable().describe(`
        * * Field Name: RestrictSessionsByTracks
        * * Display Name: Restrict Sessions By Tracks
        * * SQL Data Type: bit`),
    MaximumNumberOfSessions: z.number().nullable().describe(`
        * * Field Name: MaximumNumberOfSessions
        * * Display Name: Maximum Number Of Sessions
        * * SQL Data Type: bigint`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteRegistrationFeeEntityType = z.infer<typeof membersuiteRegistrationFeeSchema>;

/**
 * zod schema definition for the entity MemberSuite: Revenue Recognition Schedule Entries
 */
export const membersuiteRevenueRecognitionScheduleEntrySchema = z.object({
    _ParentID: z.string().nullable().describe(`
        * * Field Name: _ParentID
        * * Display Name: Parent ID
        * * SQL Data Type: uniqueidentifier`),
    deferredRevenueGLCode: z.string().nullable().describe(`
        * * Field Name: deferredRevenueGLCode
        * * Display Name: deferred Revenue GL Code
        * * SQL Data Type: nvarchar(500)`),
    revenueGLCode: z.string().nullable().describe(`
        * * Field Name: revenueGLCode
        * * Display Name: revenue GL Code
        * * SQL Data Type: nvarchar(500)`),
    parentEntryID: z.string().nullable().describe(`
        * * Field Name: parentEntryID
        * * Display Name: parent Entry ID
        * * SQL Data Type: nvarchar(500)`),
    revenueSplitID: z.string().nullable().describe(`
        * * Field Name: revenueSplitID
        * * Display Name: revenue Split ID
        * * SQL Data Type: nvarchar(500)`),
    subledgerEntry: z.string().nullable().describe(`
        * * Field Name: subledgerEntry
        * * Display Name: subledger Entry
        * * SQL Data Type: nvarchar(500)`),
    entryID: z.string().describe(`
        * * Field Name: entryID
        * * Display Name: entry ID
        * * SQL Data Type: uniqueidentifier`),
    dateProcessed: z.date().nullable().describe(`
        * * Field Name: dateProcessed
        * * Display Name: date Processed
        * * SQL Data Type: datetime2`),
    date: z.date().nullable().describe(`
        * * Field Name: date
        * * Display Name: date
        * * SQL Data Type: datetime2`),
    amount: z.number().nullable().describe(`
        * * Field Name: amount
        * * Display Name: amount
        * * SQL Data Type: decimal(19, 4)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteRevenueRecognitionScheduleEntryEntityType = z.infer<typeof membersuiteRevenueRecognitionScheduleEntrySchema>;

/**
 * zod schema definition for the entity MemberSuite: Revenue Recognition Schedules
 */
export const membersuiteRevenueRecognitionScheduleSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    IsSuspended: z.boolean().nullable().describe(`
        * * Field Name: IsSuspended
        * * Display Name: Is Suspended
        * * SQL Data Type: bit`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    DeferredRevenueGLCode: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueGLCode
        * * Display Name: Deferred Revenue GL Code
        * * SQL Data Type: nvarchar(500)`),
    RevenueGLCode: z.string().nullable().describe(`
        * * Field Name: RevenueGLCode
        * * Display Name: Revenue GL Code
        * * SQL Data Type: nvarchar(500)`),
    ParentSchedule: z.string().nullable().describe(`
        * * Field Name: ParentSchedule
        * * Display Name: Parent Schedule
        * * SQL Data Type: uniqueidentifier`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Invoice: z.string().nullable().describe(`
        * * Field Name: Invoice
        * * Display Name: Invoice
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    InvoiceLineItemID: z.string().nullable().describe(`
        * * Field Name: InvoiceLineItemID
        * * Display Name: Invoice Line Item ID
        * * SQL Data Type: nvarchar(500)`),
    ChangeMemo: z.string().nullable().describe(`
        * * Field Name: ChangeMemo
        * * Display Name: Change Memo
        * * SQL Data Type: uniqueidentifier`),
    WriteOff: z.string().nullable().describe(`
        * * Field Name: WriteOff
        * * Display Name: Write Off
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteRevenueRecognitionScheduleEntityType = z.infer<typeof membersuiteRevenueRecognitionScheduleSchema>;

/**
 * zod schema definition for the entity MemberSuite: Section Dues Products
 */
export const membersuiteSectionDuesProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    MembershipOrganization: z.string().nullable().describe(`
        * * Field Name: MembershipOrganization
        * * Display Name: Membership Organization
        * * SQL Data Type: uniqueidentifier`),
    Section: z.string().nullable().describe(`
        * * Field Name: Section
        * * Display Name: Section
        * * SQL Data Type: uniqueidentifier`),
    MembershipType: z.string().nullable().describe(`
        * * Field Name: MembershipType
        * * Display Name: Membership Type
        * * SQL Data Type: uniqueidentifier`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteSectionDuesProductEntityType = z.infer<typeof membersuiteSectionDuesProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Shipping Products
 */
export const membersuiteShippingProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteShippingProductEntityType = z.infer<typeof membersuiteShippingProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Subledger Entry Batches
 */
export const membersuitesubledger_entry_batchesSchema = z.object({
    batch_id: z.string().describe(`
        * * Field Name: batch_id
        * * Display Name: Batch Id
        * * SQL Data Type: nvarchar(100)`),
    fiscal_year_id: z.string().nullable().describe(`
        * * Field Name: fiscal_year_id
        * * Display Name: Fiscal Year Id
        * * SQL Data Type: nvarchar(100)`),
    partition_key: z.string().nullable().describe(`
        * * Field Name: partition_key
        * * Display Name: Partition Key
        * * SQL Data Type: nvarchar(100)`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuitesubledger_entry_batchesEntityType = z.infer<typeof membersuitesubledger_entry_batchesSchema>;

/**
 * zod schema definition for the entity MemberSuite: Subledger Entry Items
 */
export const membersuitesubledger_entry_itemsSchema = z.object({
    subledger_entry_id: z.string().describe(`
        * * Field Name: subledger_entry_id
        * * Display Name: Subledger Entry Id
        * * SQL Data Type: nvarchar(100)`),
    gl_account: z.string().nullable().describe(`
        * * Field Name: gl_account
        * * Display Name: Gl Account
        * * SQL Data Type: nvarchar(500)`),
    gl_account_name: z.string().nullable().describe(`
        * * Field Name: gl_account_name
        * * Display Name: Gl Account Name
        * * SQL Data Type: nvarchar(500)`),
    debits: z.number().nullable().describe(`
        * * Field Name: debits
        * * Display Name: debits
        * * SQL Data Type: decimal(19, 4)`),
    credits: z.number().nullable().describe(`
        * * Field Name: credits
        * * Display Name: credits
        * * SQL Data Type: decimal(19, 4)`),
    project_code: z.string().nullable().describe(`
        * * Field Name: project_code
        * * Display Name: Project Code
        * * SQL Data Type: nvarchar(500)`),
    project_description: z.string().nullable().describe(`
        * * Field Name: project_description
        * * Display Name: Project Description
        * * SQL Data Type: nvarchar(500)`),
    batch_id: z.string().nullable().describe(`
        * * Field Name: batch_id
        * * Display Name: Batch Id
        * * SQL Data Type: nvarchar(100)`),
    batch_name: z.string().nullable().describe(`
        * * Field Name: batch_name
        * * Display Name: Batch Name
        * * SQL Data Type: nvarchar(500)`),
    batch_date: z.date().nullable().describe(`
        * * Field Name: batch_date
        * * Display Name: Batch Date
        * * SQL Data Type: datetime2`),
    business_unit_id: z.string().nullable().describe(`
        * * Field Name: business_unit_id
        * * Display Name: Business Unit Id
        * * SQL Data Type: nvarchar(100)`),
    business_unit_name: z.string().nullable().describe(`
        * * Field Name: business_unit_name
        * * Display Name: Business Unit Name
        * * SQL Data Type: nvarchar(500)`),
    transaction_id: z.string().nullable().describe(`
        * * Field Name: transaction_id
        * * Display Name: Transaction Id
        * * SQL Data Type: nvarchar(100)`),
    transaction_localid: z.string().nullable().describe(`
        * * Field Name: transaction_localid
        * * Display Name: Transaction Localid
        * * SQL Data Type: nvarchar(100)`),
    transaction_name: z.string().nullable().describe(`
        * * Field Name: transaction_name
        * * Display Name: Transaction Name
        * * SQL Data Type: nvarchar(500)`),
    transaction_type: z.string().nullable().describe(`
        * * Field Name: transaction_type
        * * Display Name: Transaction Type
        * * SQL Data Type: nvarchar(500)`),
    type: z.string().nullable().describe(`
        * * Field Name: type
        * * Display Name: type
        * * SQL Data Type: nvarchar(500)`),
    type_name: z.string().nullable().describe(`
        * * Field Name: type_name
        * * Display Name: Type Name
        * * SQL Data Type: nvarchar(500)`),
    invoice_id: z.string().nullable().describe(`
        * * Field Name: invoice_id
        * * Display Name: Invoice Id
        * * SQL Data Type: nvarchar(100)`),
    invoice_lineitem_id: z.string().nullable().describe(`
        * * Field Name: invoice_lineitem_id
        * * Display Name: Invoice Lineitem Id
        * * SQL Data Type: nvarchar(100)`),
    invoicelocalid: z.string().nullable().describe(`
        * * Field Name: invoicelocalid
        * * Display Name: invoicelocalid
        * * SQL Data Type: nvarchar(100)`),
    invoice_name: z.string().nullable().describe(`
        * * Field Name: invoice_name
        * * Display Name: Invoice Name
        * * SQL Data Type: nvarchar(500)`),
    invoicedate: z.date().nullable().describe(`
        * * Field Name: invoicedate
        * * Display Name: invoicedate
        * * SQL Data Type: datetime2`),
    invoiceduedate: z.date().nullable().describe(`
        * * Field Name: invoiceduedate
        * * Display Name: invoiceduedate
        * * SQL Data Type: datetime2`),
    invoicetotal: z.number().nullable().describe(`
        * * Field Name: invoicetotal
        * * Display Name: invoicetotal
        * * SQL Data Type: decimal(19, 4)`),
    payment_id: z.string().nullable().describe(`
        * * Field Name: payment_id
        * * Display Name: Payment Id
        * * SQL Data Type: nvarchar(100)`),
    payment_lineitem_id: z.string().nullable().describe(`
        * * Field Name: payment_lineitem_id
        * * Display Name: Payment Lineitem Id
        * * SQL Data Type: nvarchar(100)`),
    payment_name: z.string().nullable().describe(`
        * * Field Name: payment_name
        * * Display Name: Payment Name
        * * SQL Data Type: nvarchar(500)`),
    credit_id: z.string().nullable().describe(`
        * * Field Name: credit_id
        * * Display Name: Credit Id
        * * SQL Data Type: nvarchar(100)`),
    credit_name: z.string().nullable().describe(`
        * * Field Name: credit_name
        * * Display Name: Credit Name
        * * SQL Data Type: nvarchar(500)`),
    credit_usage_id: z.string().nullable().describe(`
        * * Field Name: credit_usage_id
        * * Display Name: Credit Usage Id
        * * SQL Data Type: nvarchar(100)`),
    credit_usage_lineitem_id: z.string().nullable().describe(`
        * * Field Name: credit_usage_lineitem_id
        * * Display Name: Credit Usage Lineitem Id
        * * SQL Data Type: nvarchar(100)`),
    credit_usage_name: z.string().nullable().describe(`
        * * Field Name: credit_usage_name
        * * Display Name: Credit Usage Name
        * * SQL Data Type: nvarchar(500)`),
    refund_id: z.string().nullable().describe(`
        * * Field Name: refund_id
        * * Display Name: Refund Id
        * * SQL Data Type: nvarchar(100)`),
    refund_name: z.string().nullable().describe(`
        * * Field Name: refund_name
        * * Display Name: Refund Name
        * * SQL Data Type: nvarchar(500)`),
    write_off_id: z.string().nullable().describe(`
        * * Field Name: write_off_id
        * * Display Name: Write Off Id
        * * SQL Data Type: nvarchar(100)`),
    write_off_name: z.string().nullable().describe(`
        * * Field Name: write_off_name
        * * Display Name: Write Off Name
        * * SQL Data Type: nvarchar(500)`),
    gift_id: z.string().nullable().describe(`
        * * Field Name: gift_id
        * * Display Name: Gift Id
        * * SQL Data Type: nvarchar(100)`),
    gift_name: z.string().nullable().describe(`
        * * Field Name: gift_name
        * * Display Name: Gift Name
        * * SQL Data Type: nvarchar(500)`),
    cogs_entry_id: z.string().nullable().describe(`
        * * Field Name: cogs_entry_id
        * * Display Name: Cogs Entry Id
        * * SQL Data Type: nvarchar(100)`),
    cogs_entry_name: z.string().nullable().describe(`
        * * Field Name: cogs_entry_name
        * * Display Name: Cogs Entry Name
        * * SQL Data Type: nvarchar(500)`),
    change_memo_id: z.string().nullable().describe(`
        * * Field Name: change_memo_id
        * * Display Name: Change Memo Id
        * * SQL Data Type: nvarchar(100)`),
    change_memo_name: z.string().nullable().describe(`
        * * Field Name: change_memo_name
        * * Display Name: Change Memo Name
        * * SQL Data Type: nvarchar(500)`),
    historical_deferral_id: z.string().nullable().describe(`
        * * Field Name: historical_deferral_id
        * * Display Name: Historical Deferral Id
        * * SQL Data Type: nvarchar(100)`),
    historical_deferral_name: z.string().nullable().describe(`
        * * Field Name: historical_deferral_name
        * * Display Name: Historical Deferral Name
        * * SQL Data Type: nvarchar(500)`),
    inventory_receipt_id: z.string().nullable().describe(`
        * * Field Name: inventory_receipt_id
        * * Display Name: Inventory Receipt Id
        * * SQL Data Type: nvarchar(100)`),
    inventory_receipt_name: z.string().nullable().describe(`
        * * Field Name: inventory_receipt_name
        * * Display Name: Inventory Receipt Name
        * * SQL Data Type: nvarchar(500)`),
    cash_account_id: z.string().nullable().describe(`
        * * Field Name: cash_account_id
        * * Display Name: Cash Account Id
        * * SQL Data Type: nvarchar(100)`),
    cash_account_name: z.string().nullable().describe(`
        * * Field Name: cash_account_name
        * * Display Name: Cash Account Name
        * * SQL Data Type: nvarchar(500)`),
    due_to_due_from_business_unit_id: z.string().nullable().describe(`
        * * Field Name: due_to_due_from_business_unit_id
        * * Display Name: Due To Due From Business Unit Id
        * * SQL Data Type: nvarchar(100)`),
    due_to_due_from_business_unit_name: z.string().nullable().describe(`
        * * Field Name: due_to_due_from_business_unit_name
        * * Display Name: Due To Due From Business Unit Name
        * * SQL Data Type: nvarchar(500)`),
    customer_id: z.string().nullable().describe(`
        * * Field Name: customer_id
        * * Display Name: Customer Id
        * * SQL Data Type: nvarchar(100)`),
    customer_name: z.string().nullable().describe(`
        * * Field Name: customer_name
        * * Display Name: Customer Name
        * * SQL Data Type: nvarchar(500)`),
    customer_number: z.string().nullable().describe(`
        * * Field Name: customer_number
        * * Display Name: Customer Number
        * * SQL Data Type: nvarchar(100)`),
    customer_email_address: z.string().nullable().describe(`
        * * Field Name: customer_email_address
        * * Display Name: Customer Email Address
        * * SQL Data Type: nvarchar(500)`),
    customer_type: z.string().nullable().describe(`
        * * Field Name: customer_type
        * * Display Name: Customer Type
        * * SQL Data Type: nvarchar(500)`),
    firstname: z.string().nullable().describe(`
        * * Field Name: firstname
        * * Display Name: firstname
        * * SQL Data Type: nvarchar(500)`),
    lastname: z.string().nullable().describe(`
        * * Field Name: lastname
        * * Display Name: lastname
        * * SQL Data Type: nvarchar(500)`),
    product_id: z.string().nullable().describe(`
        * * Field Name: product_id
        * * Display Name: Product Id
        * * SQL Data Type: nvarchar(100)`),
    product_code: z.string().nullable().describe(`
        * * Field Name: product_code
        * * Display Name: Product Code
        * * SQL Data Type: nvarchar(500)`),
    product_name: z.string().nullable().describe(`
        * * Field Name: product_name
        * * Display Name: Product Name
        * * SQL Data Type: nvarchar(500)`),
    product_type: z.string().nullable().describe(`
        * * Field Name: product_type
        * * Display Name: Product Type
        * * SQL Data Type: nvarchar(500)`),
    productcategory: z.string().nullable().describe(`
        * * Field Name: productcategory
        * * Display Name: productcategory
        * * SQL Data Type: nvarchar(500)`),
    membershiptypename: z.string().nullable().describe(`
        * * Field Name: membershiptypename
        * * Display Name: membershiptypename
        * * SQL Data Type: nvarchar(500)`),
    fiscal_year_id: z.string().nullable().describe(`
        * * Field Name: fiscal_year_id
        * * Display Name: Fiscal Year Id
        * * SQL Data Type: nvarchar(100)`),
    fiscal_year_name: z.string().nullable().describe(`
        * * Field Name: fiscal_year_name
        * * Display Name: Fiscal Year Name
        * * SQL Data Type: nvarchar(500)`),
    fiscal_period: z.string().nullable().describe(`
        * * Field Name: fiscal_period
        * * Display Name: Fiscal Period
        * * SQL Data Type: nvarchar(100)`),
    fiscal_period_name: z.string().nullable().describe(`
        * * Field Name: fiscal_period_name
        * * Display Name: Fiscal Period Name
        * * SQL Data Type: nvarchar(500)`),
    currency_code: z.string().nullable().describe(`
        * * Field Name: currency_code
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(100)`),
    date: z.date().nullable().describe(`
        * * Field Name: date
        * * Display Name: date
        * * SQL Data Type: datetime2`),
    credit_value_null_when_zero: z.number().nullable().describe(`
        * * Field Name: credit_value_null_when_zero
        * * Display Name: Credit Value Null When Zero
        * * SQL Data Type: decimal(19, 4)`),
    debit_value_null_when_zero: z.number().nullable().describe(`
        * * Field Name: debit_value_null_when_zero
        * * Display Name: Debit Value Null When Zero
        * * SQL Data Type: decimal(19, 4)`),
    company: z.string().nullable().describe(`
        * * Field Name: company
        * * Display Name: company
        * * SQL Data Type: nvarchar(500)`),
    list_index: z.string().describe(`
        * * Field Name: list_index
        * * Display Name: List Index
        * * SQL Data Type: nvarchar(50)`),
    created_by_id: z.string().nullable().describe(`
        * * Field Name: created_by_id
        * * Display Name: Created By Id
        * * SQL Data Type: nvarchar(100)`),
    created_by_name: z.string().nullable().describe(`
        * * Field Name: created_by_name
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    created_date: z.date().nullable().describe(`
        * * Field Name: created_date
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    clover_etl_date: z.date().nullable().describe(`
        * * Field Name: clover_etl_date
        * * Display Name: Clover Etl Date
        * * SQL Data Type: datetime2`),
    clover_etl_job: z.string().nullable().describe(`
        * * Field Name: clover_etl_job
        * * Display Name: Clover Etl Job
        * * SQL Data Type: nvarchar(500)`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company_Virtual: z.string().describe(`
        * * Field Name: Company_Virtual
        * * Display Name: Company Virtual
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuitesubledger_entry_itemsEntityType = z.infer<typeof membersuitesubledger_entry_itemsSchema>;

/**
 * zod schema definition for the entity MemberSuite: Subscription Fees
 */
export const membersuiteSubscriptionFeeSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    Publication: z.string().nullable().describe(`
        * * Field Name: Publication
        * * Display Name: Publication
        * * SQL Data Type: uniqueidentifier`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    ExpirationType: z.string().nullable().describe(`
        * * Field Name: ExpirationType
        * * Display Name: Expiration Type
        * * SQL Data Type: nvarchar(100)`),
    Availability: z.string().nullable().describe(`
        * * Field Name: Availability
        * * Display Name: Availability
        * * SQL Data Type: nvarchar(100)`),
    StartDate: z.date().nullable().describe(`
        * * Field Name: StartDate
        * * Display Name: Start Date
        * * SQL Data Type: date`),
    SellForNextYearAfter: z.date().nullable().describe(`
        * * Field Name: SellForNextYearAfter
        * * Display Name: Sell For Next Year After
        * * SQL Data Type: date`),
    SetDatesBasedOnPaymentDate: z.boolean().nullable().describe(`
        * * Field Name: SetDatesBasedOnPaymentDate
        * * Display Name: Set Dates Based On Payment Date
        * * SQL Data Type: bit`),
    SellForNextMonthAfterDay: z.number().nullable().describe(`
        * * Field Name: SellForNextMonthAfterDay
        * * Display Name: Sell For Next Month After Day
        * * SQL Data Type: bigint`),
    StartDay: z.number().nullable().describe(`
        * * Field Name: StartDay
        * * Display Name: Start Day
        * * SQL Data Type: bigint`),
    AllowMidMonthExpirations: z.boolean().nullable().describe(`
        * * Field Name: AllowMidMonthExpirations
        * * Display Name: Allow Mid Month Expirations
        * * SQL Data Type: bit`),
    TermLength: z.number().nullable().describe(`
        * * Field Name: TermLength
        * * Display Name: Term Length
        * * SQL Data Type: bigint`),
    TermType: z.string().nullable().describe(`
        * * Field Name: TermType
        * * Display Name: Term Type
        * * SQL Data Type: nvarchar(100)`),
    UpdateDatesWhen: z.string().nullable().describe(`
        * * Field Name: UpdateDatesWhen
        * * Display Name: Update Dates When
        * * SQL Data Type: nvarchar(100)`),
    RequiresApproval: z.boolean().nullable().describe(`
        * * Field Name: RequiresApproval
        * * Display Name: Requires Approval
        * * SQL Data Type: bit`),
    RenewalTerms: z.string().nullable().describe(`
        * * Field Name: RenewalTerms
        * * Display Name: Renewal Terms
        * * SQL Data Type: uniqueidentifier`),
    ProFormaRenewalInvoices: z.boolean().nullable().describe(`
        * * Field Name: ProFormaRenewalInvoices
        * * Display Name: Pro Forma Renewal Invoices
        * * SQL Data Type: bit`),
    GracePeriod: z.number().nullable().describe(`
        * * Field Name: GracePeriod
        * * Display Name: Grace Period
        * * SQL Data Type: bigint`),
    BillPrimaryOrganization: z.boolean().nullable().describe(`
        * * Field Name: BillPrimaryOrganization
        * * Display Name: Bill Primary Organization
        * * SQL Data Type: bit`),
    ReinstatementPeriod: z.number().nullable().describe(`
        * * Field Name: ReinstatementPeriod
        * * Display Name: Reinstatement Period
        * * SQL Data Type: bigint`),
    UseFreshJoinDateForReinstatedMembers: z.boolean().nullable().describe(`
        * * Field Name: UseFreshJoinDateForReinstatedMembers
        * * Display Name: Use Fresh Join Date For Reinstated Members
        * * SQL Data Type: bit`),
    GiveRenewalPricingDuringReinstatementPeriod: z.boolean().nullable().describe(`
        * * Field Name: GiveRenewalPricingDuringReinstatementPeriod
        * * Display Name: Give Renewal Pricing During Reinstatement Period
        * * SQL Data Type: bit`),
    UseCurrentDateAsBasisForExpirationOfReinstatedMembership: z.boolean().nullable().describe(`
        * * Field Name: UseCurrentDateAsBasisForExpirationOfReinstatedMembership
        * * Display Name: Use Current Date As Basis For Expiration Of Reinstated Membership
        * * SQL Data Type: bit`),
    InitialBillingEmail: z.string().nullable().describe(`
        * * Field Name: InitialBillingEmail
        * * Display Name: Initial Billing Email
        * * SQL Data Type: uniqueidentifier`),
    FirstReminderEmail: z.string().nullable().describe(`
        * * Field Name: FirstReminderEmail
        * * Display Name: First Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    SecondReminderEmail: z.string().nullable().describe(`
        * * Field Name: SecondReminderEmail
        * * Display Name: Second Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    ThirdReminderEmail: z.string().nullable().describe(`
        * * Field Name: ThirdReminderEmail
        * * Display Name: Third Reminder Email
        * * SQL Data Type: uniqueidentifier`),
    DropEmail: z.string().nullable().describe(`
        * * Field Name: DropEmail
        * * Display Name: Drop Email
        * * SQL Data Type: uniqueidentifier`),
    InvoicePercentage: z.number().nullable().describe(`
        * * Field Name: InvoicePercentage
        * * Display Name: Invoice Percentage
        * * SQL Data Type: decimal(19, 4)`),
    InvoiceType: z.string().nullable().describe(`
        * * Field Name: InvoiceType
        * * Display Name: Invoice Type
        * * SQL Data Type: uniqueidentifier`),
    AutoRenew: z.boolean().nullable().describe(`
        * * Field Name: AutoRenew
        * * Display Name: Auto Renew
        * * SQL Data Type: bit`),
    RenewsWith: z.string().nullable().describe(`
        * * Field Name: RenewsWith
        * * Display Name: Renews With
        * * SQL Data Type: uniqueidentifier`),
    Type: z.string().nullable().describe(`
        * * Field Name: Type
        * * Display Name: Type
        * * SQL Data Type: nvarchar(100)`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteSubscriptionFeeEntityType = z.infer<typeof membersuiteSubscriptionFeeSchema>;

/**
 * zod schema definition for the entity MemberSuite: Tax Products
 */
export const membersuiteTaxProductSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    IsDiyImported: z.boolean().nullable().describe(`
        * * Field Name: IsDiyImported
        * * Display Name: Is Diy Imported
        * * SQL Data Type: bit`),
    Code: z.string().nullable().describe(`
        * * Field Name: Code
        * * Display Name: Code
        * * SQL Data Type: nvarchar(500)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    Category: z.string().nullable().describe(`
        * * Field Name: Category
        * * Display Name: Category
        * * SQL Data Type: uniqueidentifier`),
    DisplayOrder: z.number().nullable().describe(`
        * * Field Name: DisplayOrder
        * * Display Name: Display Order
        * * SQL Data Type: bigint`),
    Description: z.number().nullable().describe(`
        * * Field Name: Description
        * * Display Name: Description
        * * SQL Data Type: decimal(19, 4)`),
    ConfirmationEmail: z.string().nullable().describe(`
        * * Field Name: ConfirmationEmail
        * * Display Name: Confirmation Email
        * * SQL Data Type: uniqueidentifier`),
    SellOnline: z.boolean().nullable().describe(`
        * * Field Name: SellOnline
        * * Display Name: Sell Online
        * * SQL Data Type: bit`),
    SellFrom: z.date().nullable().describe(`
        * * Field Name: SellFrom
        * * Display Name: Sell From
        * * SQL Data Type: datetime2`),
    SellUntil: z.date().nullable().describe(`
        * * Field Name: SellUntil
        * * Display Name: Sell Until
        * * SQL Data Type: datetime2`),
    NewUntil: z.date().nullable().describe(`
        * * Field Name: NewUntil
        * * Display Name: New Until
        * * SQL Data Type: datetime2`),
    Price: z.number().nullable().describe(`
        * * Field Name: Price
        * * Display Name: Price
        * * SQL Data Type: decimal(19, 4)`),
    InventoryCostingMethod: z.string().nullable().describe(`
        * * Field Name: InventoryCostingMethod
        * * Display Name: Inventory Costing Method
        * * SQL Data Type: nvarchar(100)`),
    AllowCustomersToPayLater: z.boolean().nullable().describe(`
        * * Field Name: AllowCustomersToPayLater
        * * Display Name: Allow Customers To Pay Later
        * * SQL Data Type: bit`),
    MemberPrice: z.number().nullable().describe(`
        * * Field Name: MemberPrice
        * * Display Name: Member Price
        * * SQL Data Type: decimal(19, 4)`),
    UseSpecialPricesOnly: z.boolean().nullable().describe(`
        * * Field Name: UseSpecialPricesOnly
        * * Display Name: Use Special Prices Only
        * * SQL Data Type: bit`),
    DisplayPriceAs: z.string().nullable().describe(`
        * * Field Name: DisplayPriceAs
        * * Display Name: Display Price As
        * * SQL Data Type: nvarchar(500)`),
    TrackInventory: z.boolean().nullable().describe(`
        * * Field Name: TrackInventory
        * * Display Name: Track Inventory
        * * SQL Data Type: bit`),
    LateFeeRuleSet: z.string().nullable().describe(`
        * * Field Name: LateFeeRuleSet
        * * Display Name: Late Fee Rule Set
        * * SQL Data Type: uniqueidentifier`),
    Weight: z.number().nullable().describe(`
        * * Field Name: Weight
        * * Display Name: Weight
        * * SQL Data Type: decimal(19, 4)`),
    AllowBackOrders: z.boolean().nullable().describe(`
        * * Field Name: AllowBackOrders
        * * Display Name: Allow Back Orders
        * * SQL Data Type: bit`),
    PaymentCaptureTimingBehavior: z.string().nullable().describe(`
        * * Field Name: PaymentCaptureTimingBehavior
        * * Display Name: Payment Capture Timing Behavior
        * * SQL Data Type: nvarchar(100)`),
    EligibleForShippingCharges: z.boolean().nullable().describe(`
        * * Field Name: EligibleForShippingCharges
        * * Display Name: Eligible For Shipping Charges
        * * SQL Data Type: bit`),
    Taxable: z.boolean().nullable().describe(`
        * * Field Name: Taxable
        * * Display Name: Taxable
        * * SQL Data Type: bit`),
    TaxTable: z.string().nullable().describe(`
        * * Field Name: TaxTable
        * * Display Name: Tax Table
        * * SQL Data Type: uniqueidentifier`),
    ProrationTable: z.string().nullable().describe(`
        * * Field Name: ProrationTable
        * * Display Name: Proration Table
        * * SQL Data Type: uniqueidentifier`),
    Project: z.string().nullable().describe(`
        * * Field Name: Project
        * * Display Name: Project
        * * SQL Data Type: uniqueidentifier`),
    ARAccount: z.string().nullable().describe(`
        * * Field Name: ARAccount
        * * Display Name: AR Account
        * * SQL Data Type: uniqueidentifier`),
    Vendor: z.string().nullable().describe(`
        * * Field Name: Vendor
        * * Display Name: Vendor
        * * SQL Data Type: uniqueidentifier`),
    DeferredRevenueAccount: z.string().nullable().describe(`
        * * Field Name: DeferredRevenueAccount
        * * Display Name: Deferred Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    WriteOffAccount: z.string().nullable().describe(`
        * * Field Name: WriteOffAccount
        * * Display Name: Write Off Account
        * * SQL Data Type: uniqueidentifier`),
    InventoryAccount: z.string().nullable().describe(`
        * * Field Name: InventoryAccount
        * * Display Name: Inventory Account
        * * SQL Data Type: uniqueidentifier`),
    COGSAccount: z.string().nullable().describe(`
        * * Field Name: COGSAccount
        * * Display Name: COGS Account
        * * SQL Data Type: uniqueidentifier`),
    CancellationFeeProduct: z.string().nullable().describe(`
        * * Field Name: CancellationFeeProduct
        * * Display Name: Cancellation Fee Product
        * * SQL Data Type: uniqueidentifier`),
    CancellationFee: z.number().nullable().describe(`
        * * Field Name: CancellationFee
        * * Display Name: Cancellation Fee
        * * SQL Data Type: decimal(19, 4)`),
    RestockingFee: z.number().nullable().describe(`
        * * Field Name: RestockingFee
        * * Display Name: Restocking Fee
        * * SQL Data Type: decimal(19, 4)`),
    RevenueRecognitionTemplate: z.string().nullable().describe(`
        * * Field Name: RevenueRecognitionTemplate
        * * Display Name: Revenue Recognition Template
        * * SQL Data Type: uniqueidentifier`),
    RevenueAccount: z.string().nullable().describe(`
        * * Field Name: RevenueAccount
        * * Display Name: Revenue Account
        * * SQL Data Type: uniqueidentifier`),
    BillingTemplate: z.string().nullable().describe(`
        * * Field Name: BillingTemplate
        * * Display Name: Billing Template
        * * SQL Data Type: uniqueidentifier`),
    DefaultWarehouse: z.string().nullable().describe(`
        * * Field Name: DefaultWarehouse
        * * Display Name: Default Warehouse
        * * SQL Data Type: uniqueidentifier`),
    ShowOnMembershipForm: z.boolean().nullable().describe(`
        * * Field Name: ShowOnMembershipForm
        * * Display Name: Show On Membership Form
        * * SQL Data Type: bit`),
    ShowDuringEventRegistrations: z.boolean().nullable().describe(`
        * * Field Name: ShowDuringEventRegistrations
        * * Display Name: Show During Event Registrations
        * * SQL Data Type: bit`),
    UseShipToForPriceCalculation: z.boolean().nullable().describe(`
        * * Field Name: UseShipToForPriceCalculation
        * * Display Name: Use Ship To For Price Calculation
        * * SQL Data Type: bit`),
    ReorderPoint: z.number().nullable().describe(`
        * * Field Name: ReorderPoint
        * * Display Name: Reorder Point
        * * SQL Data Type: decimal(19, 4)`),
    IsActive: z.boolean().nullable().describe(`
        * * Field Name: IsActive
        * * Display Name: Is Active
        * * SQL Data Type: bit`),
    HasSpecialPrices: z.boolean().nullable().describe(`
        * * Field Name: HasSpecialPrices
        * * Display Name: Has Special Prices
        * * SQL Data Type: bit`),
    HasEligibilityRestrictions: z.boolean().nullable().describe(`
        * * Field Name: HasEligibilityRestrictions
        * * Display Name: Has Eligibility Restrictions
        * * SQL Data Type: bit`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteTaxProductEntityType = z.infer<typeof membersuiteTaxProductSchema>;

/**
 * zod schema definition for the entity MemberSuite: Write Offs
 */
export const membersuiteWriteOffSchema = z.object({
    ID: z.string().describe(`
        * * Field Name: ID
        * * Display Name: ID
        * * SQL Data Type: uniqueidentifier`),
    Name: z.string().nullable().describe(`
        * * Field Name: Name
        * * Display Name: Name
        * * SQL Data Type: nvarchar(500)`),
    Keywords: z.string().nullable().describe(`
        * * Field Name: Keywords
        * * Display Name: Keywords
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedBy: z.string().nullable().describe(`
        * * Field Name: LastModifiedBy
        * * Display Name: Last Modified By
        * * SQL Data Type: uniqueidentifier`),
    LastModifiedDate: z.date().nullable().describe(`
        * * Field Name: LastModifiedDate
        * * Display Name: Last Modified Date
        * * SQL Data Type: datetime2`),
    CreatedDate: z.date().nullable().describe(`
        * * Field Name: CreatedDate
        * * Display Name: Created Date
        * * SQL Data Type: datetime2`),
    CreatedBy: z.string().nullable().describe(`
        * * Field Name: CreatedBy
        * * Display Name: Created By
        * * SQL Data Type: uniqueidentifier`),
    LockedForDeletion: z.boolean().nullable().describe(`
        * * Field Name: LockedForDeletion
        * * Display Name: Locked For Deletion
        * * SQL Data Type: bit`),
    IsConfiguration: z.boolean().nullable().describe(`
        * * Field Name: IsConfiguration
        * * Display Name: Is Configuration
        * * SQL Data Type: bit`),
    IsSealed: z.boolean().nullable().describe(`
        * * Field Name: IsSealed
        * * Display Name: Is Sealed
        * * SQL Data Type: bit`),
    CreatedByName: z.string().nullable().describe(`
        * * Field Name: CreatedByName
        * * Display Name: Created By Name
        * * SQL Data Type: nvarchar(500)`),
    LastModifiedByName: z.string().nullable().describe(`
        * * Field Name: LastModifiedByName
        * * Display Name: Last Modified By Name
        * * SQL Data Type: nvarchar(500)`),
    LocalID: z.number().nullable().describe(`
        * * Field Name: LocalID
        * * Display Name: Local ID
        * * SQL Data Type: bigint`),
    OrderCancellation: z.string().nullable().describe(`
        * * Field Name: OrderCancellation
        * * Display Name: Order Cancellation
        * * SQL Data Type: uniqueidentifier`),
    Return: z.string().nullable().describe(`
        * * Field Name: Return
        * * Display Name: Return
        * * SQL Data Type: uniqueidentifier`),
    Order: z.string().nullable().describe(`
        * * Field Name: Order
        * * Display Name: Order
        * * SQL Data Type: uniqueidentifier`),
    Date: z.date().nullable().describe(`
        * * Field Name: Date
        * * Display Name: Date
        * * SQL Data Type: date`),
    Memo: z.string().nullable().describe(`
        * * Field Name: Memo
        * * Display Name: Memo
        * * SQL Data Type: nvarchar(500)`),
    Notes: z.string().nullable().describe(`
        * * Field Name: Notes
        * * Display Name: Notes
        * * SQL Data Type: nvarchar(MAX)`),
    BadDebtsExpenseAccount: z.string().nullable().describe(`
        * * Field Name: BadDebtsExpenseAccount
        * * Display Name: Bad Debts Expense Account
        * * SQL Data Type: uniqueidentifier`),
    Method: z.string().nullable().describe(`
        * * Field Name: Method
        * * Display Name: Method
        * * SQL Data Type: nvarchar(100)`),
    Batch: z.string().nullable().describe(`
        * * Field Name: Batch
        * * Display Name: Batch
        * * SQL Data Type: uniqueidentifier`),
    SourceCode: z.string().nullable().describe(`
        * * Field Name: SourceCode
        * * Display Name: Source Code
        * * SQL Data Type: uniqueidentifier`),
    MediaCode: z.string().nullable().describe(`
        * * Field Name: MediaCode
        * * Display Name: Media Code
        * * SQL Data Type: uniqueidentifier`),
    Invoice: z.string().nullable().describe(`
        * * Field Name: Invoice
        * * Display Name: Invoice
        * * SQL Data Type: uniqueidentifier`),
    Total: z.number().nullable().describe(`
        * * Field Name: Total
        * * Display Name: Total
        * * SQL Data Type: decimal(19, 4)`),
    TotalInBaseCurrency: z.number().nullable().describe(`
        * * Field Name: TotalInBaseCurrency
        * * Display Name: Total In Base Currency
        * * SQL Data Type: decimal(19, 4)`),
    BusinessUnit: z.string().nullable().describe(`
        * * Field Name: BusinessUnit
        * * Display Name: Business Unit
        * * SQL Data Type: uniqueidentifier`),
    CurrencyCode: z.string().nullable().describe(`
        * * Field Name: CurrencyCode
        * * Display Name: Currency Code
        * * SQL Data Type: nvarchar(500)`),
    _PulledAt: z.date().describe(`
        * * Field Name: _PulledAt
        * * Display Name: Pulled At
        * * SQL Data Type: datetime2
        * * Default Value: sysutcdatetime()`),
    _RawJson: z.string().nullable().describe(`
        * * Field Name: _RawJson
        * * Display Name: Raw Json
        * * SQL Data Type: nvarchar(MAX)`),
    CompanyIntegrationID: z.string().describe(`
        * * Field Name: CompanyIntegrationID
        * * Display Name: Company Integration ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
        * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34`),
    CompanyID: z.string().describe(`
        * * Field Name: CompanyID
        * * Display Name: Company ID
        * * SQL Data Type: uniqueidentifier
        * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
        * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C`),
    __mj_CreatedAt: z.date().describe(`
        * * Field Name: __mj_CreatedAt
        * * Display Name: Created At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    __mj_UpdatedAt: z.date().describe(`
        * * Field Name: __mj_UpdatedAt
        * * Display Name: Updated At
        * * SQL Data Type: datetimeoffset
        * * Default Value: getutcdate()`),
    CompanyIntegration: z.string().describe(`
        * * Field Name: CompanyIntegration
        * * Display Name: Company Integration
        * * SQL Data Type: nvarchar(255)`),
    Company: z.string().describe(`
        * * Field Name: Company
        * * Display Name: Company
        * * SQL Data Type: nvarchar(50)`),
});

export type membersuiteWriteOffEntityType = z.infer<typeof membersuiteWriteOffSchema>;
 
 

/**
 * MemberSuite: Batches - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Batch
 * * Base View: vwBatches
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Batches')
export class membersuiteBatchEntity extends BaseEntity<membersuiteBatchEntityType> {
    /**
    * Loads the MemberSuite: Batches record from the database
    * @param ID: string - primary key value to load the MemberSuite: Batches record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteBatchEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: BankReconciliation
    * * Display Name: Bank Reconciliation
    * * SQL Data Type: uniqueidentifier
    */
    get BankReconciliation(): string | null {
        return this.Get('BankReconciliation');
    }
    set BankReconciliation(value: string | null) {
        this.Set('BankReconciliation', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: nvarchar(MAX)
    */
    get Description(): string | null {
        return this.Get('Description');
    }
    set Description(value: string | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: DatePosted
    * * Display Name: Date Posted
    * * SQL Data Type: date
    */
    get DatePosted(): Date | null {
        return this.Get('DatePosted');
    }
    set DatePosted(value: Date | null) {
        this.Set('DatePosted', value);
    }

    /**
    * * Field Name: DateClosed
    * * Display Name: Date Closed
    * * SQL Data Type: date
    */
    get DateClosed(): Date | null {
        return this.Get('DateClosed');
    }
    set DateClosed(value: Date | null) {
        this.Set('DateClosed', value);
    }

    /**
    * * Field Name: DateExported
    * * Display Name: Date Exported
    * * SQL Data Type: datetime2
    */
    get DateExported(): Date | null {
        return this.Get('DateExported');
    }
    set DateExported(value: Date | null) {
        this.Set('DateExported', value);
    }

    /**
    * * Field Name: ClosedBy
    * * Display Name: Closed By
    * * SQL Data Type: uniqueidentifier
    */
    get ClosedBy(): string | null {
        return this.Get('ClosedBy');
    }
    set ClosedBy(value: string | null) {
        this.Set('ClosedBy', value);
    }

    /**
    * * Field Name: PostedBy
    * * Display Name: Posted By
    * * SQL Data Type: uniqueidentifier
    */
    get PostedBy(): string | null {
        return this.Get('PostedBy');
    }
    set PostedBy(value: string | null) {
        this.Set('PostedBy', value);
    }

    /**
    * * Field Name: FiscalYear
    * * Display Name: Fiscal Year
    * * SQL Data Type: uniqueidentifier
    */
    get FiscalYear(): string | null {
        return this.Get('FiscalYear');
    }
    set FiscalYear(value: string | null) {
        this.Set('FiscalYear', value);
    }

    /**
    * * Field Name: FiscalPeriod
    * * Display Name: Fiscal Period
    * * SQL Data Type: bigint
    */
    get FiscalPeriod(): number | null {
        return this.Get('FiscalPeriod');
    }
    set FiscalPeriod(value: number | null) {
        this.Set('FiscalPeriod', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Status
    * * Display Name: Status
    * * SQL Data Type: nvarchar(100)
    */
    get Status(): string | null {
        return this.Get('Status');
    }
    set Status(value: string | null) {
        this.Set('Status', value);
    }

    /**
    * * Field Name: DateVerified
    * * Display Name: Date Verified
    * * SQL Data Type: date
    */
    get DateVerified(): Date | null {
        return this.Get('DateVerified');
    }
    set DateVerified(value: Date | null) {
        this.Set('DateVerified', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: ControlTotal
    * * Display Name: Control Total
    * * SQL Data Type: decimal(19, 4)
    */
    get ControlTotal(): number | null {
        return this.Get('ControlTotal');
    }
    set ControlTotal(value: number | null) {
        this.Set('ControlTotal', value);
    }

    /**
    * * Field Name: ControlCount
    * * Display Name: Control Count
    * * SQL Data Type: bigint
    */
    get ControlCount(): number | null {
        return this.Get('ControlCount');
    }
    set ControlCount(value: number | null) {
        this.Set('ControlCount', value);
    }

    /**
    * * Field Name: RestrictAccess
    * * Display Name: Restrict Access
    * * SQL Data Type: bit
    */
    get RestrictAccess(): boolean | null {
        return this.Get('RestrictAccess');
    }
    set RestrictAccess(value: boolean | null) {
        this.Set('RestrictAccess', value);
    }

    /**
    * * Field Name: PostAutomatically
    * * Display Name: Post Automatically
    * * SQL Data Type: bit
    */
    get PostAutomatically(): boolean | null {
        return this.Get('PostAutomatically');
    }
    set PostAutomatically(value: boolean | null) {
        this.Set('PostAutomatically', value);
    }

    /**
    * * Field Name: DateToAutomaticallyClose
    * * Display Name: Date To Automatically Close
    * * SQL Data Type: datetime2
    */
    get DateToAutomaticallyClose(): Date | null {
        return this.Get('DateToAutomaticallyClose');
    }
    set DateToAutomaticallyClose(value: Date | null) {
        this.Set('DateToAutomaticallyClose', value);
    }

    /**
    * * Field Name: RecurringBatchDefinition
    * * Display Name: Recurring Batch Definition
    * * SQL Data Type: uniqueidentifier
    */
    get RecurringBatchDefinition(): string | null {
        return this.Get('RecurringBatchDefinition');
    }
    set RecurringBatchDefinition(value: string | null) {
        this.Set('RecurringBatchDefinition', value);
    }

    /**
    * * Field Name: ClosedByName
    * * Display Name: Closed By Name
    * * SQL Data Type: nvarchar(500)
    */
    get ClosedByName(): string | null {
        return this.Get('ClosedByName');
    }
    set ClosedByName(value: string | null) {
        this.Set('ClosedByName', value);
    }

    /**
    * * Field Name: PostedByName
    * * Display Name: Posted By Name
    * * SQL Data Type: nvarchar(500)
    */
    get PostedByName(): string | null {
        return this.Get('PostedByName');
    }
    set PostedByName(value: string | null) {
        this.Set('PostedByName', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Business Units - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: BusinessUnit
 * * Base View: vwBusinessUnits
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Business Units')
export class membersuiteBusinessUnitEntity extends BaseEntity<membersuiteBusinessUnitEntityType> {
    /**
    * Loads the MemberSuite: Business Units record from the database
    * @param ID: string - primary key value to load the MemberSuite: Business Units record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteBusinessUnitEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: nvarchar(MAX)
    */
    get Description(): string | null {
        return this.Get('Description');
    }
    set Description(value: string | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: BaseCurrency
    * * Display Name: Base Currency
    * * SQL Data Type: nvarchar(500)
    */
    get BaseCurrency(): string | null {
        return this.Get('BaseCurrency');
    }
    set BaseCurrency(value: string | null) {
        this.Set('BaseCurrency', value);
    }

    /**
    * * Field Name: DisplayAddress
    * * Display Name: Display Address
    * * SQL Data Type: nvarchar(MAX)
    */
    get DisplayAddress(): string | null {
        return this.Get('DisplayAddress');
    }
    set DisplayAddress(value: string | null) {
        this.Set('DisplayAddress', value);
    }

    /**
    * * Field Name: GenerateInvoicesOnZeroDollarOrders
    * * Display Name: Generate Invoices On Zero Dollar Orders
    * * SQL Data Type: bit
    */
    get GenerateInvoicesOnZeroDollarOrders(): boolean | null {
        return this.Get('GenerateInvoicesOnZeroDollarOrders');
    }
    set GenerateInvoicesOnZeroDollarOrders(value: boolean | null) {
        this.Set('GenerateInvoicesOnZeroDollarOrders', value);
    }

    /**
    * * Field Name: DefaultInvoiceType
    * * Display Name: Default Invoice Type
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultInvoiceType(): string | null {
        return this.Get('DefaultInvoiceType');
    }
    set DefaultInvoiceType(value: string | null) {
        this.Set('DefaultInvoiceType', value);
    }

    /**
    * * Field Name: IsDefault
    * * Display Name: Is Default
    * * SQL Data Type: bit
    */
    get IsDefault(): boolean | null {
        return this.Get('IsDefault');
    }
    set IsDefault(value: boolean | null) {
        this.Set('IsDefault', value);
    }

    /**
    * * Field Name: StartOfFiscalYear
    * * Display Name: Start Of Fiscal Year
    * * SQL Data Type: nvarchar(100)
    */
    get StartOfFiscalYear(): string | null {
        return this.Get('StartOfFiscalYear');
    }
    set StartOfFiscalYear(value: string | null) {
        this.Set('StartOfFiscalYear', value);
    }

    /**
    * * Field Name: FinancialSoftwarePackage
    * * Display Name: Financial Software Package
    * * SQL Data Type: nvarchar(100)
    */
    get FinancialSoftwarePackage(): string | null {
        return this.Get('FinancialSoftwarePackage');
    }
    set FinancialSoftwarePackage(value: string | null) {
        this.Set('FinancialSoftwarePackage', value);
    }

    /**
    * * Field Name: DefaultInvoiceTemplate
    * * Display Name: Default Invoice Template
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultInvoiceTemplate(): string | null {
        return this.Get('DefaultInvoiceTemplate');
    }
    set DefaultInvoiceTemplate(value: string | null) {
        this.Set('DefaultInvoiceTemplate', value);
    }

    /**
    * * Field Name: DefaultOrderTemplate
    * * Display Name: Default Order Template
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultOrderTemplate(): string | null {
        return this.Get('DefaultOrderTemplate');
    }
    set DefaultOrderTemplate(value: string | null) {
        this.Set('DefaultOrderTemplate', value);
    }

    /**
    * * Field Name: DefaultPaymentReceiptTemplate
    * * Display Name: Default Payment Receipt Template
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultPaymentReceiptTemplate(): string | null {
        return this.Get('DefaultPaymentReceiptTemplate');
    }
    set DefaultPaymentReceiptTemplate(value: string | null) {
        this.Set('DefaultPaymentReceiptTemplate', value);
    }

    /**
    * * Field Name: InvoiceReport
    * * Display Name: Invoice Report
    * * SQL Data Type: uniqueidentifier
    */
    get InvoiceReport(): string | null {
        return this.Get('InvoiceReport');
    }
    set InvoiceReport(value: string | null) {
        this.Set('InvoiceReport', value);
    }

    /**
    * * Field Name: PaymentReceiptReport
    * * Display Name: Payment Receipt Report
    * * SQL Data Type: uniqueidentifier
    */
    get PaymentReceiptReport(): string | null {
        return this.Get('PaymentReceiptReport');
    }
    set PaymentReceiptReport(value: string | null) {
        this.Set('PaymentReceiptReport', value);
    }

    /**
    * * Field Name: DefaultInventoryCostingMethod
    * * Display Name: Default Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get DefaultInventoryCostingMethod(): string | null {
        return this.Get('DefaultInventoryCostingMethod');
    }
    set DefaultInventoryCostingMethod(value: string | null) {
        this.Set('DefaultInventoryCostingMethod', value);
    }

    /**
    * * Field Name: DefaultWriteOffMethod
    * * Display Name: Default Write Off Method
    * * SQL Data Type: nvarchar(100)
    */
    get DefaultWriteOffMethod(): string | null {
        return this.Get('DefaultWriteOffMethod');
    }
    set DefaultWriteOffMethod(value: string | null) {
        this.Set('DefaultWriteOffMethod', value);
    }

    /**
    * * Field Name: BatchDownloadMethod
    * * Display Name: Batch Download Method
    * * SQL Data Type: nvarchar(100)
    */
    get BatchDownloadMethod(): string | null {
        return this.Get('BatchDownloadMethod');
    }
    set BatchDownloadMethod(value: string | null) {
        this.Set('BatchDownloadMethod', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: BatchDownloadTemplate
    * * Display Name: Batch Download Template
    * * SQL Data Type: uniqueidentifier
    */
    get BatchDownloadTemplate(): string | null {
        return this.Get('BatchDownloadTemplate');
    }
    set BatchDownloadTemplate(value: string | null) {
        this.Set('BatchDownloadTemplate', value);
    }

    /**
    * * Field Name: VerifyControlValuesWhenPostingBatches
    * * Display Name: Verify Control Values When Posting Batches
    * * SQL Data Type: bit
    */
    get VerifyControlValuesWhenPostingBatches(): boolean | null {
        return this.Get('VerifyControlValuesWhenPostingBatches');
    }
    set VerifyControlValuesWhenPostingBatches(value: boolean | null) {
        this.Set('VerifyControlValuesWhenPostingBatches', value);
    }

    /**
    * * Field Name: EnableWordBasedInvoicesAndReceipts
    * * Display Name: Enable Word Based Invoices And Receipts
    * * SQL Data Type: bit
    */
    get EnableWordBasedInvoicesAndReceipts(): boolean | null {
        return this.Get('EnableWordBasedInvoicesAndReceipts');
    }
    set EnableWordBasedInvoicesAndReceipts(value: boolean | null) {
        this.Set('EnableWordBasedInvoicesAndReceipts', value);
    }

    /**
    * * Field Name: DoNotAllowPartialPaymentsInPortal
    * * Display Name: Do Not Allow Partial Payments In Portal
    * * SQL Data Type: bit
    */
    get DoNotAllowPartialPaymentsInPortal(): boolean | null {
        return this.Get('DoNotAllowPartialPaymentsInPortal');
    }
    set DoNotAllowPartialPaymentsInPortal(value: boolean | null) {
        this.Set('DoNotAllowPartialPaymentsInPortal', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: COGS Entries - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: COGSEntry
 * * Base View: vwCOGSEntries
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: COGS Entries')
export class membersuiteCOGSEntryEntity extends BaseEntity<membersuiteCOGSEntryEntityType> {
    /**
    * Loads the MemberSuite: COGS Entries record from the database
    * @param ID: string - primary key value to load the MemberSuite: COGS Entries record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteCOGSEntryEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: OrderLineItemID
    * * Display Name: Order Line Item ID
    * * SQL Data Type: nvarchar(500)
    */
    get OrderLineItemID(): string | null {
        return this.Get('OrderLineItemID');
    }
    set OrderLineItemID(value: string | null) {
        this.Set('OrderLineItemID', value);
    }

    /**
    * * Field Name: StockItemInventory
    * * Display Name: Stock Item Inventory
    * * SQL Data Type: uniqueidentifier
    */
    get StockItemInventory(): string | null {
        return this.Get('StockItemInventory');
    }
    set StockItemInventory(value: string | null) {
        this.Set('StockItemInventory', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: FiscalYear
    * * Display Name: Fiscal Year
    * * SQL Data Type: uniqueidentifier
    */
    get FiscalYear(): string | null {
        return this.Get('FiscalYear');
    }
    set FiscalYear(value: string | null) {
        this.Set('FiscalYear', value);
    }

    /**
    * * Field Name: FiscalPeriod
    * * Display Name: Fiscal Period
    * * SQL Data Type: bigint
    */
    get FiscalPeriod(): number | null {
        return this.Get('FiscalPeriod');
    }
    set FiscalPeriod(value: number | null) {
        this.Set('FiscalPeriod', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: UnitCost
    * * Display Name: Unit Cost
    * * SQL Data Type: decimal(19, 4)
    */
    get UnitCost(): number | null {
        return this.Get('UnitCost');
    }
    set UnitCost(value: number | null) {
        this.Set('UnitCost', value);
    }

    /**
    * * Field Name: Quantity
    * * Display Name: Quantity
    * * SQL Data Type: bigint
    */
    get Quantity(): number | null {
        return this.Get('Quantity');
    }
    set Quantity(value: number | null) {
        this.Set('Quantity', value);
    }

    /**
    * * Field Name: FulfillmentTransaction
    * * Display Name: Fulfillment Transaction
    * * SQL Data Type: uniqueidentifier
    */
    get FulfillmentTransaction(): string | null {
        return this.Get('FulfillmentTransaction');
    }
    set FulfillmentTransaction(value: string | null) {
        this.Set('FulfillmentTransaction', value);
    }

    /**
    * * Field Name: ReturnTransaction
    * * Display Name: Return Transaction
    * * SQL Data Type: uniqueidentifier
    */
    get ReturnTransaction(): string | null {
        return this.Get('ReturnTransaction');
    }
    set ReturnTransaction(value: string | null) {
        this.Set('ReturnTransaction', value);
    }

    /**
    * * Field Name: InventoryReceipt
    * * Display Name: Inventory Receipt
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryReceipt(): string | null {
        return this.Get('InventoryReceipt');
    }
    set InventoryReceipt(value: string | null) {
        this.Set('InventoryReceipt', value);
    }

    /**
    * * Field Name: TotalCost
    * * Display Name: Total Cost
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalCost(): number | null {
        return this.Get('TotalCost');
    }
    set TotalCost(value: number | null) {
        this.Set('TotalCost', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: nvarchar(500)
    */
    get Description(): string | null {
        return this.Get('Description');
    }
    set Description(value: string | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ParentCOGSEntry
    * * Display Name: Parent COGS Entry
    * * SQL Data Type: uniqueidentifier
    */
    get ParentCOGSEntry(): string | null {
        return this.Get('ParentCOGSEntry');
    }
    set ParentCOGSEntry(value: string | null) {
        this.Set('ParentCOGSEntry', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Cancellation Fee Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: CancellationFeeProduct
 * * Base View: vwCancellationFeeProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Cancellation Fee Products')
export class membersuiteCancellationFeeProductEntity extends BaseEntity<membersuiteCancellationFeeProductEntityType> {
    /**
    * Loads the MemberSuite: Cancellation Fee Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Cancellation Fee Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteCancellationFeeProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Change Memo Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: ChangeMemoLineItem
 * * Base View: vwChangeMemoLineItems
 * * Primary Key: invoiceLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Change Memo Line Items')
export class membersuiteChangeMemoLineItemEntity extends BaseEntity<membersuiteChangeMemoLineItemEntityType> {
    /**
    * Loads the MemberSuite: Change Memo Line Items record from the database
    * @param invoiceLineItemID: string - primary key value to load the MemberSuite: Change Memo Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteChangeMemoLineItemEntity
    * @method
    * @override
    */
    public async Load(invoiceLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'invoiceLineItemID', Value: invoiceLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: quantity
    * * Display Name: quantity
    * * SQL Data Type: bigint
    */
    get quantity(): number | null {
        return this.Get('quantity');
    }
    set quantity(value: number | null) {
        this.Set('quantity', value);
    }

    /**
    * * Field Name: invoiceLineItemID
    * * Display Name: invoice Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get invoiceLineItemID(): string {
        return this.Get('invoiceLineItemID');
    }
    set invoiceLineItemID(value: string) {
        this.Set('invoiceLineItemID', value);
    }

    /**
    * * Field Name: description
    * * Display Name: description
    * * SQL Data Type: nvarchar(500)
    */
    get description(): string | null {
        return this.Get('description');
    }
    set description(value: string | null) {
        this.Set('description', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Chapter Dues Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: ChapterDuesProduct
 * * Base View: vwChapterDuesProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Chapter Dues Products')
export class membersuiteChapterDuesProductEntity extends BaseEntity<membersuiteChapterDuesProductEntityType> {
    /**
    * Loads the MemberSuite: Chapter Dues Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Chapter Dues Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteChapterDuesProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: MembershipOrganization
    * * Display Name: Membership Organization
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipOrganization(): string | null {
        return this.Get('MembershipOrganization');
    }
    set MembershipOrganization(value: string | null) {
        this.Set('MembershipOrganization', value);
    }

    /**
    * * Field Name: Chapter
    * * Display Name: Chapter
    * * SQL Data Type: uniqueidentifier
    */
    get Chapter(): string | null {
        return this.Get('Chapter');
    }
    set Chapter(value: string | null) {
        this.Set('Chapter', value);
    }

    /**
    * * Field Name: MembershipType
    * * Display Name: Membership Type
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipType(): string | null {
        return this.Get('MembershipType');
    }
    set MembershipType(value: string | null) {
        this.Set('MembershipType', value);
    }

    /**
    * * Field Name: RenewsWith
    * * Display Name: Renews With
    * * SQL Data Type: uniqueidentifier
    */
    get RenewsWith(): string | null {
        return this.Get('RenewsWith');
    }
    set RenewsWith(value: string | null) {
        this.Set('RenewsWith', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Credit Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: CreditLineItem
 * * Base View: vwCreditLineItems
 * * Primary Key: paymentLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Credit Line Items')
export class membersuiteCreditLineItemEntity extends BaseEntity<membersuiteCreditLineItemEntityType> {
    /**
    * Loads the MemberSuite: Credit Line Items record from the database
    * @param paymentLineItemID: string - primary key value to load the MemberSuite: Credit Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteCreditLineItemEntity
    * @method
    * @override
    */
    public async Load(paymentLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'paymentLineItemID', Value: paymentLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: paymentLineItemID
    * * Display Name: payment Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get paymentLineItemID(): string {
        return this.Get('paymentLineItemID');
    }
    set paymentLineItemID(value: string) {
        this.Set('paymentLineItemID', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: Credit
    * * Display Name: Credit
    * * SQL Data Type: uniqueidentifier
    */
    get Credit(): string | null {
        return this.Get('Credit');
    }
    set Credit(value: string | null) {
        this.Set('Credit', value);
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Credit Memos - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: CreditMemo
 * * Base View: vwCreditMemos
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Credit Memos')
export class membersuiteCreditMemoEntity extends BaseEntity<membersuiteCreditMemoEntityType> {
    /**
    * Loads the MemberSuite: Credit Memos record from the database
    * @param ID: string - primary key value to load the MemberSuite: Credit Memos record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteCreditMemoEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: Invoice
    * * Display Name: Invoice
    * * SQL Data Type: uniqueidentifier
    */
    get Invoice(): string | null {
        return this.Get('Invoice');
    }
    set Invoice(value: string | null) {
        this.Set('Invoice', value);
    }

    /**
    * * Field Name: ExchangeRate
    * * Display Name: Exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get ExchangeRate(): number | null {
        return this.Get('ExchangeRate');
    }
    set ExchangeRate(value: number | null) {
        this.Set('ExchangeRate', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Credits - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Credit
 * * Base View: vwCredits
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Credits')
export class membersuiteCreditEntity extends BaseEntity<membersuiteCreditEntityType> {
    /**
    * Loads the MemberSuite: Credits record from the database
    * @param ID: string - primary key value to load the MemberSuite: Credits record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteCreditEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: LiabilityGLAccount
    * * Display Name: Liability GL Account
    * * SQL Data Type: nvarchar(500)
    */
    get LiabilityGLAccount(): string | null {
        return this.Get('LiabilityGLAccount');
    }
    set LiabilityGLAccount(value: string | null) {
        this.Set('LiabilityGLAccount', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: InvoiceInstructions
    * * Display Name: Invoice Instructions
    * * SQL Data Type: nvarchar(100)
    */
    get InvoiceInstructions(): string | null {
        return this.Get('InvoiceInstructions');
    }
    set InvoiceInstructions(value: string | null) {
        this.Set('InvoiceInstructions', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: AmountUsed
    * * Display Name: Amount Used
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountUsed(): number | null {
        return this.Get('AmountUsed');
    }
    set AmountUsed(value: number | null) {
        this.Set('AmountUsed', value);
    }

    /**
    * * Field Name: Owner
    * * Display Name: Owner
    * * SQL Data Type: uniqueidentifier
    */
    get Owner(): string | null {
        return this.Get('Owner');
    }
    set Owner(value: string | null) {
        this.Set('Owner', value);
    }

    /**
    * * Field Name: PaymentLineItemID
    * * Display Name: Payment Line Item ID
    * * SQL Data Type: nvarchar(500)
    */
    get PaymentLineItemID(): string | null {
        return this.Get('PaymentLineItemID');
    }
    set PaymentLineItemID(value: string | null) {
        this.Set('PaymentLineItemID', value);
    }

    /**
    * * Field Name: Payment
    * * Display Name: Payment
    * * SQL Data Type: uniqueidentifier
    */
    get Payment(): string | null {
        return this.Get('Payment');
    }
    set Payment(value: string | null) {
        this.Set('Payment', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: TransactionID
    * * Display Name: Transaction ID
    * * SQL Data Type: nvarchar(500)
    */
    get TransactionID(): string | null {
        return this.Get('TransactionID');
    }
    set TransactionID(value: string | null) {
        this.Set('TransactionID', value);
    }

    /**
    * * Field Name: ExchangeRate
    * * Display Name: Exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get ExchangeRate(): number | null {
        return this.Get('ExchangeRate');
    }
    set ExchangeRate(value: number | null) {
        this.Set('ExchangeRate', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Debit Memos - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: DebitMemo
 * * Base View: vwDebitMemos
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Debit Memos')
export class membersuiteDebitMemoEntity extends BaseEntity<membersuiteDebitMemoEntityType> {
    /**
    * Loads the MemberSuite: Debit Memos record from the database
    * @param ID: string - primary key value to load the MemberSuite: Debit Memos record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteDebitMemoEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: Invoice
    * * Display Name: Invoice
    * * SQL Data Type: uniqueidentifier
    */
    get Invoice(): string | null {
        return this.Get('Invoice');
    }
    set Invoice(value: string | null) {
        this.Set('Invoice', value);
    }

    /**
    * * Field Name: ExchangeRate
    * * Display Name: Exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get ExchangeRate(): number | null {
        return this.Get('ExchangeRate');
    }
    set ExchangeRate(value: number | null) {
        this.Set('ExchangeRate', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Discount Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: DiscountProduct
 * * Base View: vwDiscountProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Discount Products')
export class membersuiteDiscountProductEntity extends BaseEntity<membersuiteDiscountProductEntityType> {
    /**
    * Loads the MemberSuite: Discount Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Discount Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteDiscountProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Due To Due From Entries - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: DueToDueFromEntry
 * * Base View: vwDueToDueFromEntries
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Due To Due From Entries')
export class membersuiteDueToDueFromEntryEntity extends BaseEntity<membersuiteDueToDueFromEntryEntityType> {
    /**
    * Loads the MemberSuite: Due To Due From Entries record from the database
    * @param ID: string - primary key value to load the MemberSuite: Due To Due From Entries record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteDueToDueFromEntryEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: FromBusinessUnit
    * * Display Name: From Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get FromBusinessUnit(): string | null {
        return this.Get('FromBusinessUnit');
    }
    set FromBusinessUnit(value: string | null) {
        this.Set('FromBusinessUnit', value);
    }

    /**
    * * Field Name: ToBusinessUnit
    * * Display Name: To Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get ToBusinessUnit(): string | null {
        return this.Get('ToBusinessUnit');
    }
    set ToBusinessUnit(value: string | null) {
        this.Set('ToBusinessUnit', value);
    }

    /**
    * * Field Name: AccountsReceivableAccount
    * * Display Name: Accounts Receivable Account
    * * SQL Data Type: uniqueidentifier
    */
    get AccountsReceivableAccount(): string | null {
        return this.Get('AccountsReceivableAccount');
    }
    set AccountsReceivableAccount(value: string | null) {
        this.Set('AccountsReceivableAccount', value);
    }

    /**
    * * Field Name: LiabilityAccount
    * * Display Name: Liability Account
    * * SQL Data Type: uniqueidentifier
    */
    get LiabilityAccount(): string | null {
        return this.Get('LiabilityAccount');
    }
    set LiabilityAccount(value: string | null) {
        this.Set('LiabilityAccount', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Fiscal Years - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: FiscalYear
 * * Base View: vwFiscalYears
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Fiscal Years')
export class membersuiteFiscalYearEntity extends BaseEntity<membersuiteFiscalYearEntityType> {
    /**
    * Loads the MemberSuite: Fiscal Years record from the database
    * @param ID: string - primary key value to load the MemberSuite: Fiscal Years record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteFiscalYearEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: Year
    * * Display Name: Year
    * * SQL Data Type: bigint
    */
    get Year(): number | null {
        return this.Get('Year');
    }
    set Year(value: number | null) {
        this.Set('Year', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: IsClosed
    * * Display Name: Is Closed
    * * SQL Data Type: bit
    */
    get IsClosed(): boolean | null {
        return this.Get('IsClosed');
    }
    set IsClosed(value: boolean | null) {
        this.Set('IsClosed', value);
    }

    /**
    * * Field Name: ClosedBy
    * * Display Name: Closed By
    * * SQL Data Type: uniqueidentifier
    */
    get ClosedBy(): string | null {
        return this.Get('ClosedBy');
    }
    set ClosedBy(value: string | null) {
        this.Set('ClosedBy', value);
    }

    /**
    * * Field Name: StartDate
    * * Display Name: Start Date
    * * SQL Data Type: date
    */
    get StartDate(): Date | null {
        return this.Get('StartDate');
    }
    set StartDate(value: Date | null) {
        this.Set('StartDate', value);
    }

    /**
    * * Field Name: EndDate
    * * Display Name: End Date
    * * SQL Data Type: date
    */
    get EndDate(): Date | null {
        return this.Get('EndDate');
    }
    set EndDate(value: Date | null) {
        this.Set('EndDate', value);
    }

    /**
    * * Field Name: ClosedByName
    * * Display Name: Closed By Name
    * * SQL Data Type: nvarchar(500)
    */
    get ClosedByName(): string | null {
        return this.Get('ClosedByName');
    }
    set ClosedByName(value: string | null) {
        this.Set('ClosedByName', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Fundraising Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: FundraisingProduct
 * * Base View: vwFundraisingProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Fundraising Products')
export class membersuiteFundraisingProductEntity extends BaseEntity<membersuiteFundraisingProductEntityType> {
    /**
    * Loads the MemberSuite: Fundraising Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Fundraising Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteFundraisingProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: Campaign
    * * Display Name: Campaign
    * * SQL Data Type: uniqueidentifier
    */
    get Campaign(): string | null {
        return this.Get('Campaign');
    }
    set Campaign(value: string | null) {
        this.Set('Campaign', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Appeal
    * * Display Name: Appeal
    * * SQL Data Type: uniqueidentifier
    */
    get Appeal(): string | null {
        return this.Get('Appeal');
    }
    set Appeal(value: string | null) {
        this.Set('Appeal', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: GiftSubType
    * * Display Name: Gift Sub Type
    * * SQL Data Type: uniqueidentifier
    */
    get GiftSubType(): string | null {
        return this.Get('GiftSubType');
    }
    set GiftSubType(value: string | null) {
        this.Set('GiftSubType', value);
    }

    /**
    * * Field Name: Fund
    * * Display Name: Fund
    * * SQL Data Type: uniqueidentifier
    */
    get Fund(): string | null {
        return this.Get('Fund');
    }
    set Fund(value: string | null) {
        this.Set('Fund', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: GL Accounts - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: GLAccount
 * * Base View: vwGLAccounts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: GL Accounts')
export class membersuiteGLAccountEntity extends BaseEntity<membersuiteGLAccountEntityType> {
    /**
    * Loads the MemberSuite: GL Accounts record from the database
    * @param ID: string - primary key value to load the MemberSuite: GL Accounts record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteGLAccountEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: nvarchar(500)
    */
    get Description(): string | null {
        return this.Get('Description');
    }
    set Description(value: string | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Individuals - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Individual
 * * Base View: vwIndividuals
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Individuals')
export class membersuiteIndividualEntity extends BaseEntity<membersuiteIndividualEntityType> {
    /**
    * Loads the MemberSuite: Individuals record from the database
    * @param ID: string - primary key value to load the MemberSuite: Individuals record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteIndividualEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Nickname
    * * Display Name: Nickname
    * * SQL Data Type: nvarchar(500)
    */
    get Nickname(): string | null {
        return this.Get('Nickname');
    }
    set Nickname(value: string | null) {
        this.Set('Nickname', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: MiddleName
    * * Display Name: Middle Name
    * * SQL Data Type: nvarchar(500)
    */
    get MiddleName(): string | null {
        return this.Get('MiddleName');
    }
    set MiddleName(value: string | null) {
        this.Set('MiddleName', value);
    }

    /**
    * * Field Name: EmailAddress
    * * Display Name: Email Address
    * * SQL Data Type: nvarchar(256)
    */
    get EmailAddress(): string | null {
        return this.Get('EmailAddress');
    }
    set EmailAddress(value: string | null) {
        this.Set('EmailAddress', value);
    }

    /**
    * * Field Name: FirstName
    * * Display Name: First Name
    * * SQL Data Type: nvarchar(500)
    */
    get FirstName(): string | null {
        return this.Get('FirstName');
    }
    set FirstName(value: string | null) {
        this.Set('FirstName', value);
    }

    /**
    * * Field Name: LastName
    * * Display Name: Last Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastName(): string | null {
        return this.Get('LastName');
    }
    set LastName(value: string | null) {
        this.Set('LastName', value);
    }

    /**
    * * Field Name: PaymentGatewayID
    * * Display Name: Payment Gateway ID
    * * SQL Data Type: nvarchar(500)
    */
    get PaymentGatewayID(): string | null {
        return this.Get('PaymentGatewayID');
    }
    set PaymentGatewayID(value: string | null) {
        this.Set('PaymentGatewayID', value);
    }

    /**
    * * Field Name: Status
    * * Display Name: Status
    * * SQL Data Type: uniqueidentifier
    */
    get Status(): string | null {
        return this.Get('Status');
    }
    set Status(value: string | null) {
        this.Set('Status', value);
    }

    /**
    * * Field Name: IneligibleFunds
    * * Display Name: Ineligible Funds
    * * SQL Data Type: uniqueidentifier
    */
    get IneligibleFunds(): string | null {
        return this.Get('IneligibleFunds');
    }
    set IneligibleFunds(value: string | null) {
        this.Set('IneligibleFunds', value);
    }

    /**
    * * Field Name: TaxExempt
    * * Display Name: Tax Exempt
    * * SQL Data Type: bit
    */
    get TaxExempt(): boolean | null {
        return this.Get('TaxExempt');
    }
    set TaxExempt(value: boolean | null) {
        this.Set('TaxExempt', value);
    }

    /**
    * * Field Name: DefaultCreditTerms
    * * Display Name: Default Credit Terms
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultCreditTerms(): string | null {
        return this.Get('DefaultCreditTerms');
    }
    set DefaultCreditTerms(value: string | null) {
        this.Set('DefaultCreditTerms', value);
    }

    /**
    * * Field Name: PreferredAddressType
    * * Display Name: Preferred Address Type
    * * SQL Data Type: uniqueidentifier
    */
    get PreferredAddressType(): string | null {
        return this.Get('PreferredAddressType');
    }
    set PreferredAddressType(value: string | null) {
        this.Set('PreferredAddressType', value);
    }

    /**
    * * Field Name: PreferredPhoneNumberType
    * * Display Name: Preferred Phone Number Type
    * * SQL Data Type: uniqueidentifier
    */
    get PreferredPhoneNumberType(): string | null {
        return this.Get('PreferredPhoneNumberType');
    }
    set PreferredPhoneNumberType(value: string | null) {
        this.Set('PreferredPhoneNumberType', value);
    }

    /**
    * * Field Name: DonorLevel
    * * Display Name: Donor Level
    * * SQL Data Type: uniqueidentifier
    */
    get DonorLevel(): string | null {
        return this.Get('DonorLevel');
    }
    set DonorLevel(value: string | null) {
        this.Set('DonorLevel', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: WebSite
    * * Display Name: Web Site
    * * SQL Data Type: nvarchar(512)
    */
    get WebSite(): string | null {
        return this.Get('WebSite');
    }
    set WebSite(value: string | null) {
        this.Set('WebSite', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: NRDSID
    * * Display Name: Nrdsid
    * * SQL Data Type: bigint
    */
    get NRDSID(): number | null {
        return this.Get('NRDSID');
    }
    set NRDSID(value: number | null) {
        this.Set('NRDSID', value);
    }

    /**
    * * Field Name: FacebookProfile
    * * Display Name: Facebook Profile
    * * SQL Data Type: nvarchar(500)
    */
    get FacebookProfile(): string | null {
        return this.Get('FacebookProfile');
    }
    set FacebookProfile(value: string | null) {
        this.Set('FacebookProfile', value);
    }

    /**
    * * Field Name: FacebookId
    * * Display Name: Facebook Id
    * * SQL Data Type: nvarchar(500)
    */
    get FacebookId(): string | null {
        return this.Get('FacebookId');
    }
    set FacebookId(value: string | null) {
        this.Set('FacebookId', value);
    }

    /**
    * * Field Name: TwitterHandle
    * * Display Name: Twitter Handle
    * * SQL Data Type: nvarchar(500)
    */
    get TwitterHandle(): string | null {
        return this.Get('TwitterHandle');
    }
    set TwitterHandle(value: string | null) {
        this.Set('TwitterHandle', value);
    }

    /**
    * * Field Name: TwitterId
    * * Display Name: Twitter Id
    * * SQL Data Type: nvarchar(500)
    */
    get TwitterId(): string | null {
        return this.Get('TwitterId');
    }
    set TwitterId(value: string | null) {
        this.Set('TwitterId', value);
    }

    /**
    * * Field Name: LinkedInProfile
    * * Display Name: Linked In Profile
    * * SQL Data Type: nvarchar(500)
    */
    get LinkedInProfile(): string | null {
        return this.Get('LinkedInProfile');
    }
    set LinkedInProfile(value: string | null) {
        this.Set('LinkedInProfile', value);
    }

    /**
    * * Field Name: LinkedInId
    * * Display Name: Linked In Id
    * * SQL Data Type: nvarchar(500)
    */
    get LinkedInId(): string | null {
        return this.Get('LinkedInId');
    }
    set LinkedInId(value: string | null) {
        this.Set('LinkedInId', value);
    }

    /**
    * * Field Name: GooglePlusUrl
    * * Display Name: Google Plus Url
    * * SQL Data Type: nvarchar(500)
    */
    get GooglePlusUrl(): string | null {
        return this.Get('GooglePlusUrl');
    }
    set GooglePlusUrl(value: string | null) {
        this.Set('GooglePlusUrl', value);
    }

    /**
    * * Field Name: GooglePlusId
    * * Display Name: Google Plus Id
    * * SQL Data Type: nvarchar(500)
    */
    get GooglePlusId(): string | null {
        return this.Get('GooglePlusId');
    }
    set GooglePlusId(value: string | null) {
        this.Set('GooglePlusId', value);
    }

    /**
    * * Field Name: InstagramProfile
    * * Display Name: Instagram Profile
    * * SQL Data Type: nvarchar(500)
    */
    get InstagramProfile(): string | null {
        return this.Get('InstagramProfile');
    }
    set InstagramProfile(value: string | null) {
        this.Set('InstagramProfile', value);
    }

    /**
    * * Field Name: InstagramId
    * * Display Name: Instagram Id
    * * SQL Data Type: nvarchar(500)
    */
    get InstagramId(): string | null {
        return this.Get('InstagramId');
    }
    set InstagramId(value: string | null) {
        this.Set('InstagramId', value);
    }

    /**
    * * Field Name: DoNotEmail
    * * Display Name: Do Not Email
    * * SQL Data Type: bit
    */
    get DoNotEmail(): boolean | null {
        return this.Get('DoNotEmail');
    }
    set DoNotEmail(value: boolean | null) {
        this.Set('DoNotEmail', value);
    }

    /**
    * * Field Name: CommunicationsLastVerified
    * * Display Name: Communications Last Verified
    * * SQL Data Type: datetime2
    */
    get CommunicationsLastVerified(): Date | null {
        return this.Get('CommunicationsLastVerified');
    }
    set CommunicationsLastVerified(value: Date | null) {
        this.Set('CommunicationsLastVerified', value);
    }

    /**
    * * Field Name: CommunicationsLastVerifiedFrom
    * * Display Name: Communications Last Verified From
    * * SQL Data Type: nvarchar(500)
    */
    get CommunicationsLastVerifiedFrom(): string | null {
        return this.Get('CommunicationsLastVerifiedFrom');
    }
    set CommunicationsLastVerifiedFrom(value: string | null) {
        this.Set('CommunicationsLastVerifiedFrom', value);
    }

    /**
    * * Field Name: DoNotFax
    * * Display Name: Do Not Fax
    * * SQL Data Type: bit
    */
    get DoNotFax(): boolean | null {
        return this.Get('DoNotFax');
    }
    set DoNotFax(value: boolean | null) {
        this.Set('DoNotFax', value);
    }

    /**
    * * Field Name: DoNotMail
    * * Display Name: Do Not Mail
    * * SQL Data Type: bit
    */
    get DoNotMail(): boolean | null {
        return this.Get('DoNotMail');
    }
    set DoNotMail(value: boolean | null) {
        this.Set('DoNotMail', value);
    }

    /**
    * * Field Name: Age
    * * Display Name: Age
    * * SQL Data Type: bigint
    */
    get Age(): number | null {
        return this.Get('Age');
    }
    set Age(value: number | null) {
        this.Set('Age', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: uniqueidentifier
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: DateOfBirth
    * * Display Name: Date Of Birth
    * * SQL Data Type: date
    */
    get DateOfBirth(): Date | null {
        return this.Get('DateOfBirth');
    }
    set DateOfBirth(value: Date | null) {
        this.Set('DateOfBirth', value);
    }

    /**
    * * Field Name: EmailAddress2
    * * Display Name: Email Address 2
    * * SQL Data Type: nvarchar(256)
    */
    get EmailAddress2(): string | null {
        return this.Get('EmailAddress2');
    }
    set EmailAddress2(value: string | null) {
        this.Set('EmailAddress2', value);
    }

    /**
    * * Field Name: EmailAddress3
    * * Display Name: Email Address 3
    * * SQL Data Type: nvarchar(256)
    */
    get EmailAddress3(): string | null {
        return this.Get('EmailAddress3');
    }
    set EmailAddress3(value: string | null) {
        this.Set('EmailAddress3', value);
    }

    /**
    * * Field Name: Title
    * * Display Name: Title
    * * SQL Data Type: nvarchar(500)
    */
    get Title(): string | null {
        return this.Get('Title');
    }
    set Title(value: string | null) {
        this.Set('Title', value);
    }

    /**
    * * Field Name: Prefix
    * * Display Name: Prefix
    * * SQL Data Type: nvarchar(500)
    */
    get Prefix(): string | null {
        return this.Get('Prefix');
    }
    set Prefix(value: string | null) {
        this.Set('Prefix', value);
    }

    /**
    * * Field Name: Suffix
    * * Display Name: Suffix
    * * SQL Data Type: nvarchar(500)
    */
    get Suffix(): string | null {
        return this.Get('Suffix');
    }
    set Suffix(value: string | null) {
        this.Set('Suffix', value);
    }

    /**
    * * Field Name: Designation
    * * Display Name: Designation
    * * SQL Data Type: nvarchar(500)
    */
    get Designation(): string | null {
        return this.Get('Designation');
    }
    set Designation(value: string | null) {
        this.Set('Designation', value);
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(500)
    */
    get Company(): string | null {
        return this.Get('Company');
    }
    set Company(value: string | null) {
        this.Set('Company', value);
    }

    /**
    * * Field Name: SeasonalAddressStart
    * * Display Name: Seasonal Address Start
    * * SQL Data Type: date
    */
    get SeasonalAddressStart(): Date | null {
        return this.Get('SeasonalAddressStart');
    }
    set SeasonalAddressStart(value: Date | null) {
        this.Set('SeasonalAddressStart', value);
    }

    /**
    * * Field Name: SeasonalAddressEnd
    * * Display Name: Seasonal Address End
    * * SQL Data Type: date
    */
    get SeasonalAddressEnd(): Date | null {
        return this.Get('SeasonalAddressEnd');
    }
    set SeasonalAddressEnd(value: Date | null) {
        this.Set('SeasonalAddressEnd', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: SortName
    * * Display Name: Sort Name
    * * SQL Data Type: nvarchar(500)
    */
    get SortName(): string | null {
        return this.Get('SortName');
    }
    set SortName(value: string | null) {
        this.Set('SortName', value);
    }

    /**
    * * Field Name: Image
    * * Display Name: Image
    * * SQL Data Type: decimal(19, 4)
    */
    get Image(): number | null {
        return this.Get('Image');
    }
    set Image(value: number | null) {
        this.Set('Image', value);
    }

    /**
    * * Field Name: PrimaryOrganization__rtg
    * * Display Name: Primary Organization Rtg
    * * SQL Data Type: uniqueidentifier
    */
    get PrimaryOrganization__rtg(): string | null {
        return this.Get('PrimaryOrganization__rtg');
    }
    set PrimaryOrganization__rtg(value: string | null) {
        this.Set('PrimaryOrganization__rtg', value);
    }

    /**
    * * Field Name: Gender__c
    * * Display Name: Gender C
    * * SQL Data Type: nvarchar(500)
    */
    get Gender__c(): string | null {
        return this.Get('Gender__c');
    }
    set Gender__c(value: string | null) {
        this.Set('Gender__c', value);
    }

    /**
    * * Field Name: SpouseName__c
    * * Display Name: Spouse Name C
    * * SQL Data Type: nvarchar(500)
    */
    get SpouseName__c(): string | null {
        return this.Get('SpouseName__c');
    }
    set SpouseName__c(value: string | null) {
        this.Set('SpouseName__c', value);
    }

    /**
    * * Field Name: Bio__c
    * * Display Name: Bio C
    * * SQL Data Type: nvarchar(MAX)
    */
    get Bio__c(): string | null {
        return this.Get('Bio__c');
    }
    set Bio__c(value: string | null) {
        this.Set('Bio__c', value);
    }

    /**
    * * Field Name: MaritalStatus__c
    * * Display Name: Marital Status C
    * * SQL Data Type: nvarchar(500)
    */
    get MaritalStatus__c(): string | null {
        return this.Get('MaritalStatus__c');
    }
    set MaritalStatus__c(value: string | null) {
        this.Set('MaritalStatus__c', value);
    }

    /**
    * * Field Name: MembershipCategory__c
    * * Display Name: Membership Category C
    * * SQL Data Type: nvarchar(500)
    */
    get MembershipCategory__c(): string | null {
        return this.Get('MembershipCategory__c');
    }
    set MembershipCategory__c(value: string | null) {
        this.Set('MembershipCategory__c', value);
    }

    /**
    * * Field Name: NRDSID__c
    * * Display Name: Nrdsid C
    * * SQL Data Type: nvarchar(500)
    */
    get NRDSID__c(): string | null {
        return this.Get('NRDSID__c');
    }
    set NRDSID__c(value: string | null) {
        this.Set('NRDSID__c', value);
    }

    /**
    * * Field Name: IsRetired__c
    * * Display Name: Is Retired C
    * * SQL Data Type: bit
    */
    get IsRetired__c(): boolean | null {
        return this.Get('IsRetired__c');
    }
    set IsRetired__c(value: boolean | null) {
        this.Set('IsRetired__c', value);
    }

    /**
    * * Field Name: TerminationDate__c
    * * Display Name: Termination Date C
    * * SQL Data Type: date
    */
    get TerminationDate__c(): Date | null {
        return this.Get('TerminationDate__c');
    }
    set TerminationDate__c(value: Date | null) {
        this.Set('TerminationDate__c', value);
    }

    /**
    * * Field Name: LastDuesPaymentDate__c
    * * Display Name: Last Dues Payment Date C
    * * SQL Data Type: date
    */
    get LastDuesPaymentDate__c(): Date | null {
        return this.Get('LastDuesPaymentDate__c');
    }
    set LastDuesPaymentDate__c(value: Date | null) {
        this.Set('LastDuesPaymentDate__c', value);
    }

    /**
    * * Field Name: OriginalJoinDate__c
    * * Display Name: Original Join Date C
    * * SQL Data Type: date
    */
    get OriginalJoinDate__c(): Date | null {
        return this.Get('OriginalJoinDate__c');
    }
    set OriginalJoinDate__c(value: Date | null) {
        this.Set('OriginalJoinDate__c', value);
    }

    /**
    * * Field Name: DoNotCall__c
    * * Display Name: Do Not Call C
    * * SQL Data Type: bit
    */
    get DoNotCall__c(): boolean | null {
        return this.Get('DoNotCall__c');
    }
    set DoNotCall__c(value: boolean | null) {
        this.Set('DoNotCall__c', value);
    }

    /**
    * * Field Name: WhyCreatingAccount_Other__c
    * * Display Name: Why Creating Account Other C
    * * SQL Data Type: nvarchar(500)
    */
    get WhyCreatingAccount_Other__c(): string | null {
        return this.Get('WhyCreatingAccount_Other__c');
    }
    set WhyCreatingAccount_Other__c(value: string | null) {
        this.Set('WhyCreatingAccount_Other__c', value);
    }

    /**
    * * Field Name: SchoolAttending__c
    * * Display Name: School Attending C
    * * SQL Data Type: nvarchar(500)
    */
    get SchoolAttending__c(): string | null {
        return this.Get('SchoolAttending__c');
    }
    set SchoolAttending__c(value: string | null) {
        this.Set('SchoolAttending__c', value);
    }

    /**
    * * Field Name: AnticipatedGradDate__c
    * * Display Name: Anticipated Grad Date C
    * * SQL Data Type: date
    */
    get AnticipatedGradDate__c(): Date | null {
        return this.Get('AnticipatedGradDate__c');
    }
    set AnticipatedGradDate__c(value: Date | null) {
        this.Set('AnticipatedGradDate__c', value);
    }

    /**
    * * Field Name: Major__c
    * * Display Name: Major C
    * * SQL Data Type: nvarchar(500)
    */
    get Major__c(): string | null {
        return this.Get('Major__c');
    }
    set Major__c(value: string | null) {
        this.Set('Major__c', value);
    }

    /**
    * * Field Name: Placeholder_DoNOTDelete__c
    * * Display Name: Placeholder Do NOT Delete C
    * * SQL Data Type: nvarchar(500)
    */
    get Placeholder_DoNOTDelete__c(): string | null {
        return this.Get('Placeholder_DoNOTDelete__c');
    }
    set Placeholder_DoNOTDelete__c(value: string | null) {
        this.Set('Placeholder_DoNOTDelete__c', value);
    }

    /**
    * * Field Name: AreasofPractice__c
    * * Display Name: Areasof Practice C
    * * SQL Data Type: nvarchar(500)
    */
    get AreasofPractice__c(): string | null {
        return this.Get('AreasofPractice__c');
    }
    set AreasofPractice__c(value: string | null) {
        this.Set('AreasofPractice__c', value);
    }

    /**
    * * Field Name: SIOR_Dues_Paid_Through__c
    * * Display Name: Sior Dues Paid Through C
    * * SQL Data Type: date
    */
    get SIOR_Dues_Paid_Through__c(): Date | null {
        return this.Get('SIOR_Dues_Paid_Through__c');
    }
    set SIOR_Dues_Paid_Through__c(value: Date | null) {
        this.Set('SIOR_Dues_Paid_Through__c', value);
    }

    /**
    * * Field Name: SIORFunctionRole__c
    * * Display Name: SIOR Function Role C
    * * SQL Data Type: nvarchar(500)
    */
    get SIORFunctionRole__c(): string | null {
        return this.Get('SIORFunctionRole__c');
    }
    set SIORFunctionRole__c(value: string | null) {
        this.Set('SIORFunctionRole__c', value);
    }

    /**
    * * Field Name: SIOR_Join_Date__c
    * * Display Name: Sior Join Date C
    * * SQL Data Type: date
    */
    get SIOR_Join_Date__c(): Date | null {
        return this.Get('SIOR_Join_Date__c');
    }
    set SIOR_Join_Date__c(value: Date | null) {
        this.Set('SIOR_Join_Date__c', value);
    }

    /**
    * * Field Name: Home_Address
    * * Display Name: Home Address
    * * SQL Data Type: nvarchar(500)
    */
    get Home_Address(): string | null {
        return this.Get('Home_Address');
    }
    set Home_Address(value: string | null) {
        this.Set('Home_Address', value);
    }

    /**
    * * Field Name: Work_Address
    * * Display Name: Work Address
    * * SQL Data Type: nvarchar(500)
    */
    get Work_Address(): string | null {
        return this.Get('Work_Address');
    }
    set Work_Address(value: string | null) {
        this.Set('Work_Address', value);
    }

    /**
    * * Field Name: Mobile_PhoneNumber
    * * Display Name: Mobile Phone Number
    * * SQL Data Type: nvarchar(64)
    */
    get Mobile_PhoneNumber(): string | null {
        return this.Get('Mobile_PhoneNumber');
    }
    set Mobile_PhoneNumber(value: string | null) {
        this.Set('Mobile_PhoneNumber', value);
    }

    /**
    * * Field Name: Work_PhoneNumber
    * * Display Name: Work Phone Number
    * * SQL Data Type: nvarchar(64)
    */
    get Work_PhoneNumber(): string | null {
        return this.Get('Work_PhoneNumber');
    }
    set Work_PhoneNumber(value: string | null) {
        this.Set('Work_PhoneNumber', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company_Virtual
    * * Display Name: Company Virtual
    * * SQL Data Type: nvarchar(50)
    */
    get Company_Virtual(): string {
        return this.Get('Company_Virtual');
    }
}


/**
 * MemberSuite: Invoice Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: InvoiceLineItem
 * * Base View: vwInvoiceLineItems
 * * Primary Key: invoiceLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Invoice Line Items')
export class membersuiteInvoiceLineItemEntity extends BaseEntity<membersuiteInvoiceLineItemEntityType> {
    /**
    * Loads the MemberSuite: Invoice Line Items record from the database
    * @param invoiceLineItemID: string - primary key value to load the MemberSuite: Invoice Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteInvoiceLineItemEntity
    * @method
    * @override
    */
    public async Load(invoiceLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'invoiceLineItemID', Value: invoiceLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: invoiceLineItemID
    * * Display Name: invoice Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get invoiceLineItemID(): string {
        return this.Get('invoiceLineItemID');
    }
    set invoiceLineItemID(value: string) {
        this.Set('invoiceLineItemID', value);
    }

    /**
    * * Field Name: orderLineItemID
    * * Display Name: order Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get orderLineItemID(): string | null {
        return this.Get('orderLineItemID');
    }
    set orderLineItemID(value: string | null) {
        this.Set('orderLineItemID', value);
    }

    /**
    * * Field Name: isVoid
    * * Display Name: is Void
    * * SQL Data Type: bit
    */
    get isVoid(): boolean | null {
        return this.Get('isVoid');
    }
    set isVoid(value: boolean | null) {
        this.Set('isVoid', value);
    }

    /**
    * * Field Name: originalTotal
    * * Display Name: original Total
    * * SQL Data Type: decimal(19, 4)
    */
    get originalTotal(): number | null {
        return this.Get('originalTotal');
    }
    set originalTotal(value: number | null) {
        this.Set('originalTotal', value);
    }

    /**
    * * Field Name: arglAccount
    * * Display Name: argl Account
    * * SQL Data Type: nvarchar(500)
    */
    get arglAccount(): string | null {
        return this.Get('arglAccount');
    }
    set arglAccount(value: string | null) {
        this.Set('arglAccount', value);
    }

    /**
    * * Field Name: accountingProject
    * * Display Name: accounting Project
    * * SQL Data Type: nvarchar(500)
    */
    get accountingProject(): string | null {
        return this.Get('accountingProject');
    }
    set accountingProject(value: string | null) {
        this.Set('accountingProject', value);
    }

    /**
    * * Field Name: revenueGLAccount
    * * Display Name: revenue GL Account
    * * SQL Data Type: nvarchar(500)
    */
    get revenueGLAccount(): string | null {
        return this.Get('revenueGLAccount');
    }
    set revenueGLAccount(value: string | null) {
        this.Set('revenueGLAccount', value);
    }

    /**
    * * Field Name: hasBeenCOGSRecognized
    * * Display Name: has Been COGS Recognized
    * * SQL Data Type: bit
    */
    get hasBeenCOGSRecognized(): boolean | null {
        return this.Get('hasBeenCOGSRecognized');
    }
    set hasBeenCOGSRecognized(value: boolean | null) {
        this.Set('hasBeenCOGSRecognized', value);
    }

    /**
    * * Field Name: billingScheduleEntryID
    * * Display Name: billing Schedule Entry ID
    * * SQL Data Type: nvarchar(500)
    */
    get billingScheduleEntryID(): string | null {
        return this.Get('billingScheduleEntryID');
    }
    set billingScheduleEntryID(value: string | null) {
        this.Set('billingScheduleEntryID', value);
    }

    /**
    * * Field Name: optional
    * * Display Name: optional
    * * SQL Data Type: bit
    */
    get optional(): boolean | null {
        return this.Get('optional');
    }
    set optional(value: boolean | null) {
        this.Set('optional', value);
    }

    /**
    * * Field Name: revenueRecognitionTemplate
    * * Display Name: revenue Recognition Template
    * * SQL Data Type: nvarchar(500)
    */
    get revenueRecognitionTemplate(): string | null {
        return this.Get('revenueRecognitionTemplate');
    }
    set revenueRecognitionTemplate(value: string | null) {
        this.Set('revenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: amountPaid
    * * Display Name: amount Paid
    * * SQL Data Type: decimal(19, 4)
    */
    get amountPaid(): number | null {
        return this.Get('amountPaid');
    }
    set amountPaid(value: number | null) {
        this.Set('amountPaid', value);
    }

    /**
    * * Field Name: balanceDue
    * * Display Name: balance Due
    * * SQL Data Type: decimal(19, 4)
    */
    get balanceDue(): number | null {
        return this.Get('balanceDue');
    }
    set balanceDue(value: number | null) {
        this.Set('balanceDue', value);
    }

    /**
    * * Field Name: amountWrittenOff
    * * Display Name: amount Written Off
    * * SQL Data Type: decimal(19, 4)
    */
    get amountWrittenOff(): number | null {
        return this.Get('amountWrittenOff');
    }
    set amountWrittenOff(value: number | null) {
        this.Set('amountWrittenOff', value);
    }

    /**
    * * Field Name: amountRefunded
    * * Display Name: amount Refunded
    * * SQL Data Type: decimal(19, 4)
    */
    get amountRefunded(): number | null {
        return this.Get('amountRefunded');
    }
    set amountRefunded(value: number | null) {
        this.Set('amountRefunded', value);
    }

    /**
    * * Field Name: lateFeeRule
    * * Display Name: late Fee Rule
    * * SQL Data Type: nvarchar(500)
    */
    get lateFeeRule(): string | null {
        return this.Get('lateFeeRule');
    }
    set lateFeeRule(value: string | null) {
        this.Set('lateFeeRule', value);
    }

    /**
    * * Field Name: amountToPayUponCreation
    * * Display Name: amount To Pay Upon Creation
    * * SQL Data Type: decimal(19, 4)
    */
    get amountToPayUponCreation(): number | null {
        return this.Get('amountToPayUponCreation');
    }
    set amountToPayUponCreation(value: number | null) {
        this.Set('amountToPayUponCreation', value);
    }

    /**
    * * Field Name: billingMaster
    * * Display Name: billing Master
    * * SQL Data Type: bit
    */
    get billingMaster(): boolean | null {
        return this.Get('billingMaster');
    }
    set billingMaster(value: boolean | null) {
        this.Set('billingMaster', value);
    }

    /**
    * * Field Name: product
    * * Display Name: product
    * * SQL Data Type: nvarchar(500)
    */
    get product(): string | null {
        return this.Get('product');
    }
    set product(value: string | null) {
        this.Set('product', value);
    }

    /**
    * * Field Name: quantity
    * * Display Name: quantity
    * * SQL Data Type: bigint
    */
    get quantity(): number | null {
        return this.Get('quantity');
    }
    set quantity(value: number | null) {
        this.Set('quantity', value);
    }

    /**
    * * Field Name: unitPrice
    * * Display Name: unit Price
    * * SQL Data Type: decimal(19, 4)
    */
    get unitPrice(): number | null {
        return this.Get('unitPrice');
    }
    set unitPrice(value: number | null) {
        this.Set('unitPrice', value);
    }

    /**
    * * Field Name: description
    * * Display Name: description
    * * SQL Data Type: nvarchar(500)
    */
    get description(): string | null {
        return this.Get('description');
    }
    set description(value: string | null) {
        this.Set('description', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: Invoice
    * * Display Name: Invoice
    * * SQL Data Type: uniqueidentifier
    */
    get Invoice(): string | null {
        return this.Get('Invoice');
    }
    set Invoice(value: string | null) {
        this.Set('Invoice', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Invoices - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Invoice
 * * Base View: vwInvoices
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Invoices')
export class membersuiteInvoiceEntity extends BaseEntity<membersuiteInvoiceEntityType> {
    /**
    * Loads the MemberSuite: Invoices record from the database
    * @param ID: string - primary key value to load the MemberSuite: Invoices record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteInvoiceEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: IsVoid
    * * Display Name: Is Void
    * * SQL Data Type: bit
    */
    get IsVoid(): boolean | null {
        return this.Get('IsVoid');
    }
    set IsVoid(value: boolean | null) {
        this.Set('IsVoid', value);
    }

    /**
    * * Field Name: BillTo
    * * Display Name: Bill To
    * * SQL Data Type: uniqueidentifier
    */
    get BillTo(): string | null {
        return this.Get('BillTo');
    }
    set BillTo(value: string | null) {
        this.Set('BillTo', value);
    }

    /**
    * * Field Name: ConvertedFromProForma
    * * Display Name: Converted From Pro Forma
    * * SQL Data Type: date
    */
    get ConvertedFromProForma(): Date | null {
        return this.Get('ConvertedFromProForma');
    }
    set ConvertedFromProForma(value: Date | null) {
        this.Set('ConvertedFromProForma', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: DueDate
    * * Display Name: Due Date
    * * SQL Data Type: date
    */
    get DueDate(): Date | null {
        return this.Get('DueDate');
    }
    set DueDate(value: Date | null) {
        this.Set('DueDate', value);
    }

    /**
    * * Field Name: BillingAddress
    * * Display Name: Billing Address
    * * SQL Data Type: nvarchar(500)
    */
    get BillingAddress(): string | null {
        return this.Get('BillingAddress');
    }
    set BillingAddress(value: string | null) {
        this.Set('BillingAddress', value);
    }

    /**
    * * Field Name: Terms
    * * Display Name: Terms
    * * SQL Data Type: uniqueidentifier
    */
    get Terms(): string | null {
        return this.Get('Terms');
    }
    set Terms(value: string | null) {
        this.Set('Terms', value);
    }

    /**
    * * Field Name: PurchaseOrderNumber
    * * Display Name: Purchase Order Number
    * * SQL Data Type: nvarchar(500)
    */
    get PurchaseOrderNumber(): string | null {
        return this.Get('PurchaseOrderNumber');
    }
    set PurchaseOrderNumber(value: string | null) {
        this.Set('PurchaseOrderNumber', value);
    }

    /**
    * * Field Name: CustomerMessage
    * * Display Name: Customer Message
    * * SQL Data Type: nvarchar(MAX)
    */
    get CustomerMessage(): string | null {
        return this.Get('CustomerMessage');
    }
    set CustomerMessage(value: string | null) {
        this.Set('CustomerMessage', value);
    }

    /**
    * * Field Name: BalanceDue
    * * Display Name: Balance Due
    * * SQL Data Type: decimal(19, 4)
    */
    get BalanceDue(): number | null {
        return this.Get('BalanceDue');
    }
    set BalanceDue(value: number | null) {
        this.Set('BalanceDue', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: uniqueidentifier
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: AmountPaid
    * * Display Name: Amount Paid
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountPaid(): number | null {
        return this.Get('AmountPaid');
    }
    set AmountPaid(value: number | null) {
        this.Set('AmountPaid', value);
    }

    /**
    * * Field Name: AmountWrittenOff
    * * Display Name: Amount Written Off
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountWrittenOff(): number | null {
        return this.Get('AmountWrittenOff');
    }
    set AmountWrittenOff(value: number | null) {
        this.Set('AmountWrittenOff', value);
    }

    /**
    * * Field Name: AmountRefunded
    * * Display Name: Amount Refunded
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountRefunded(): number | null {
        return this.Get('AmountRefunded');
    }
    set AmountRefunded(value: number | null) {
        this.Set('AmountRefunded', value);
    }

    /**
    * * Field Name: ProForma
    * * Display Name: Pro Forma
    * * SQL Data Type: bit
    */
    get ProForma(): boolean | null {
        return this.Get('ProForma');
    }
    set ProForma(value: boolean | null) {
        this.Set('ProForma', value);
    }

    /**
    * * Field Name: InsertionOrder
    * * Display Name: Insertion Order
    * * SQL Data Type: uniqueidentifier
    */
    get InsertionOrder(): string | null {
        return this.Get('InsertionOrder');
    }
    set InsertionOrder(value: string | null) {
        this.Set('InsertionOrder', value);
    }

    /**
    * * Field Name: ExchangeRate
    * * Display Name: Exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get ExchangeRate(): number | null {
        return this.Get('ExchangeRate');
    }
    set ExchangeRate(value: number | null) {
        this.Set('ExchangeRate', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: HideInPortal
    * * Display Name: Hide In Portal
    * * SQL Data Type: bit
    */
    get HideInPortal(): boolean | null {
        return this.Get('HideInPortal');
    }
    set HideInPortal(value: boolean | null) {
        this.Set('HideInPortal', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Late Fee Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: LateFeeProduct
 * * Base View: vwLateFeeProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Late Fee Products')
export class membersuiteLateFeeProductEntity extends BaseEntity<membersuiteLateFeeProductEntityType> {
    /**
    * Loads the MemberSuite: Late Fee Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Late Fee Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteLateFeeProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Legacy Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: LegacyProduct
 * * Base View: vwLegacyProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Legacy Products')
export class membersuiteLegacyProductEntity extends BaseEntity<membersuiteLegacyProductEntityType> {
    /**
    * Loads the MemberSuite: Legacy Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Legacy Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteLegacyProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Membership Dues Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: MembershipDuesProduct
 * * Base View: vwMembershipDuesProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Membership Dues Products')
export class membersuiteMembershipDuesProductEntity extends BaseEntity<membersuiteMembershipDuesProductEntityType> {
    /**
    * Loads the MemberSuite: Membership Dues Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Membership Dues Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteMembershipDuesProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: InitialStatus
    * * Display Name: Initial Status
    * * SQL Data Type: uniqueidentifier
    */
    get InitialStatus(): string | null {
        return this.Get('InitialStatus');
    }
    set InitialStatus(value: string | null) {
        this.Set('InitialStatus', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: DropStatus
    * * Display Name: Drop Status
    * * SQL Data Type: uniqueidentifier
    */
    get DropStatus(): string | null {
        return this.Get('DropStatus');
    }
    set DropStatus(value: string | null) {
        this.Set('DropStatus', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: ExpirationType
    * * Display Name: Expiration Type
    * * SQL Data Type: nvarchar(100)
    */
    get ExpirationType(): string | null {
        return this.Get('ExpirationType');
    }
    set ExpirationType(value: string | null) {
        this.Set('ExpirationType', value);
    }

    /**
    * * Field Name: Availability
    * * Display Name: Availability
    * * SQL Data Type: nvarchar(100)
    */
    get Availability(): string | null {
        return this.Get('Availability');
    }
    set Availability(value: string | null) {
        this.Set('Availability', value);
    }

    /**
    * * Field Name: StartDate
    * * Display Name: Start Date
    * * SQL Data Type: date
    */
    get StartDate(): Date | null {
        return this.Get('StartDate');
    }
    set StartDate(value: Date | null) {
        this.Set('StartDate', value);
    }

    /**
    * * Field Name: SellForNextYearAfter
    * * Display Name: Sell For Next Year After
    * * SQL Data Type: date
    */
    get SellForNextYearAfter(): Date | null {
        return this.Get('SellForNextYearAfter');
    }
    set SellForNextYearAfter(value: Date | null) {
        this.Set('SellForNextYearAfter', value);
    }

    /**
    * * Field Name: SetDatesBasedOnPaymentDate
    * * Display Name: Set Dates Based On Payment Date
    * * SQL Data Type: bit
    */
    get SetDatesBasedOnPaymentDate(): boolean | null {
        return this.Get('SetDatesBasedOnPaymentDate');
    }
    set SetDatesBasedOnPaymentDate(value: boolean | null) {
        this.Set('SetDatesBasedOnPaymentDate', value);
    }

    /**
    * * Field Name: SellForNextMonthAfterDay
    * * Display Name: Sell For Next Month After Day
    * * SQL Data Type: bigint
    */
    get SellForNextMonthAfterDay(): number | null {
        return this.Get('SellForNextMonthAfterDay');
    }
    set SellForNextMonthAfterDay(value: number | null) {
        this.Set('SellForNextMonthAfterDay', value);
    }

    /**
    * * Field Name: StartDay
    * * Display Name: Start Day
    * * SQL Data Type: bigint
    */
    get StartDay(): number | null {
        return this.Get('StartDay');
    }
    set StartDay(value: number | null) {
        this.Set('StartDay', value);
    }

    /**
    * * Field Name: AllowMidMonthExpirations
    * * Display Name: Allow Mid Month Expirations
    * * SQL Data Type: bit
    */
    get AllowMidMonthExpirations(): boolean | null {
        return this.Get('AllowMidMonthExpirations');
    }
    set AllowMidMonthExpirations(value: boolean | null) {
        this.Set('AllowMidMonthExpirations', value);
    }

    /**
    * * Field Name: TermLength
    * * Display Name: Term Length
    * * SQL Data Type: bigint
    */
    get TermLength(): number | null {
        return this.Get('TermLength');
    }
    set TermLength(value: number | null) {
        this.Set('TermLength', value);
    }

    /**
    * * Field Name: TermType
    * * Display Name: Term Type
    * * SQL Data Type: nvarchar(100)
    */
    get TermType(): string | null {
        return this.Get('TermType');
    }
    set TermType(value: string | null) {
        this.Set('TermType', value);
    }

    /**
    * * Field Name: UpdateDatesWhen
    * * Display Name: Update Dates When
    * * SQL Data Type: nvarchar(100)
    */
    get UpdateDatesWhen(): string | null {
        return this.Get('UpdateDatesWhen');
    }
    set UpdateDatesWhen(value: string | null) {
        this.Set('UpdateDatesWhen', value);
    }

    /**
    * * Field Name: RequiresApproval
    * * Display Name: Requires Approval
    * * SQL Data Type: bit
    */
    get RequiresApproval(): boolean | null {
        return this.Get('RequiresApproval');
    }
    set RequiresApproval(value: boolean | null) {
        this.Set('RequiresApproval', value);
    }

    /**
    * * Field Name: RenewalTerms
    * * Display Name: Renewal Terms
    * * SQL Data Type: uniqueidentifier
    */
    get RenewalTerms(): string | null {
        return this.Get('RenewalTerms');
    }
    set RenewalTerms(value: string | null) {
        this.Set('RenewalTerms', value);
    }

    /**
    * * Field Name: ProFormaRenewalInvoices
    * * Display Name: Pro Forma Renewal Invoices
    * * SQL Data Type: bit
    */
    get ProFormaRenewalInvoices(): boolean | null {
        return this.Get('ProFormaRenewalInvoices');
    }
    set ProFormaRenewalInvoices(value: boolean | null) {
        this.Set('ProFormaRenewalInvoices', value);
    }

    /**
    * * Field Name: GracePeriod
    * * Display Name: Grace Period
    * * SQL Data Type: bigint
    */
    get GracePeriod(): number | null {
        return this.Get('GracePeriod');
    }
    set GracePeriod(value: number | null) {
        this.Set('GracePeriod', value);
    }

    /**
    * * Field Name: BillPrimaryOrganization
    * * Display Name: Bill Primary Organization
    * * SQL Data Type: bit
    */
    get BillPrimaryOrganization(): boolean | null {
        return this.Get('BillPrimaryOrganization');
    }
    set BillPrimaryOrganization(value: boolean | null) {
        this.Set('BillPrimaryOrganization', value);
    }

    /**
    * * Field Name: ReinstatementPeriod
    * * Display Name: Reinstatement Period
    * * SQL Data Type: bigint
    */
    get ReinstatementPeriod(): number | null {
        return this.Get('ReinstatementPeriod');
    }
    set ReinstatementPeriod(value: number | null) {
        this.Set('ReinstatementPeriod', value);
    }

    /**
    * * Field Name: ReceivesMemberBenefits
    * * Display Name: Receives Member Benefits
    * * SQL Data Type: bit
    */
    get ReceivesMemberBenefits(): boolean | null {
        return this.Get('ReceivesMemberBenefits');
    }
    set ReceivesMemberBenefits(value: boolean | null) {
        this.Set('ReceivesMemberBenefits', value);
    }

    /**
    * * Field Name: MembershipType
    * * Display Name: Membership Type
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipType(): string | null {
        return this.Get('MembershipType');
    }
    set MembershipType(value: string | null) {
        this.Set('MembershipType', value);
    }

    /**
    * * Field Name: RenewsWith
    * * Display Name: Renews With
    * * SQL Data Type: uniqueidentifier
    */
    get RenewsWith(): string | null {
        return this.Get('RenewsWith');
    }
    set RenewsWith(value: string | null) {
        this.Set('RenewsWith', value);
    }

    /**
    * * Field Name: InitialBillingEmail
    * * Display Name: Initial Billing Email
    * * SQL Data Type: uniqueidentifier
    */
    get InitialBillingEmail(): string | null {
        return this.Get('InitialBillingEmail');
    }
    set InitialBillingEmail(value: string | null) {
        this.Set('InitialBillingEmail', value);
    }

    /**
    * * Field Name: FirstReminderEmail
    * * Display Name: First Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get FirstReminderEmail(): string | null {
        return this.Get('FirstReminderEmail');
    }
    set FirstReminderEmail(value: string | null) {
        this.Set('FirstReminderEmail', value);
    }

    /**
    * * Field Name: SecondReminderEmail
    * * Display Name: Second Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get SecondReminderEmail(): string | null {
        return this.Get('SecondReminderEmail');
    }
    set SecondReminderEmail(value: string | null) {
        this.Set('SecondReminderEmail', value);
    }

    /**
    * * Field Name: ThirdReminderEmail
    * * Display Name: Third Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get ThirdReminderEmail(): string | null {
        return this.Get('ThirdReminderEmail');
    }
    set ThirdReminderEmail(value: string | null) {
        this.Set('ThirdReminderEmail', value);
    }

    /**
    * * Field Name: DropEmail
    * * Display Name: Drop Email
    * * SQL Data Type: uniqueidentifier
    */
    get DropEmail(): string | null {
        return this.Get('DropEmail');
    }
    set DropEmail(value: string | null) {
        this.Set('DropEmail', value);
    }

    /**
    * * Field Name: InvoicePercentage
    * * Display Name: Invoice Percentage
    * * SQL Data Type: decimal(19, 4)
    */
    get InvoicePercentage(): number | null {
        return this.Get('InvoicePercentage');
    }
    set InvoicePercentage(value: number | null) {
        this.Set('InvoicePercentage', value);
    }

    /**
    * * Field Name: InvoiceType
    * * Display Name: Invoice Type
    * * SQL Data Type: uniqueidentifier
    */
    get InvoiceType(): string | null {
        return this.Get('InvoiceType');
    }
    set InvoiceType(value: string | null) {
        this.Set('InvoiceType', value);
    }

    /**
    * * Field Name: AutoRenew
    * * Display Name: Auto Renew
    * * SQL Data Type: bit
    */
    get AutoRenew(): boolean | null {
        return this.Get('AutoRenew');
    }
    set AutoRenew(value: boolean | null) {
        this.Set('AutoRenew', value);
    }

    /**
    * * Field Name: ResumeMode
    * * Display Name: Resume Mode
    * * SQL Data Type: nvarchar(100)
    */
    get ResumeMode(): string | null {
        return this.Get('ResumeMode');
    }
    set ResumeMode(value: string | null) {
        this.Set('ResumeMode', value);
    }

    /**
    * * Field Name: ChapterMode
    * * Display Name: Chapter Mode
    * * SQL Data Type: nvarchar(100)
    */
    get ChapterMode(): string | null {
        return this.Get('ChapterMode');
    }
    set ChapterMode(value: string | null) {
        this.Set('ChapterMode', value);
    }

    /**
    * * Field Name: ChapterPostalCodeMappingMode
    * * Display Name: Chapter Postal Code Mapping Mode
    * * SQL Data Type: nvarchar(100)
    */
    get ChapterPostalCodeMappingMode(): string | null {
        return this.Get('ChapterPostalCodeMappingMode');
    }
    set ChapterPostalCodeMappingMode(value: string | null) {
        this.Set('ChapterPostalCodeMappingMode', value);
    }

    /**
    * * Field Name: SectionMode
    * * Display Name: Section Mode
    * * SQL Data Type: nvarchar(100)
    */
    get SectionMode(): string | null {
        return this.Get('SectionMode');
    }
    set SectionMode(value: string | null) {
        this.Set('SectionMode', value);
    }

    /**
    * * Field Name: AutomaticallyUpdateChapter
    * * Display Name: Automatically Update Chapter
    * * SQL Data Type: bit
    */
    get AutomaticallyUpdateChapter(): boolean | null {
        return this.Get('AutomaticallyUpdateChapter');
    }
    set AutomaticallyUpdateChapter(value: boolean | null) {
        this.Set('AutomaticallyUpdateChapter', value);
    }

    /**
    * * Field Name: MembershipOrganization
    * * Display Name: Membership Organization
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipOrganization(): string | null {
        return this.Get('MembershipOrganization');
    }
    set MembershipOrganization(value: string | null) {
        this.Set('MembershipOrganization', value);
    }

    /**
    * * Field Name: UseFreshJoinDateForReinstatedMembers
    * * Display Name: Use Fresh Join Date For Reinstated Members
    * * SQL Data Type: bit
    */
    get UseFreshJoinDateForReinstatedMembers(): boolean | null {
        return this.Get('UseFreshJoinDateForReinstatedMembers');
    }
    set UseFreshJoinDateForReinstatedMembers(value: boolean | null) {
        this.Set('UseFreshJoinDateForReinstatedMembers', value);
    }

    /**
    * * Field Name: GiveRenewalPricingDuringReinstatementPeriod
    * * Display Name: Give Renewal Pricing During Reinstatement Period
    * * SQL Data Type: bit
    */
    get GiveRenewalPricingDuringReinstatementPeriod(): boolean | null {
        return this.Get('GiveRenewalPricingDuringReinstatementPeriod');
    }
    set GiveRenewalPricingDuringReinstatementPeriod(value: boolean | null) {
        this.Set('GiveRenewalPricingDuringReinstatementPeriod', value);
    }

    /**
    * * Field Name: UseCurrentDateAsBasisForExpirationOfReinstatedMembership
    * * Display Name: Use Current Date As Basis For Expiration Of Reinstated Membership
    * * SQL Data Type: bit
    */
    get UseCurrentDateAsBasisForExpirationOfReinstatedMembership(): boolean | null {
        return this.Get('UseCurrentDateAsBasisForExpirationOfReinstatedMembership');
    }
    set UseCurrentDateAsBasisForExpirationOfReinstatedMembership(value: boolean | null) {
        this.Set('UseCurrentDateAsBasisForExpirationOfReinstatedMembership', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: WasLocalIDGenerated
    * * Display Name: Was Local ID Generated
    * * SQL Data Type: bit
    */
    get WasLocalIDGenerated(): boolean | null {
        return this.Get('WasLocalIDGenerated');
    }
    set WasLocalIDGenerated(value: boolean | null) {
        this.Set('WasLocalIDGenerated', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Merchandises - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Merchandise
 * * Base View: vwMerchandises
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Merchandises')
export class membersuiteMerchandiseEntity extends BaseEntity<membersuiteMerchandiseEntityType> {
    /**
    * Loads the MemberSuite: Merchandises record from the database
    * @param ID: string - primary key value to load the MemberSuite: Merchandises record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteMerchandiseEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: ShortDescription
    * * Display Name: Short Description
    * * SQL Data Type: decimal(19, 4)
    */
    get ShortDescription(): number | null {
        return this.Get('ShortDescription');
    }
    set ShortDescription(value: number | null) {
        this.Set('ShortDescription', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Miscellaneous Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: MiscellaneousProduct
 * * Base View: vwMiscellaneousProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Miscellaneous Products')
export class membersuiteMiscellaneousProductEntity extends BaseEntity<membersuiteMiscellaneousProductEntityType> {
    /**
    * Loads the MemberSuite: Miscellaneous Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Miscellaneous Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteMiscellaneousProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Order Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: OrderLineItem
 * * Base View: vwOrderLineItems
 * * Primary Key: orderLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Order Line Items')
export class membersuiteOrderLineItemEntity extends BaseEntity<membersuiteOrderLineItemEntityType> {
    /**
    * Loads the MemberSuite: Order Line Items record from the database
    * @param orderLineItemID: string - primary key value to load the MemberSuite: Order Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteOrderLineItemEntity
    * @method
    * @override
    */
    public async Load(orderLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'orderLineItemID', Value: orderLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: quantityShipped
    * * Display Name: quantity Shipped
    * * SQL Data Type: bigint
    */
    get quantityShipped(): number | null {
        return this.Get('quantityShipped');
    }
    set quantityShipped(value: number | null) {
        this.Set('quantityShipped', value);
    }

    /**
    * * Field Name: quantityCancelled
    * * Display Name: quantity Cancelled
    * * SQL Data Type: bigint
    */
    get quantityCancelled(): number | null {
        return this.Get('quantityCancelled');
    }
    set quantityCancelled(value: number | null) {
        this.Set('quantityCancelled', value);
    }

    /**
    * * Field Name: quantityPendingReturn
    * * Display Name: quantity Pending Return
    * * SQL Data Type: bigint
    */
    get quantityPendingReturn(): number | null {
        return this.Get('quantityPendingReturn');
    }
    set quantityPendingReturn(value: number | null) {
        this.Set('quantityPendingReturn', value);
    }

    /**
    * * Field Name: quantityReturned
    * * Display Name: quantity Returned
    * * SQL Data Type: bigint
    */
    get quantityReturned(): number | null {
        return this.Get('quantityReturned');
    }
    set quantityReturned(value: number | null) {
        this.Set('quantityReturned', value);
    }

    /**
    * * Field Name: weight
    * * Display Name: weight
    * * SQL Data Type: decimal(19, 4)
    */
    get weight(): number | null {
        return this.Get('weight');
    }
    set weight(value: number | null) {
        this.Set('weight', value);
    }

    /**
    * * Field Name: optional
    * * Display Name: optional
    * * SQL Data Type: bit
    */
    get optional(): boolean | null {
        return this.Get('optional');
    }
    set optional(value: boolean | null) {
        this.Set('optional', value);
    }

    /**
    * * Field Name: warehouse
    * * Display Name: warehouse
    * * SQL Data Type: nvarchar(500)
    */
    get warehouse(): string | null {
        return this.Get('warehouse');
    }
    set warehouse(value: string | null) {
        this.Set('warehouse', value);
    }

    /**
    * * Field Name: lateFeeRule
    * * Display Name: late Fee Rule
    * * SQL Data Type: nvarchar(500)
    */
    get lateFeeRule(): string | null {
        return this.Get('lateFeeRule');
    }
    set lateFeeRule(value: string | null) {
        this.Set('lateFeeRule', value);
    }

    /**
    * * Field Name: overrideMemberPricingTo
    * * Display Name: override Member Pricing To
    * * SQL Data Type: nvarchar(500)
    */
    get overrideMemberPricingTo(): string | null {
        return this.Get('overrideMemberPricingTo');
    }
    set overrideMemberPricingTo(value: string | null) {
        this.Set('overrideMemberPricingTo', value);
    }

    /**
    * * Field Name: productLinkageID
    * * Display Name: product Linkage ID
    * * SQL Data Type: nvarchar(500)
    */
    get productLinkageID(): string | null {
        return this.Get('productLinkageID');
    }
    set productLinkageID(value: string | null) {
        this.Set('productLinkageID', value);
    }

    /**
    * * Field Name: type
    * * Display Name: type
    * * SQL Data Type: bigint
    */
    get type(): number | null {
        return this.Get('type');
    }
    set type(value: number | null) {
        this.Set('type', value);
    }

    /**
    * * Field Name: priceOverride
    * * Display Name: price Override
    * * SQL Data Type: bit
    */
    get priceOverride(): boolean | null {
        return this.Get('priceOverride');
    }
    set priceOverride(value: boolean | null) {
        this.Set('priceOverride', value);
    }

    /**
    * * Field Name: overrideReason
    * * Display Name: override Reason
    * * SQL Data Type: nvarchar(500)
    */
    get overrideReason(): string | null {
        return this.Get('overrideReason');
    }
    set overrideReason(value: string | null) {
        this.Set('overrideReason', value);
    }

    /**
    * * Field Name: overrideShipTo
    * * Display Name: override Ship To
    * * SQL Data Type: nvarchar(500)
    */
    get overrideShipTo(): string | null {
        return this.Get('overrideShipTo');
    }
    set overrideShipTo(value: string | null) {
        this.Set('overrideShipTo', value);
    }

    /**
    * * Field Name: overrideShipToAddressType
    * * Display Name: override Ship To Address Type
    * * SQL Data Type: nvarchar(500)
    */
    get overrideShipToAddressType(): string | null {
        return this.Get('overrideShipToAddressType');
    }
    set overrideShipToAddressType(value: string | null) {
        this.Set('overrideShipToAddressType', value);
    }

    /**
    * * Field Name: status
    * * Display Name: status
    * * SQL Data Type: bigint
    */
    get status(): number | null {
        return this.Get('status');
    }
    set status(value: number | null) {
        this.Set('status', value);
    }

    /**
    * * Field Name: billingTemplate
    * * Display Name: billing Template
    * * SQL Data Type: nvarchar(500)
    */
    get billingTemplate(): string | null {
        return this.Get('billingTemplate');
    }
    set billingTemplate(value: string | null) {
        this.Set('billingTemplate', value);
    }

    /**
    * * Field Name: revenueRecognitionTemplate
    * * Display Name: revenue Recognition Template
    * * SQL Data Type: nvarchar(500)
    */
    get revenueRecognitionTemplate(): string | null {
        return this.Get('revenueRecognitionTemplate');
    }
    set revenueRecognitionTemplate(value: string | null) {
        this.Set('revenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: fulfillmentDate
    * * Display Name: fulfillment Date
    * * SQL Data Type: datetime2
    */
    get fulfillmentDate(): Date | null {
        return this.Get('fulfillmentDate');
    }
    set fulfillmentDate(value: Date | null) {
        this.Set('fulfillmentDate', value);
    }

    /**
    * * Field Name: wasGeneratedAutomatically
    * * Display Name: was Generated Automatically
    * * SQL Data Type: bit
    */
    get wasGeneratedAutomatically(): boolean | null {
        return this.Get('wasGeneratedAutomatically');
    }
    set wasGeneratedAutomatically(value: boolean | null) {
        this.Set('wasGeneratedAutomatically', value);
    }

    /**
    * * Field Name: orderLineItemID
    * * Display Name: order Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get orderLineItemID(): string {
        return this.Get('orderLineItemID');
    }
    set orderLineItemID(value: string) {
        this.Set('orderLineItemID', value);
    }

    /**
    * * Field Name: linkedOrderLineItemID
    * * Display Name: linked Order Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get linkedOrderLineItemID(): string | null {
        return this.Get('linkedOrderLineItemID');
    }
    set linkedOrderLineItemID(value: string | null) {
        this.Set('linkedOrderLineItemID', value);
    }

    /**
    * * Field Name: amountPaid
    * * Display Name: amount Paid
    * * SQL Data Type: decimal(19, 4)
    */
    get amountPaid(): number | null {
        return this.Get('amountPaid');
    }
    set amountPaid(value: number | null) {
        this.Set('amountPaid', value);
    }

    /**
    * * Field Name: amountPendingCapture
    * * Display Name: amount Pending Capture
    * * SQL Data Type: decimal(19, 4)
    */
    get amountPendingCapture(): number | null {
        return this.Get('amountPendingCapture');
    }
    set amountPendingCapture(value: number | null) {
        this.Set('amountPendingCapture', value);
    }

    /**
    * * Field Name: amountRefunded
    * * Display Name: amount Refunded
    * * SQL Data Type: decimal(19, 4)
    */
    get amountRefunded(): number | null {
        return this.Get('amountRefunded');
    }
    set amountRefunded(value: number | null) {
        this.Set('amountRefunded', value);
    }

    /**
    * * Field Name: balanceDue
    * * Display Name: balance Due
    * * SQL Data Type: decimal(19, 4)
    */
    get balanceDue(): number | null {
        return this.Get('balanceDue');
    }
    set balanceDue(value: number | null) {
        this.Set('balanceDue', value);
    }

    /**
    * * Field Name: discounts
    * * Display Name: discounts
    * * SQL Data Type: decimal(19, 4)
    */
    get discounts(): number | null {
        return this.Get('discounts');
    }
    set discounts(value: number | null) {
        this.Set('discounts', value);
    }

    /**
    * * Field Name: umbrellaProduct
    * * Display Name: umbrella Product
    * * SQL Data Type: nvarchar(500)
    */
    get umbrellaProduct(): string | null {
        return this.Get('umbrellaProduct');
    }
    set umbrellaProduct(value: string | null) {
        this.Set('umbrellaProduct', value);
    }

    /**
    * * Field Name: skipLineItemProcessing
    * * Display Name: skip Line Item Processing
    * * SQL Data Type: bit
    */
    get skipLineItemProcessing(): boolean | null {
        return this.Get('skipLineItemProcessing');
    }
    set skipLineItemProcessing(value: boolean | null) {
        this.Set('skipLineItemProcessing', value);
    }

    /**
    * * Field Name: billingRunTargetRecordID
    * * Display Name: billing Run Target Record ID
    * * SQL Data Type: nvarchar(500)
    */
    get billingRunTargetRecordID(): string | null {
        return this.Get('billingRunTargetRecordID');
    }
    set billingRunTargetRecordID(value: string | null) {
        this.Set('billingRunTargetRecordID', value);
    }

    /**
    * * Field Name: tieredRegistrationPricingRule
    * * Display Name: tiered Registration Pricing Rule
    * * SQL Data Type: nvarchar(500)
    */
    get tieredRegistrationPricingRule(): string | null {
        return this.Get('tieredRegistrationPricingRule');
    }
    set tieredRegistrationPricingRule(value: string | null) {
        this.Set('tieredRegistrationPricingRule', value);
    }

    /**
    * * Field Name: parentOrderLineItemID
    * * Display Name: parent Order Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get parentOrderLineItemID(): string | null {
        return this.Get('parentOrderLineItemID');
    }
    set parentOrderLineItemID(value: string | null) {
        this.Set('parentOrderLineItemID', value);
    }

    /**
    * * Field Name: product
    * * Display Name: product
    * * SQL Data Type: nvarchar(500)
    */
    get product(): string | null {
        return this.Get('product');
    }
    set product(value: string | null) {
        this.Set('product', value);
    }

    /**
    * * Field Name: quantity
    * * Display Name: quantity
    * * SQL Data Type: bigint
    */
    get quantity(): number | null {
        return this.Get('quantity');
    }
    set quantity(value: number | null) {
        this.Set('quantity', value);
    }

    /**
    * * Field Name: unitPrice
    * * Display Name: unit Price
    * * SQL Data Type: decimal(19, 4)
    */
    get unitPrice(): number | null {
        return this.Get('unitPrice');
    }
    set unitPrice(value: number | null) {
        this.Set('unitPrice', value);
    }

    /**
    * * Field Name: description
    * * Display Name: description
    * * SQL Data Type: nvarchar(500)
    */
    get description(): string | null {
        return this.Get('description');
    }
    set description(value: string | null) {
        this.Set('description', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Orders - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Order
 * * Base View: vwOrders
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Orders')
export class membersuiteOrderEntity extends BaseEntity<membersuiteOrderEntityType> {
    /**
    * Loads the MemberSuite: Orders record from the database
    * @param ID: string - primary key value to load the MemberSuite: Orders record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteOrderEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: AmountDueNow
    * * Display Name: Amount Due Now
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountDueNow(): number | null {
        return this.Get('AmountDueNow');
    }
    set AmountDueNow(value: number | null) {
        this.Set('AmountDueNow', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: HasGeneratedCEUCredits
    * * Display Name: Has Generated CEU Credits
    * * SQL Data Type: bit
    */
    get HasGeneratedCEUCredits(): boolean | null {
        return this.Get('HasGeneratedCEUCredits');
    }
    set HasGeneratedCEUCredits(value: boolean | null) {
        this.Set('HasGeneratedCEUCredits', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: TrackingNumber
    * * Display Name: Tracking Number
    * * SQL Data Type: nvarchar(500)
    */
    get TrackingNumber(): string | null {
        return this.Get('TrackingNumber');
    }
    set TrackingNumber(value: string | null) {
        this.Set('TrackingNumber', value);
    }

    /**
    * * Field Name: ShipDate
    * * Display Name: Ship Date
    * * SQL Data Type: date
    */
    get ShipDate(): Date | null {
        return this.Get('ShipDate');
    }
    set ShipDate(value: Date | null) {
        this.Set('ShipDate', value);
    }

    /**
    * * Field Name: CustomerNotes
    * * Display Name: Customer Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get CustomerNotes(): string | null {
        return this.Get('CustomerNotes');
    }
    set CustomerNotes(value: string | null) {
        this.Set('CustomerNotes', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: Warehouse
    * * Display Name: Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get Warehouse(): string | null {
        return this.Get('Warehouse');
    }
    set Warehouse(value: string | null) {
        this.Set('Warehouse', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: ShipTo
    * * Display Name: Ship To
    * * SQL Data Type: uniqueidentifier
    */
    get ShipTo(): string | null {
        return this.Get('ShipTo');
    }
    set ShipTo(value: string | null) {
        this.Set('ShipTo', value);
    }

    /**
    * * Field Name: BillTo
    * * Display Name: Bill To
    * * SQL Data Type: uniqueidentifier
    */
    get BillTo(): string | null {
        return this.Get('BillTo');
    }
    set BillTo(value: string | null) {
        this.Set('BillTo', value);
    }

    /**
    * * Field Name: PaymentMethod
    * * Display Name: Payment Method
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentMethod(): string | null {
        return this.Get('PaymentMethod');
    }
    set PaymentMethod(value: string | null) {
        this.Set('PaymentMethod', value);
    }

    /**
    * * Field Name: PaymentReferenceNumber
    * * Display Name: Payment Reference Number
    * * SQL Data Type: nvarchar(500)
    */
    get PaymentReferenceNumber(): string | null {
        return this.Get('PaymentReferenceNumber');
    }
    set PaymentReferenceNumber(value: string | null) {
        this.Set('PaymentReferenceNumber', value);
    }

    /**
    * * Field Name: HasBeenQueued
    * * Display Name: Has Been Queued
    * * SQL Data Type: bit
    */
    get HasBeenQueued(): boolean | null {
        return this.Get('HasBeenQueued');
    }
    set HasBeenQueued(value: boolean | null) {
        this.Set('HasBeenQueued', value);
    }

    /**
    * * Field Name: ProcessingStartTime
    * * Display Name: Processing Start Time
    * * SQL Data Type: datetime2
    */
    get ProcessingStartTime(): Date | null {
        return this.Get('ProcessingStartTime');
    }
    set ProcessingStartTime(value: Date | null) {
        this.Set('ProcessingStartTime', value);
    }

    /**
    * * Field Name: ProcessingEndTime
    * * Display Name: Processing End Time
    * * SQL Data Type: datetime2
    */
    get ProcessingEndTime(): Date | null {
        return this.Get('ProcessingEndTime');
    }
    set ProcessingEndTime(value: Date | null) {
        this.Set('ProcessingEndTime', value);
    }

    /**
    * * Field Name: ProcessingDuration
    * * Display Name: Processing Duration
    * * SQL Data Type: bigint
    */
    get ProcessingDuration(): number | null {
        return this.Get('ProcessingDuration');
    }
    set ProcessingDuration(value: number | null) {
        this.Set('ProcessingDuration', value);
    }

    /**
    * * Field Name: BalanceDue
    * * Display Name: Balance Due
    * * SQL Data Type: decimal(19, 4)
    */
    get BalanceDue(): number | null {
        return this.Get('BalanceDue');
    }
    set BalanceDue(value: number | null) {
        this.Set('BalanceDue', value);
    }

    /**
    * * Field Name: AmountPaid
    * * Display Name: Amount Paid
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountPaid(): number | null {
        return this.Get('AmountPaid');
    }
    set AmountPaid(value: number | null) {
        this.Set('AmountPaid', value);
    }

    /**
    * * Field Name: AmountPendingCapture
    * * Display Name: Amount Pending Capture
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountPendingCapture(): number | null {
        return this.Get('AmountPendingCapture');
    }
    set AmountPendingCapture(value: number | null) {
        this.Set('AmountPendingCapture', value);
    }

    /**
    * * Field Name: AmountRefunded
    * * Display Name: Amount Refunded
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountRefunded(): number | null {
        return this.Get('AmountRefunded');
    }
    set AmountRefunded(value: number | null) {
        this.Set('AmountRefunded', value);
    }

    /**
    * * Field Name: PreProcessingIdentifier
    * * Display Name: Pre Processing Identifier
    * * SQL Data Type: nvarchar(500)
    */
    get PreProcessingIdentifier(): string | null {
        return this.Get('PreProcessingIdentifier');
    }
    set PreProcessingIdentifier(value: string | null) {
        this.Set('PreProcessingIdentifier', value);
    }

    /**
    * * Field Name: PreProcessingHash
    * * Display Name: Pre Processing Hash
    * * SQL Data Type: nvarchar(500)
    */
    get PreProcessingHash(): string | null {
        return this.Get('PreProcessingHash');
    }
    set PreProcessingHash(value: string | null) {
        this.Set('PreProcessingHash', value);
    }

    /**
    * * Field Name: CashAccount
    * * Display Name: Cash Account
    * * SQL Data Type: uniqueidentifier
    */
    get CashAccount(): string | null {
        return this.Get('CashAccount');
    }
    set CashAccount(value: string | null) {
        this.Set('CashAccount', value);
    }

    /**
    * * Field Name: CreditCardNumber
    * * Display Name: Credit Card Number
    * * SQL Data Type: nvarchar(500)
    */
    get CreditCardNumber(): string | null {
        return this.Get('CreditCardNumber');
    }
    set CreditCardNumber(value: string | null) {
        this.Set('CreditCardNumber', value);
    }

    /**
    * * Field Name: ACHAccountNumber
    * * Display Name: ACH Account Number
    * * SQL Data Type: nvarchar(500)
    */
    get ACHAccountNumber(): string | null {
        return this.Get('ACHAccountNumber');
    }
    set ACHAccountNumber(value: string | null) {
        this.Set('ACHAccountNumber', value);
    }

    /**
    * * Field Name: ACHRoutingNumber
    * * Display Name: ACH Routing Number
    * * SQL Data Type: nvarchar(500)
    */
    get ACHRoutingNumber(): string | null {
        return this.Get('ACHRoutingNumber');
    }
    set ACHRoutingNumber(value: string | null) {
        this.Set('ACHRoutingNumber', value);
    }

    /**
    * * Field Name: WebSECCode
    * * Display Name: Web SEC Code
    * * SQL Data Type: nvarchar(100)
    */
    get WebSECCode(): string | null {
        return this.Get('WebSECCode');
    }
    set WebSECCode(value: string | null) {
        this.Set('WebSECCode', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: CreditCardExpirationDate
    * * Display Name: Credit Card Expiration Date
    * * SQL Data Type: date
    */
    get CreditCardExpirationDate(): Date | null {
        return this.Get('CreditCardExpirationDate');
    }
    set CreditCardExpirationDate(value: Date | null) {
        this.Set('CreditCardExpirationDate', value);
    }

    /**
    * * Field Name: CreditCardAuthorizationID
    * * Display Name: Credit Card Authorization ID
    * * SQL Data Type: nvarchar(500)
    */
    get CreditCardAuthorizationID(): string | null {
        return this.Get('CreditCardAuthorizationID');
    }
    set CreditCardAuthorizationID(value: string | null) {
        this.Set('CreditCardAuthorizationID', value);
    }

    /**
    * * Field Name: CreditCardType
    * * Display Name: Credit Card Type
    * * SQL Data Type: nvarchar(100)
    */
    get CreditCardType(): string | null {
        return this.Get('CreditCardType');
    }
    set CreditCardType(value: string | null) {
        this.Set('CreditCardType', value);
    }

    /**
    * * Field Name: ProcessOrderEvenIfPaymentFails
    * * Display Name: Process Order Even If Payment Fails
    * * SQL Data Type: bit
    */
    get ProcessOrderEvenIfPaymentFails(): boolean | null {
        return this.Get('ProcessOrderEvenIfPaymentFails');
    }
    set ProcessOrderEvenIfPaymentFails(value: boolean | null) {
        this.Set('ProcessOrderEvenIfPaymentFails', value);
    }

    /**
    * * Field Name: CCVCode
    * * Display Name: CCV Code
    * * SQL Data Type: nvarchar(500)
    */
    get CCVCode(): string | null {
        return this.Get('CCVCode');
    }
    set CCVCode(value: string | null) {
        this.Set('CCVCode', value);
    }

    /**
    * * Field Name: IgnoreMissingDemographics
    * * Display Name: Ignore Missing Demographics
    * * SQL Data Type: bit
    */
    get IgnoreMissingDemographics(): boolean | null {
        return this.Get('IgnoreMissingDemographics');
    }
    set IgnoreMissingDemographics(value: boolean | null) {
        this.Set('IgnoreMissingDemographics', value);
    }

    /**
    * * Field Name: ShippingAddress
    * * Display Name: Shipping Address
    * * SQL Data Type: nvarchar(500)
    */
    get ShippingAddress(): string | null {
        return this.Get('ShippingAddress');
    }
    set ShippingAddress(value: string | null) {
        this.Set('ShippingAddress', value);
    }

    /**
    * * Field Name: BillingAddress
    * * Display Name: Billing Address
    * * SQL Data Type: nvarchar(500)
    */
    get BillingAddress(): string | null {
        return this.Get('BillingAddress');
    }
    set BillingAddress(value: string | null) {
        this.Set('BillingAddress', value);
    }

    /**
    * * Field Name: BillingEmailAddress
    * * Display Name: Billing Email Address
    * * SQL Data Type: nvarchar(500)
    */
    get BillingEmailAddress(): string | null {
        return this.Get('BillingEmailAddress');
    }
    set BillingEmailAddress(value: string | null) {
        this.Set('BillingEmailAddress', value);
    }

    /**
    * * Field Name: Status
    * * Display Name: Status
    * * SQL Data Type: nvarchar(100)
    */
    get Status(): string | null {
        return this.Get('Status');
    }
    set Status(value: string | null) {
        this.Set('Status', value);
    }

    /**
    * * Field Name: Discounts
    * * Display Name: Discounts
    * * SQL Data Type: decimal(19, 4)
    */
    get Discounts(): number | null {
        return this.Get('Discounts');
    }
    set Discounts(value: number | null) {
        this.Set('Discounts', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: InvoiceType
    * * Display Name: Invoice Type
    * * SQL Data Type: uniqueidentifier
    */
    get InvoiceType(): string | null {
        return this.Get('InvoiceType');
    }
    set InvoiceType(value: string | null) {
        this.Set('InvoiceType', value);
    }

    /**
    * * Field Name: IsCreditCardEncrypted
    * * Display Name: Is Credit Card Encrypted
    * * SQL Data Type: bit
    */
    get IsCreditCardEncrypted(): boolean | null {
        return this.Get('IsCreditCardEncrypted');
    }
    set IsCreditCardEncrypted(value: boolean | null) {
        this.Set('IsCreditCardEncrypted', value);
    }

    /**
    * * Field Name: ShippingOverride
    * * Display Name: Shipping Override
    * * SQL Data Type: bit
    */
    get ShippingOverride(): boolean | null {
        return this.Get('ShippingOverride');
    }
    set ShippingOverride(value: boolean | null) {
        this.Set('ShippingOverride', value);
    }

    /**
    * * Field Name: TaxOverride
    * * Display Name: Tax Override
    * * SQL Data Type: bit
    */
    get TaxOverride(): boolean | null {
        return this.Get('TaxOverride');
    }
    set TaxOverride(value: boolean | null) {
        this.Set('TaxOverride', value);
    }

    /**
    * * Field Name: BillingRunActivityID
    * * Display Name: Billing Run Activity ID
    * * SQL Data Type: nvarchar(500)
    */
    get BillingRunActivityID(): string | null {
        return this.Get('BillingRunActivityID');
    }
    set BillingRunActivityID(value: string | null) {
        this.Set('BillingRunActivityID', value);
    }

    /**
    * * Field Name: UseProFormaInvoices
    * * Display Name: Use Pro Forma Invoices
    * * SQL Data Type: bit
    */
    get UseProFormaInvoices(): boolean | null {
        return this.Get('UseProFormaInvoices');
    }
    set UseProFormaInvoices(value: boolean | null) {
        this.Set('UseProFormaInvoices', value);
    }

    /**
    * * Field Name: InvoiceTerms
    * * Display Name: Invoice Terms
    * * SQL Data Type: uniqueidentifier
    */
    get InvoiceTerms(): string | null {
        return this.Get('InvoiceTerms');
    }
    set InvoiceTerms(value: string | null) {
        this.Set('InvoiceTerms', value);
    }

    /**
    * * Field Name: SuppressConfirmationEmails
    * * Display Name: Suppress Confirmation Emails
    * * SQL Data Type: bit
    */
    get SuppressConfirmationEmails(): boolean | null {
        return this.Get('SuppressConfirmationEmails');
    }
    set SuppressConfirmationEmails(value: boolean | null) {
        this.Set('SuppressConfirmationEmails', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: PurchaseOrderNumber
    * * Display Name: Purchase Order Number
    * * SQL Data Type: nvarchar(500)
    */
    get PurchaseOrderNumber(): string | null {
        return this.Get('PurchaseOrderNumber');
    }
    set PurchaseOrderNumber(value: string | null) {
        this.Set('PurchaseOrderNumber', value);
    }

    /**
    * * Field Name: ShippingMethod
    * * Display Name: Shipping Method
    * * SQL Data Type: uniqueidentifier
    */
    get ShippingMethod(): string | null {
        return this.Get('ShippingMethod');
    }
    set ShippingMethod(value: string | null) {
        this.Set('ShippingMethod', value);
    }

    /**
    * * Field Name: SavePaymentMethod
    * * Display Name: Save Payment Method
    * * SQL Data Type: bit
    */
    get SavePaymentMethod(): boolean | null {
        return this.Get('SavePaymentMethod');
    }
    set SavePaymentMethod(value: boolean | null) {
        this.Set('SavePaymentMethod', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: SavedPaymentMethod
    * * Display Name: Saved Payment Method
    * * SQL Data Type: uniqueidentifier
    */
    get SavedPaymentMethod(): string | null {
        return this.Get('SavedPaymentMethod');
    }
    set SavedPaymentMethod(value: string | null) {
        this.Set('SavedPaymentMethod', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: HideInPortal
    * * Display Name: Hide In Portal
    * * SQL Data Type: bit
    */
    get HideInPortal(): boolean | null {
        return this.Get('HideInPortal');
    }
    set HideInPortal(value: boolean | null) {
        this.Set('HideInPortal', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Organizations - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Organization
 * * Base View: vwOrganizations
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Organizations')
export class membersuiteOrganizationEntity extends BaseEntity<membersuiteOrganizationEntityType> {
    /**
    * Loads the MemberSuite: Organizations record from the database
    * @param ID: string - primary key value to load the MemberSuite: Organizations record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteOrganizationEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: SortName
    * * Display Name: Sort Name
    * * SQL Data Type: nvarchar(500)
    */
    get SortName(): string | null {
        return this.Get('SortName');
    }
    set SortName(value: string | null) {
        this.Set('SortName', value);
    }

    /**
    * * Field Name: BillingContactName
    * * Display Name: Billing Contact Name
    * * SQL Data Type: nvarchar(500)
    */
    get BillingContactName(): string | null {
        return this.Get('BillingContactName');
    }
    set BillingContactName(value: string | null) {
        this.Set('BillingContactName', value);
    }

    /**
    * * Field Name: FirstName
    * * Display Name: First Name
    * * SQL Data Type: nvarchar(500)
    */
    get FirstName(): string | null {
        return this.Get('FirstName');
    }
    set FirstName(value: string | null) {
        this.Set('FirstName', value);
    }

    /**
    * * Field Name: LastName
    * * Display Name: Last Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastName(): string | null {
        return this.Get('LastName');
    }
    set LastName(value: string | null) {
        this.Set('LastName', value);
    }

    /**
    * * Field Name: PaymentGatewayID
    * * Display Name: Payment Gateway ID
    * * SQL Data Type: nvarchar(500)
    */
    get PaymentGatewayID(): string | null {
        return this.Get('PaymentGatewayID');
    }
    set PaymentGatewayID(value: string | null) {
        this.Set('PaymentGatewayID', value);
    }

    /**
    * * Field Name: Status
    * * Display Name: Status
    * * SQL Data Type: uniqueidentifier
    */
    get Status(): string | null {
        return this.Get('Status');
    }
    set Status(value: string | null) {
        this.Set('Status', value);
    }

    /**
    * * Field Name: IneligibleFunds
    * * Display Name: Ineligible Funds
    * * SQL Data Type: uniqueidentifier
    */
    get IneligibleFunds(): string | null {
        return this.Get('IneligibleFunds');
    }
    set IneligibleFunds(value: string | null) {
        this.Set('IneligibleFunds', value);
    }

    /**
    * * Field Name: TaxExempt
    * * Display Name: Tax Exempt
    * * SQL Data Type: bit
    */
    get TaxExempt(): boolean | null {
        return this.Get('TaxExempt');
    }
    set TaxExempt(value: boolean | null) {
        this.Set('TaxExempt', value);
    }

    /**
    * * Field Name: DefaultCreditTerms
    * * Display Name: Default Credit Terms
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultCreditTerms(): string | null {
        return this.Get('DefaultCreditTerms');
    }
    set DefaultCreditTerms(value: string | null) {
        this.Set('DefaultCreditTerms', value);
    }

    /**
    * * Field Name: PreferredAddressType
    * * Display Name: Preferred Address Type
    * * SQL Data Type: uniqueidentifier
    */
    get PreferredAddressType(): string | null {
        return this.Get('PreferredAddressType');
    }
    set PreferredAddressType(value: string | null) {
        this.Set('PreferredAddressType', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: uniqueidentifier
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: DonorLevel
    * * Display Name: Donor Level
    * * SQL Data Type: uniqueidentifier
    */
    get DonorLevel(): string | null {
        return this.Get('DonorLevel');
    }
    set DonorLevel(value: string | null) {
        this.Set('DonorLevel', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: WebSite
    * * Display Name: Web Site
    * * SQL Data Type: nvarchar(512)
    */
    get WebSite(): string | null {
        return this.Get('WebSite');
    }
    set WebSite(value: string | null) {
        this.Set('WebSite', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: NRDSID
    * * Display Name: Nrdsid
    * * SQL Data Type: bigint
    */
    get NRDSID(): number | null {
        return this.Get('NRDSID');
    }
    set NRDSID(value: number | null) {
        this.Set('NRDSID', value);
    }

    /**
    * * Field Name: FacebookProfile
    * * Display Name: Facebook Profile
    * * SQL Data Type: nvarchar(500)
    */
    get FacebookProfile(): string | null {
        return this.Get('FacebookProfile');
    }
    set FacebookProfile(value: string | null) {
        this.Set('FacebookProfile', value);
    }

    /**
    * * Field Name: FacebookId
    * * Display Name: Facebook Id
    * * SQL Data Type: nvarchar(500)
    */
    get FacebookId(): string | null {
        return this.Get('FacebookId');
    }
    set FacebookId(value: string | null) {
        this.Set('FacebookId', value);
    }

    /**
    * * Field Name: TwitterHandle
    * * Display Name: Twitter Handle
    * * SQL Data Type: nvarchar(500)
    */
    get TwitterHandle(): string | null {
        return this.Get('TwitterHandle');
    }
    set TwitterHandle(value: string | null) {
        this.Set('TwitterHandle', value);
    }

    /**
    * * Field Name: TwitterId
    * * Display Name: Twitter Id
    * * SQL Data Type: nvarchar(500)
    */
    get TwitterId(): string | null {
        return this.Get('TwitterId');
    }
    set TwitterId(value: string | null) {
        this.Set('TwitterId', value);
    }

    /**
    * * Field Name: LinkedInProfile
    * * Display Name: Linked In Profile
    * * SQL Data Type: nvarchar(500)
    */
    get LinkedInProfile(): string | null {
        return this.Get('LinkedInProfile');
    }
    set LinkedInProfile(value: string | null) {
        this.Set('LinkedInProfile', value);
    }

    /**
    * * Field Name: LinkedInId
    * * Display Name: Linked In Id
    * * SQL Data Type: nvarchar(500)
    */
    get LinkedInId(): string | null {
        return this.Get('LinkedInId');
    }
    set LinkedInId(value: string | null) {
        this.Set('LinkedInId', value);
    }

    /**
    * * Field Name: GooglePlusUrl
    * * Display Name: Google Plus Url
    * * SQL Data Type: nvarchar(500)
    */
    get GooglePlusUrl(): string | null {
        return this.Get('GooglePlusUrl');
    }
    set GooglePlusUrl(value: string | null) {
        this.Set('GooglePlusUrl', value);
    }

    /**
    * * Field Name: GooglePlusId
    * * Display Name: Google Plus Id
    * * SQL Data Type: nvarchar(500)
    */
    get GooglePlusId(): string | null {
        return this.Get('GooglePlusId');
    }
    set GooglePlusId(value: string | null) {
        this.Set('GooglePlusId', value);
    }

    /**
    * * Field Name: InstagramProfile
    * * Display Name: Instagram Profile
    * * SQL Data Type: nvarchar(500)
    */
    get InstagramProfile(): string | null {
        return this.Get('InstagramProfile');
    }
    set InstagramProfile(value: string | null) {
        this.Set('InstagramProfile', value);
    }

    /**
    * * Field Name: InstagramId
    * * Display Name: Instagram Id
    * * SQL Data Type: nvarchar(500)
    */
    get InstagramId(): string | null {
        return this.Get('InstagramId');
    }
    set InstagramId(value: string | null) {
        this.Set('InstagramId', value);
    }

    /**
    * * Field Name: BillingContactPhoneNumber
    * * Display Name: Billing Contact Phone Number
    * * SQL Data Type: nvarchar(500)
    */
    get BillingContactPhoneNumber(): string | null {
        return this.Get('BillingContactPhoneNumber');
    }
    set BillingContactPhoneNumber(value: string | null) {
        this.Set('BillingContactPhoneNumber', value);
    }

    /**
    * * Field Name: EmailAddress
    * * Display Name: Email Address
    * * SQL Data Type: nvarchar(256)
    */
    get EmailAddress(): string | null {
        return this.Get('EmailAddress');
    }
    set EmailAddress(value: string | null) {
        this.Set('EmailAddress', value);
    }

    /**
    * * Field Name: JobPostingsAvailable
    * * Display Name: Job Postings Available
    * * SQL Data Type: bigint
    */
    get JobPostingsAvailable(): number | null {
        return this.Get('JobPostingsAvailable');
    }
    set JobPostingsAvailable(value: number | null) {
        this.Set('JobPostingsAvailable', value);
    }

    /**
    * * Field Name: ResumeAccessUntil
    * * Display Name: Resume Access Until
    * * SQL Data Type: datetime2
    */
    get ResumeAccessUntil(): Date | null {
        return this.Get('ResumeAccessUntil');
    }
    set ResumeAccessUntil(value: Date | null) {
        this.Set('ResumeAccessUntil', value);
    }

    /**
    * * Field Name: PreferredPhoneNumberType
    * * Display Name: Preferred Phone Number Type
    * * SQL Data Type: uniqueidentifier
    */
    get PreferredPhoneNumberType(): string | null {
        return this.Get('PreferredPhoneNumberType');
    }
    set PreferredPhoneNumberType(value: string | null) {
        this.Set('PreferredPhoneNumberType', value);
    }

    /**
    * * Field Name: ChFin_TotalRevenue__c
    * * Display Name: Ch Fin Total Revenue C
    * * SQL Data Type: nvarchar(500)
    */
    get ChFin_TotalRevenue__c(): string | null {
        return this.Get('ChFin_TotalRevenue__c');
    }
    set ChFin_TotalRevenue__c(value: string | null) {
        this.Set('ChFin_TotalRevenue__c', value);
    }

    /**
    * * Field Name: ChFin_TotalExpenses__c
    * * Display Name: Ch Fin Total Expenses C
    * * SQL Data Type: nvarchar(500)
    */
    get ChFin_TotalExpenses__c(): string | null {
        return this.Get('ChFin_TotalExpenses__c');
    }
    set ChFin_TotalExpenses__c(value: string | null) {
        this.Set('ChFin_TotalExpenses__c', value);
    }

    /**
    * * Field Name: ChFin_NetAssets__c
    * * Display Name: Ch Fin Net Assets C
    * * SQL Data Type: nvarchar(500)
    */
    get ChFin_NetAssets__c(): string | null {
        return this.Get('ChFin_NetAssets__c');
    }
    set ChFin_NetAssets__c(value: string | null) {
        this.Set('ChFin_NetAssets__c', value);
    }

    /**
    * * Field Name: ChFin_FiledTaxReturn__c
    * * Display Name: Ch Fin Filed Tax Return C
    * * SQL Data Type: bit
    */
    get ChFin_FiledTaxReturn__c(): boolean | null {
        return this.Get('ChFin_FiledTaxReturn__c');
    }
    set ChFin_FiledTaxReturn__c(value: boolean | null) {
        this.Set('ChFin_FiledTaxReturn__c', value);
    }

    /**
    * * Field Name: ChFin_GroupExemption__c
    * * Display Name: Ch Fin Group Exemption C
    * * SQL Data Type: bit
    */
    get ChFin_GroupExemption__c(): boolean | null {
        return this.Get('ChFin_GroupExemption__c');
    }
    set ChFin_GroupExemption__c(value: boolean | null) {
        this.Set('ChFin_GroupExemption__c', value);
    }

    /**
    * * Field Name: ChOff_ElectiveDateBegin__c
    * * Display Name: Ch Off Elective Date Begin C
    * * SQL Data Type: nvarchar(500)
    */
    get ChOff_ElectiveDateBegin__c(): string | null {
        return this.Get('ChOff_ElectiveDateBegin__c');
    }
    set ChOff_ElectiveDateBegin__c(value: string | null) {
        this.Set('ChOff_ElectiveDateBegin__c', value);
    }

    /**
    * * Field Name: ChOff_ElectiveDateEnd__c
    * * Display Name: Ch Off Elective Date End C
    * * SQL Data Type: nvarchar(500)
    */
    get ChOff_ElectiveDateEnd__c(): string | null {
        return this.Get('ChOff_ElectiveDateEnd__c');
    }
    set ChOff_ElectiveDateEnd__c(value: string | null) {
        this.Set('ChOff_ElectiveDateEnd__c', value);
    }

    /**
    * * Field Name: ChOff_Office__c
    * * Display Name: Ch Off Office C
    * * SQL Data Type: nvarchar(500)
    */
    get ChOff_Office__c(): string | null {
        return this.Get('ChOff_Office__c');
    }
    set ChOff_Office__c(value: string | null) {
        this.Set('ChOff_Office__c', value);
    }

    /**
    * * Field Name: ChOff_Term__c
    * * Display Name: Ch Off Term C
    * * SQL Data Type: nvarchar(500)
    */
    get ChOff_Term__c(): string | null {
        return this.Get('ChOff_Term__c');
    }
    set ChOff_Term__c(value: string | null) {
        this.Set('ChOff_Term__c', value);
    }

    /**
    * * Field Name: ChJur_County__c
    * * Display Name: Ch Jur County C
    * * SQL Data Type: nvarchar(500)
    */
    get ChJur_County__c(): string | null {
        return this.Get('ChJur_County__c');
    }
    set ChJur_County__c(value: string | null) {
        this.Set('ChJur_County__c', value);
    }

    /**
    * * Field Name: ChJur_State__c
    * * Display Name: Ch Jur State C
    * * SQL Data Type: nvarchar(500)
    */
    get ChJur_State__c(): string | null {
        return this.Get('ChJur_State__c');
    }
    set ChJur_State__c(value: string | null) {
        this.Set('ChJur_State__c', value);
    }

    /**
    * * Field Name: ChJur_Country__c
    * * Display Name: Ch Jur Country C
    * * SQL Data Type: nvarchar(500)
    */
    get ChJur_Country__c(): string | null {
        return this.Get('ChJur_Country__c');
    }
    set ChJur_Country__c(value: string | null) {
        this.Set('ChJur_Country__c', value);
    }

    /**
    * * Field Name: ChSpon_Year__c
    * * Display Name: Ch Spon Year C
    * * SQL Data Type: nvarchar(500)
    */
    get ChSpon_Year__c(): string | null {
        return this.Get('ChSpon_Year__c');
    }
    set ChSpon_Year__c(value: string | null) {
        this.Set('ChSpon_Year__c', value);
    }

    /**
    * * Field Name: ChSpon_SponsorID__c
    * * Display Name: Ch Spon Sponsor IDC
    * * SQL Data Type: nvarchar(500)
    */
    get ChSpon_SponsorID__c(): string | null {
        return this.Get('ChSpon_SponsorID__c');
    }
    set ChSpon_SponsorID__c(value: string | null) {
        this.Set('ChSpon_SponsorID__c', value);
    }

    /**
    * * Field Name: ChSpon_SponsorLevel__c
    * * Display Name: Ch Spon Sponsor Level C
    * * SQL Data Type: nvarchar(500)
    */
    get ChSpon_SponsorLevel__c(): string | null {
        return this.Get('ChSpon_SponsorLevel__c');
    }
    set ChSpon_SponsorLevel__c(value: string | null) {
        this.Set('ChSpon_SponsorLevel__c', value);
    }

    /**
    * * Field Name: ChSpon_Rate__c
    * * Display Name: Ch Spon Rate C
    * * SQL Data Type: nvarchar(500)
    */
    get ChSpon_Rate__c(): string | null {
        return this.Get('ChSpon_Rate__c');
    }
    set ChSpon_Rate__c(value: string | null) {
        this.Set('ChSpon_Rate__c', value);
    }

    /**
    * * Field Name: ChByl_BylawsCurrent__c
    * * Display Name: Ch Byl Bylaws Current C
    * * SQL Data Type: bit
    */
    get ChByl_BylawsCurrent__c(): boolean | null {
        return this.Get('ChByl_BylawsCurrent__c');
    }
    set ChByl_BylawsCurrent__c(value: boolean | null) {
        this.Set('ChByl_BylawsCurrent__c', value);
    }

    /**
    * * Field Name: ChByl_ApprovalNotes__c
    * * Display Name: Ch Byl Approval Notes C
    * * SQL Data Type: nvarchar(500)
    */
    get ChByl_ApprovalNotes__c(): string | null {
        return this.Get('ChByl_ApprovalNotes__c');
    }
    set ChByl_ApprovalNotes__c(value: string | null) {
        this.Set('ChByl_ApprovalNotes__c', value);
    }

    /**
    * * Field Name: ChFin_FiscalYearBegin__c
    * * Display Name: Ch Fin Fiscal Year Begin C
    * * SQL Data Type: date
    */
    get ChFin_FiscalYearBegin__c(): Date | null {
        return this.Get('ChFin_FiscalYearBegin__c');
    }
    set ChFin_FiscalYearBegin__c(value: Date | null) {
        this.Set('ChFin_FiscalYearBegin__c', value);
    }

    /**
    * * Field Name: ChFin_FiscalYearEnd__c
    * * Display Name: Ch Fin Fiscal Year End C
    * * SQL Data Type: date
    */
    get ChFin_FiscalYearEnd__c(): Date | null {
        return this.Get('ChFin_FiscalYearEnd__c');
    }
    set ChFin_FiscalYearEnd__c(value: Date | null) {
        this.Set('ChFin_FiscalYearEnd__c', value);
    }

    /**
    * * Field Name: ChByl_ApprovalDate__c
    * * Display Name: Ch Byl Approval Date C
    * * SQL Data Type: date
    */
    get ChByl_ApprovalDate__c(): Date | null {
        return this.Get('ChByl_ApprovalDate__c');
    }
    set ChByl_ApprovalDate__c(value: Date | null) {
        this.Set('ChByl_ApprovalDate__c', value);
    }

    /**
    * * Field Name: Mailing_Address
    * * Display Name: Mailing Address
    * * SQL Data Type: nvarchar(500)
    */
    get Mailing_Address(): string | null {
        return this.Get('Mailing_Address');
    }
    set Mailing_Address(value: string | null) {
        this.Set('Mailing_Address', value);
    }

    /**
    * * Field Name: Work_Address
    * * Display Name: Work Address
    * * SQL Data Type: nvarchar(500)
    */
    get Work_Address(): string | null {
        return this.Get('Work_Address');
    }
    set Work_Address(value: string | null) {
        this.Set('Work_Address', value);
    }

    /**
    * * Field Name: MainOffice_PhoneNumber
    * * Display Name: Main Office Phone Number
    * * SQL Data Type: nvarchar(64)
    */
    get MainOffice_PhoneNumber(): string | null {
        return this.Get('MainOffice_PhoneNumber');
    }
    set MainOffice_PhoneNumber(value: string | null) {
        this.Set('MainOffice_PhoneNumber', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Payment Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: PaymentLineItem
 * * Base View: vwPaymentLineItems
 * * Primary Key: paymentLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Payment Line Items')
export class membersuitePaymentLineItemEntity extends BaseEntity<membersuitePaymentLineItemEntityType> {
    /**
    * Loads the MemberSuite: Payment Line Items record from the database
    * @param paymentLineItemID: string - primary key value to load the MemberSuite: Payment Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuitePaymentLineItemEntity
    * @method
    * @override
    */
    public async Load(paymentLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'paymentLineItemID', Value: paymentLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: paymentLineItemID
    * * Display Name: payment Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get paymentLineItemID(): string {
        return this.Get('paymentLineItemID');
    }
    set paymentLineItemID(value: string) {
        this.Set('paymentLineItemID', value);
    }

    /**
    * * Field Name: type
    * * Display Name: type
    * * SQL Data Type: bigint
    */
    get type(): number | null {
        return this.Get('type');
    }
    set type(value: number | null) {
        this.Set('type', value);
    }

    /**
    * * Field Name: invoice
    * * Display Name: invoice
    * * SQL Data Type: nvarchar(500)
    */
    get invoice(): string | null {
        return this.Get('invoice');
    }
    set invoice(value: string | null) {
        this.Set('invoice', value);
    }

    /**
    * * Field Name: invoiceLineItemID
    * * Display Name: invoice Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get invoiceLineItemID(): string | null {
        return this.Get('invoiceLineItemID');
    }
    set invoiceLineItemID(value: string | null) {
        this.Set('invoiceLineItemID', value);
    }

    /**
    * * Field Name: currencyCode
    * * Display Name: currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get currencyCode(): string | null {
        return this.Get('currencyCode');
    }
    set currencyCode(value: string | null) {
        this.Set('currencyCode', value);
    }

    /**
    * * Field Name: exchangeRate
    * * Display Name: exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get exchangeRate(): number | null {
        return this.Get('exchangeRate');
    }
    set exchangeRate(value: number | null) {
        this.Set('exchangeRate', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: invoiceLineItemTotalAtTheTimeOfPayment
    * * Display Name: invoice Line Item Total At The Time Of Payment
    * * SQL Data Type: decimal(19, 4)
    */
    get invoiceLineItemTotalAtTheTimeOfPayment(): number | null {
        return this.Get('invoiceLineItemTotalAtTheTimeOfPayment');
    }
    set invoiceLineItemTotalAtTheTimeOfPayment(value: number | null) {
        this.Set('invoiceLineItemTotalAtTheTimeOfPayment', value);
    }

    /**
    * * Field Name: invoiceLineItemBalanceDueAtTheTimeOfPayment
    * * Display Name: invoice Line Item Balance Due At The Time Of Payment
    * * SQL Data Type: decimal(19, 4)
    */
    get invoiceLineItemBalanceDueAtTheTimeOfPayment(): number | null {
        return this.Get('invoiceLineItemBalanceDueAtTheTimeOfPayment');
    }
    set invoiceLineItemBalanceDueAtTheTimeOfPayment(value: number | null) {
        this.Set('invoiceLineItemBalanceDueAtTheTimeOfPayment', value);
    }

    /**
    * * Field Name: invoiceLineItemBalanceDueAfterPayment
    * * Display Name: invoice Line Item Balance Due After Payment
    * * SQL Data Type: decimal(19, 4)
    */
    get invoiceLineItemBalanceDueAfterPayment(): number | null {
        return this.Get('invoiceLineItemBalanceDueAfterPayment');
    }
    set invoiceLineItemBalanceDueAfterPayment(value: number | null) {
        this.Set('invoiceLineItemBalanceDueAfterPayment', value);
    }

    /**
    * * Field Name: amountRefunded
    * * Display Name: amount Refunded
    * * SQL Data Type: decimal(19, 4)
    */
    get amountRefunded(): number | null {
        return this.Get('amountRefunded');
    }
    set amountRefunded(value: number | null) {
        this.Set('amountRefunded', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: Payment
    * * Display Name: Payment
    * * SQL Data Type: uniqueidentifier
    */
    get Payment(): string | null {
        return this.Get('Payment');
    }
    set Payment(value: string | null) {
        this.Set('Payment', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Payments - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Payment
 * * Base View: vwPayments
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Payments')
export class membersuitePaymentEntity extends BaseEntity<membersuitePaymentEntityType> {
    /**
    * Loads the MemberSuite: Payments record from the database
    * @param ID: string - primary key value to load the MemberSuite: Payments record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuitePaymentEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: CreditCardType
    * * Display Name: Credit Card Type
    * * SQL Data Type: nvarchar(100)
    */
    get CreditCardType(): string | null {
        return this.Get('CreditCardType');
    }
    set CreditCardType(value: string | null) {
        this.Set('CreditCardType', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: PaymentMethod
    * * Display Name: Payment Method
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentMethod(): string | null {
        return this.Get('PaymentMethod');
    }
    set PaymentMethod(value: string | null) {
        this.Set('PaymentMethod', value);
    }

    /**
    * * Field Name: ReferenceNumber
    * * Display Name: Reference Number
    * * SQL Data Type: nvarchar(500)
    */
    get ReferenceNumber(): string | null {
        return this.Get('ReferenceNumber');
    }
    set ReferenceNumber(value: string | null) {
        this.Set('ReferenceNumber', value);
    }

    /**
    * * Field Name: Owner
    * * Display Name: Owner
    * * SQL Data Type: uniqueidentifier
    */
    get Owner(): string | null {
        return this.Get('Owner');
    }
    set Owner(value: string | null) {
        this.Set('Owner', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: PaymentThatThisTransactionReverses
    * * Display Name: Payment That This Transaction Reverses
    * * SQL Data Type: uniqueidentifier
    */
    get PaymentThatThisTransactionReverses(): string | null {
        return this.Get('PaymentThatThisTransactionReverses');
    }
    set PaymentThatThisTransactionReverses(value: string | null) {
        this.Set('PaymentThatThisTransactionReverses', value);
    }

    /**
    * * Field Name: BankReconciliation
    * * Display Name: Bank Reconciliation
    * * SQL Data Type: uniqueidentifier
    */
    get BankReconciliation(): string | null {
        return this.Get('BankReconciliation');
    }
    set BankReconciliation(value: string | null) {
        this.Set('BankReconciliation', value);
    }

    /**
    * * Field Name: IsVoid
    * * Display Name: Is Void
    * * SQL Data Type: bit
    */
    get IsVoid(): boolean | null {
        return this.Get('IsVoid');
    }
    set IsVoid(value: boolean | null) {
        this.Set('IsVoid', value);
    }

    /**
    * * Field Name: AmountPendingCapture
    * * Display Name: Amount Pending Capture
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountPendingCapture(): number | null {
        return this.Get('AmountPendingCapture');
    }
    set AmountPendingCapture(value: number | null) {
        this.Set('AmountPendingCapture', value);
    }

    /**
    * * Field Name: CashAccount
    * * Display Name: Cash Account
    * * SQL Data Type: uniqueidentifier
    */
    get CashAccount(): string | null {
        return this.Get('CashAccount');
    }
    set CashAccount(value: string | null) {
        this.Set('CashAccount', value);
    }

    /**
    * * Field Name: TransactionID
    * * Display Name: Transaction ID
    * * SQL Data Type: nvarchar(500)
    */
    get TransactionID(): string | null {
        return this.Get('TransactionID');
    }
    set TransactionID(value: string | null) {
        this.Set('TransactionID', value);
    }

    /**
    * * Field Name: CreditCardLastFiveDigits
    * * Display Name: Credit Card Last Five Digits
    * * SQL Data Type: nvarchar(500)
    */
    get CreditCardLastFiveDigits(): string | null {
        return this.Get('CreditCardLastFiveDigits');
    }
    set CreditCardLastFiveDigits(value: string | null) {
        this.Set('CreditCardLastFiveDigits', value);
    }

    /**
    * * Field Name: WasAutomaticallyGenerated
    * * Display Name: Was Automatically Generated
    * * SQL Data Type: bit
    */
    get WasAutomaticallyGenerated(): boolean | null {
        return this.Get('WasAutomaticallyGenerated');
    }
    set WasAutomaticallyGenerated(value: boolean | null) {
        this.Set('WasAutomaticallyGenerated', value);
    }

    /**
    * * Field Name: AmountReconciled
    * * Display Name: Amount Reconciled
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountReconciled(): number | null {
        return this.Get('AmountReconciled');
    }
    set AmountReconciled(value: number | null) {
        this.Set('AmountReconciled', value);
    }

    /**
    * * Field Name: CurrencyFluctuationAdjustment
    * * Display Name: Currency Fluctuation Adjustment
    * * SQL Data Type: decimal(19, 4)
    */
    get CurrencyFluctuationAdjustment(): number | null {
        return this.Get('CurrencyFluctuationAdjustment');
    }
    set CurrencyFluctuationAdjustment(value: number | null) {
        this.Set('CurrencyFluctuationAdjustment', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: WebSECCode
    * * Display Name: Web SEC Code
    * * SQL Data Type: nvarchar(100)
    */
    get WebSECCode(): string | null {
        return this.Get('WebSECCode');
    }
    set WebSECCode(value: string | null) {
        this.Set('WebSECCode', value);
    }

    /**
    * * Field Name: Status
    * * Display Name: Status
    * * SQL Data Type: nvarchar(500)
    */
    get Status(): string | null {
        return this.Get('Status');
    }
    set Status(value: string | null) {
        this.Set('Status', value);
    }

    /**
    * * Field Name: PayoutID
    * * Display Name: Payout ID
    * * SQL Data Type: nvarchar(500)
    */
    get PayoutID(): string | null {
        return this.Get('PayoutID');
    }
    set PayoutID(value: string | null) {
        this.Set('PayoutID', value);
    }

    /**
    * * Field Name: PayoutStatus
    * * Display Name: Payout Status
    * * SQL Data Type: nvarchar(500)
    */
    get PayoutStatus(): string | null {
        return this.Get('PayoutStatus');
    }
    set PayoutStatus(value: string | null) {
        this.Set('PayoutStatus', value);
    }

    /**
    * * Field Name: PayoutFee
    * * Display Name: Payout Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get PayoutFee(): number | null {
        return this.Get('PayoutFee');
    }
    set PayoutFee(value: number | null) {
        this.Set('PayoutFee', value);
    }

    /**
    * * Field Name: PayoutNet
    * * Display Name: Payout Net
    * * SQL Data Type: decimal(19, 4)
    */
    get PayoutNet(): number | null {
        return this.Get('PayoutNet');
    }
    set PayoutNet(value: number | null) {
        this.Set('PayoutNet', value);
    }

    /**
    * * Field Name: PayoutAvailableOn
    * * Display Name: Payout Available On
    * * SQL Data Type: datetime2
    */
    get PayoutAvailableOn(): Date | null {
        return this.Get('PayoutAvailableOn');
    }
    set PayoutAvailableOn(value: Date | null) {
        this.Set('PayoutAvailableOn', value);
    }

    /**
    * * Field Name: PayoutCreatedAt
    * * Display Name: Payout Created At
    * * SQL Data Type: datetime2
    */
    get PayoutCreatedAt(): Date | null {
        return this.Get('PayoutCreatedAt');
    }
    set PayoutCreatedAt(value: Date | null) {
        this.Set('PayoutCreatedAt', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Product
 * * Base View: vwProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Products')
export class membersuiteProductEntity extends BaseEntity<membersuiteProductEntityType> {
    /**
    * Loads the MemberSuite: Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: nvarchar(MAX)
    */
    get Description(): string | null {
        return this.Get('Description');
    }
    set Description(value: string | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Refund Line Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: RefundLineItem
 * * Base View: vwRefundLineItems
 * * Primary Key: paymentLineItemID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Refund Line Items')
export class membersuiteRefundLineItemEntity extends BaseEntity<membersuiteRefundLineItemEntityType> {
    /**
    * Loads the MemberSuite: Refund Line Items record from the database
    * @param paymentLineItemID: string - primary key value to load the MemberSuite: Refund Line Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteRefundLineItemEntity
    * @method
    * @override
    */
    public async Load(paymentLineItemID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'paymentLineItemID', Value: paymentLineItemID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: paymentLineItemID
    * * Display Name: payment Line Item ID
    * * SQL Data Type: uniqueidentifier
    */
    get paymentLineItemID(): string {
        return this.Get('paymentLineItemID');
    }
    set paymentLineItemID(value: string) {
        this.Set('paymentLineItemID', value);
    }

    /**
    * * Field Name: total
    * * Display Name: total
    * * SQL Data Type: decimal(19, 4)
    */
    get total(): number | null {
        return this.Get('total');
    }
    set total(value: number | null) {
        this.Set('total', value);
    }

    /**
    * * Field Name: totalInBaseCurrency
    * * Display Name: total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get totalInBaseCurrency(): number | null {
        return this.Get('totalInBaseCurrency');
    }
    set totalInBaseCurrency(value: number | null) {
        this.Set('totalInBaseCurrency', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: Refund
    * * Display Name: Refund
    * * SQL Data Type: uniqueidentifier
    */
    get Refund(): string | null {
        return this.Get('Refund');
    }
    set Refund(value: string | null) {
        this.Set('Refund', value);
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Refunds - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: Refund
 * * Base View: vwRefunds
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Refunds')
export class membersuiteRefundEntity extends BaseEntity<membersuiteRefundEntityType> {
    /**
    * Loads the MemberSuite: Refunds record from the database
    * @param ID: string - primary key value to load the MemberSuite: Refunds record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteRefundEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: InvoiceInstructions
    * * Display Name: Invoice Instructions
    * * SQL Data Type: nvarchar(100)
    */
    get InvoiceInstructions(): string | null {
        return this.Get('InvoiceInstructions');
    }
    set InvoiceInstructions(value: string | null) {
        this.Set('InvoiceInstructions', value);
    }

    /**
    * * Field Name: Credit
    * * Display Name: Credit
    * * SQL Data Type: uniqueidentifier
    */
    get Credit(): string | null {
        return this.Get('Credit');
    }
    set Credit(value: string | null) {
        this.Set('Credit', value);
    }

    /**
    * * Field Name: Payment
    * * Display Name: Payment
    * * SQL Data Type: uniqueidentifier
    */
    get Payment(): string | null {
        return this.Get('Payment');
    }
    set Payment(value: string | null) {
        this.Set('Payment', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: BankReconciliation
    * * Display Name: Bank Reconciliation
    * * SQL Data Type: uniqueidentifier
    */
    get BankReconciliation(): string | null {
        return this.Get('BankReconciliation');
    }
    set BankReconciliation(value: string | null) {
        this.Set('BankReconciliation', value);
    }

    /**
    * * Field Name: TransactionID
    * * Display Name: Transaction ID
    * * SQL Data Type: nvarchar(500)
    */
    get TransactionID(): string | null {
        return this.Get('TransactionID');
    }
    set TransactionID(value: string | null) {
        this.Set('TransactionID', value);
    }

    /**
    * * Field Name: ExchangeRate
    * * Display Name: Exchange Rate
    * * SQL Data Type: decimal(19, 4)
    */
    get ExchangeRate(): number | null {
        return this.Get('ExchangeRate');
    }
    set ExchangeRate(value: number | null) {
        this.Set('ExchangeRate', value);
    }

    /**
    * * Field Name: IgnorePaymentGatewayErrors
    * * Display Name: Ignore Payment Gateway Errors
    * * SQL Data Type: bit
    */
    get IgnorePaymentGatewayErrors(): boolean | null {
        return this.Get('IgnorePaymentGatewayErrors');
    }
    set IgnorePaymentGatewayErrors(value: boolean | null) {
        this.Set('IgnorePaymentGatewayErrors', value);
    }

    /**
    * * Field Name: AmountReconciled
    * * Display Name: Amount Reconciled
    * * SQL Data Type: decimal(19, 4)
    */
    get AmountReconciled(): number | null {
        return this.Get('AmountReconciled');
    }
    set AmountReconciled(value: number | null) {
        this.Set('AmountReconciled', value);
    }

    /**
    * * Field Name: CurrencyFluctuationAdjustment
    * * Display Name: Currency Fluctuation Adjustment
    * * SQL Data Type: decimal(19, 4)
    */
    get CurrencyFluctuationAdjustment(): number | null {
        return this.Get('CurrencyFluctuationAdjustment');
    }
    set CurrencyFluctuationAdjustment(value: number | null) {
        this.Set('CurrencyFluctuationAdjustment', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: PayoutID
    * * Display Name: Payout ID
    * * SQL Data Type: nvarchar(500)
    */
    get PayoutID(): string | null {
        return this.Get('PayoutID');
    }
    set PayoutID(value: string | null) {
        this.Set('PayoutID', value);
    }

    /**
    * * Field Name: PayoutStatus
    * * Display Name: Payout Status
    * * SQL Data Type: nvarchar(500)
    */
    get PayoutStatus(): string | null {
        return this.Get('PayoutStatus');
    }
    set PayoutStatus(value: string | null) {
        this.Set('PayoutStatus', value);
    }

    /**
    * * Field Name: PayoutFee
    * * Display Name: Payout Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get PayoutFee(): number | null {
        return this.Get('PayoutFee');
    }
    set PayoutFee(value: number | null) {
        this.Set('PayoutFee', value);
    }

    /**
    * * Field Name: PayoutNet
    * * Display Name: Payout Net
    * * SQL Data Type: decimal(19, 4)
    */
    get PayoutNet(): number | null {
        return this.Get('PayoutNet');
    }
    set PayoutNet(value: number | null) {
        this.Set('PayoutNet', value);
    }

    /**
    * * Field Name: PayoutAvailableOn
    * * Display Name: Payout Available On
    * * SQL Data Type: datetime2
    */
    get PayoutAvailableOn(): Date | null {
        return this.Get('PayoutAvailableOn');
    }
    set PayoutAvailableOn(value: Date | null) {
        this.Set('PayoutAvailableOn', value);
    }

    /**
    * * Field Name: PayoutCreatedAt
    * * Display Name: Payout Created At
    * * SQL Data Type: datetime2
    */
    get PayoutCreatedAt(): Date | null {
        return this.Get('PayoutCreatedAt');
    }
    set PayoutCreatedAt(value: Date | null) {
        this.Set('PayoutCreatedAt', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Registration Fees - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: RegistrationFee
 * * Base View: vwRegistrationFees
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Registration Fees')
export class membersuiteRegistrationFeeEntity extends BaseEntity<membersuiteRegistrationFeeEntityType> {
    /**
    * Loads the MemberSuite: Registration Fees record from the database
    * @param ID: string - primary key value to load the MemberSuite: Registration Fees record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteRegistrationFeeEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: CancellationFeeRuleSet
    * * Display Name: Cancellation Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeRuleSet(): string | null {
        return this.Get('CancellationFeeRuleSet');
    }
    set CancellationFeeRuleSet(value: string | null) {
        this.Set('CancellationFeeRuleSet', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: TieredRegistrationPricingRuleSet
    * * Display Name: Tiered Registration Pricing Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get TieredRegistrationPricingRuleSet(): string | null {
        return this.Get('TieredRegistrationPricingRuleSet');
    }
    set TieredRegistrationPricingRuleSet(value: string | null) {
        this.Set('TieredRegistrationPricingRuleSet', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: IsGuestRegistration
    * * Display Name: Is Guest Registration
    * * SQL Data Type: bit
    */
    get IsGuestRegistration(): boolean | null {
        return this.Get('IsGuestRegistration');
    }
    set IsGuestRegistration(value: boolean | null) {
        this.Set('IsGuestRegistration', value);
    }

    /**
    * * Field Name: Event
    * * Display Name: Event
    * * SQL Data Type: uniqueidentifier
    */
    get Event(): string | null {
        return this.Get('Event');
    }
    set Event(value: string | null) {
        this.Set('Event', value);
    }

    /**
    * * Field Name: CustomerType
    * * Display Name: Customer Type
    * * SQL Data Type: nvarchar(100)
    */
    get CustomerType(): string | null {
        return this.Get('CustomerType');
    }
    set CustomerType(value: string | null) {
        this.Set('CustomerType', value);
    }

    /**
    * * Field Name: RequiresApproval
    * * Display Name: Requires Approval
    * * SQL Data Type: bit
    */
    get RequiresApproval(): boolean | null {
        return this.Get('RequiresApproval');
    }
    set RequiresApproval(value: boolean | null) {
        this.Set('RequiresApproval', value);
    }

    /**
    * * Field Name: Agenda
    * * Display Name: Agenda
    * * SQL Data Type: uniqueidentifier
    */
    get Agenda(): string | null {
        return this.Get('Agenda');
    }
    set Agenda(value: string | null) {
        this.Set('Agenda', value);
    }

    /**
    * * Field Name: RegistrantCategory
    * * Display Name: Registrant Category
    * * SQL Data Type: uniqueidentifier
    */
    get RegistrantCategory(): string | null {
        return this.Get('RegistrantCategory');
    }
    set RegistrantCategory(value: string | null) {
        this.Set('RegistrantCategory', value);
    }

    /**
    * * Field Name: RegistrantClass
    * * Display Name: Registrant Class
    * * SQL Data Type: uniqueidentifier
    */
    get RegistrantClass(): string | null {
        return this.Get('RegistrantClass');
    }
    set RegistrantClass(value: string | null) {
        this.Set('RegistrantClass', value);
    }

    /**
    * * Field Name: EarlyRegistrationPrice
    * * Display Name: Early Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get EarlyRegistrationPrice(): number | null {
        return this.Get('EarlyRegistrationPrice');
    }
    set EarlyRegistrationPrice(value: number | null) {
        this.Set('EarlyRegistrationPrice', value);
    }

    /**
    * * Field Name: LateRegistrationPrice
    * * Display Name: Late Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get LateRegistrationPrice(): number | null {
        return this.Get('LateRegistrationPrice');
    }
    set LateRegistrationPrice(value: number | null) {
        this.Set('LateRegistrationPrice', value);
    }

    /**
    * * Field Name: PreRegistrationPrice
    * * Display Name: Pre Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get PreRegistrationPrice(): number | null {
        return this.Get('PreRegistrationPrice');
    }
    set PreRegistrationPrice(value: number | null) {
        this.Set('PreRegistrationPrice', value);
    }

    /**
    * * Field Name: MemberEarlyRegistrationPrice
    * * Display Name: Member Early Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberEarlyRegistrationPrice(): number | null {
        return this.Get('MemberEarlyRegistrationPrice');
    }
    set MemberEarlyRegistrationPrice(value: number | null) {
        this.Set('MemberEarlyRegistrationPrice', value);
    }

    /**
    * * Field Name: MemberLateRegistrationPrice
    * * Display Name: Member Late Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberLateRegistrationPrice(): number | null {
        return this.Get('MemberLateRegistrationPrice');
    }
    set MemberLateRegistrationPrice(value: number | null) {
        this.Set('MemberLateRegistrationPrice', value);
    }

    /**
    * * Field Name: MemberPreRegistrationPrice
    * * Display Name: Member Pre Registration Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPreRegistrationPrice(): number | null {
        return this.Get('MemberPreRegistrationPrice');
    }
    set MemberPreRegistrationPrice(value: number | null) {
        this.Set('MemberPreRegistrationPrice', value);
    }

    /**
    * * Field Name: RestrictByMembershipType
    * * Display Name: Restrict By Membership Type
    * * SQL Data Type: bit
    */
    get RestrictByMembershipType(): boolean | null {
        return this.Get('RestrictByMembershipType');
    }
    set RestrictByMembershipType(value: boolean | null) {
        this.Set('RestrictByMembershipType', value);
    }

    /**
    * * Field Name: RestrictSessionsByTimeSlots
    * * Display Name: Restrict Sessions By Time Slots
    * * SQL Data Type: bit
    */
    get RestrictSessionsByTimeSlots(): boolean | null {
        return this.Get('RestrictSessionsByTimeSlots');
    }
    set RestrictSessionsByTimeSlots(value: boolean | null) {
        this.Set('RestrictSessionsByTimeSlots', value);
    }

    /**
    * * Field Name: RestrictSessionsByTracks
    * * Display Name: Restrict Sessions By Tracks
    * * SQL Data Type: bit
    */
    get RestrictSessionsByTracks(): boolean | null {
        return this.Get('RestrictSessionsByTracks');
    }
    set RestrictSessionsByTracks(value: boolean | null) {
        this.Set('RestrictSessionsByTracks', value);
    }

    /**
    * * Field Name: MaximumNumberOfSessions
    * * Display Name: Maximum Number Of Sessions
    * * SQL Data Type: bigint
    */
    get MaximumNumberOfSessions(): number | null {
        return this.Get('MaximumNumberOfSessions');
    }
    set MaximumNumberOfSessions(value: number | null) {
        this.Set('MaximumNumberOfSessions', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Revenue Recognition Schedule Entries - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: RevenueRecognitionScheduleEntry
 * * Base View: vwRevenueRecognitionScheduleEntries
 * * Primary Key: entryID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Revenue Recognition Schedule Entries')
export class membersuiteRevenueRecognitionScheduleEntryEntity extends BaseEntity<membersuiteRevenueRecognitionScheduleEntryEntityType> {
    /**
    * Loads the MemberSuite: Revenue Recognition Schedule Entries record from the database
    * @param entryID: string - primary key value to load the MemberSuite: Revenue Recognition Schedule Entries record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteRevenueRecognitionScheduleEntryEntity
    * @method
    * @override
    */
    public async Load(entryID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'entryID', Value: entryID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: _ParentID
    * * Display Name: Parent ID
    * * SQL Data Type: uniqueidentifier
    */
    get _ParentID(): string | null {
        return this.Get('_ParentID');
    }
    set _ParentID(value: string | null) {
        this.Set('_ParentID', value);
    }

    /**
    * * Field Name: deferredRevenueGLCode
    * * Display Name: deferred Revenue GL Code
    * * SQL Data Type: nvarchar(500)
    */
    get deferredRevenueGLCode(): string | null {
        return this.Get('deferredRevenueGLCode');
    }
    set deferredRevenueGLCode(value: string | null) {
        this.Set('deferredRevenueGLCode', value);
    }

    /**
    * * Field Name: revenueGLCode
    * * Display Name: revenue GL Code
    * * SQL Data Type: nvarchar(500)
    */
    get revenueGLCode(): string | null {
        return this.Get('revenueGLCode');
    }
    set revenueGLCode(value: string | null) {
        this.Set('revenueGLCode', value);
    }

    /**
    * * Field Name: parentEntryID
    * * Display Name: parent Entry ID
    * * SQL Data Type: nvarchar(500)
    */
    get parentEntryID(): string | null {
        return this.Get('parentEntryID');
    }
    set parentEntryID(value: string | null) {
        this.Set('parentEntryID', value);
    }

    /**
    * * Field Name: revenueSplitID
    * * Display Name: revenue Split ID
    * * SQL Data Type: nvarchar(500)
    */
    get revenueSplitID(): string | null {
        return this.Get('revenueSplitID');
    }
    set revenueSplitID(value: string | null) {
        this.Set('revenueSplitID', value);
    }

    /**
    * * Field Name: subledgerEntry
    * * Display Name: subledger Entry
    * * SQL Data Type: nvarchar(500)
    */
    get subledgerEntry(): string | null {
        return this.Get('subledgerEntry');
    }
    set subledgerEntry(value: string | null) {
        this.Set('subledgerEntry', value);
    }

    /**
    * * Field Name: entryID
    * * Display Name: entry ID
    * * SQL Data Type: uniqueidentifier
    */
    get entryID(): string {
        return this.Get('entryID');
    }
    set entryID(value: string) {
        this.Set('entryID', value);
    }

    /**
    * * Field Name: dateProcessed
    * * Display Name: date Processed
    * * SQL Data Type: datetime2
    */
    get dateProcessed(): Date | null {
        return this.Get('dateProcessed');
    }
    set dateProcessed(value: Date | null) {
        this.Set('dateProcessed', value);
    }

    /**
    * * Field Name: date
    * * Display Name: date
    * * SQL Data Type: datetime2
    */
    get date(): Date | null {
        return this.Get('date');
    }
    set date(value: Date | null) {
        this.Set('date', value);
    }

    /**
    * * Field Name: amount
    * * Display Name: amount
    * * SQL Data Type: decimal(19, 4)
    */
    get amount(): number | null {
        return this.Get('amount');
    }
    set amount(value: number | null) {
        this.Set('amount', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Revenue Recognition Schedules - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: RevenueRecognitionSchedule
 * * Base View: vwRevenueRecognitionSchedules
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Revenue Recognition Schedules')
export class membersuiteRevenueRecognitionScheduleEntity extends BaseEntity<membersuiteRevenueRecognitionScheduleEntityType> {
    /**
    * Loads the MemberSuite: Revenue Recognition Schedules record from the database
    * @param ID: string - primary key value to load the MemberSuite: Revenue Recognition Schedules record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteRevenueRecognitionScheduleEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: IsSuspended
    * * Display Name: Is Suspended
    * * SQL Data Type: bit
    */
    get IsSuspended(): boolean | null {
        return this.Get('IsSuspended');
    }
    set IsSuspended(value: boolean | null) {
        this.Set('IsSuspended', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: DeferredRevenueGLCode
    * * Display Name: Deferred Revenue GL Code
    * * SQL Data Type: nvarchar(500)
    */
    get DeferredRevenueGLCode(): string | null {
        return this.Get('DeferredRevenueGLCode');
    }
    set DeferredRevenueGLCode(value: string | null) {
        this.Set('DeferredRevenueGLCode', value);
    }

    /**
    * * Field Name: RevenueGLCode
    * * Display Name: Revenue GL Code
    * * SQL Data Type: nvarchar(500)
    */
    get RevenueGLCode(): string | null {
        return this.Get('RevenueGLCode');
    }
    set RevenueGLCode(value: string | null) {
        this.Set('RevenueGLCode', value);
    }

    /**
    * * Field Name: ParentSchedule
    * * Display Name: Parent Schedule
    * * SQL Data Type: uniqueidentifier
    */
    get ParentSchedule(): string | null {
        return this.Get('ParentSchedule');
    }
    set ParentSchedule(value: string | null) {
        this.Set('ParentSchedule', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Invoice
    * * Display Name: Invoice
    * * SQL Data Type: uniqueidentifier
    */
    get Invoice(): string | null {
        return this.Get('Invoice');
    }
    set Invoice(value: string | null) {
        this.Set('Invoice', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: InvoiceLineItemID
    * * Display Name: Invoice Line Item ID
    * * SQL Data Type: nvarchar(500)
    */
    get InvoiceLineItemID(): string | null {
        return this.Get('InvoiceLineItemID');
    }
    set InvoiceLineItemID(value: string | null) {
        this.Set('InvoiceLineItemID', value);
    }

    /**
    * * Field Name: ChangeMemo
    * * Display Name: Change Memo
    * * SQL Data Type: uniqueidentifier
    */
    get ChangeMemo(): string | null {
        return this.Get('ChangeMemo');
    }
    set ChangeMemo(value: string | null) {
        this.Set('ChangeMemo', value);
    }

    /**
    * * Field Name: WriteOff
    * * Display Name: Write Off
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOff(): string | null {
        return this.Get('WriteOff');
    }
    set WriteOff(value: string | null) {
        this.Set('WriteOff', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Section Dues Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: SectionDuesProduct
 * * Base View: vwSectionDuesProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Section Dues Products')
export class membersuiteSectionDuesProductEntity extends BaseEntity<membersuiteSectionDuesProductEntityType> {
    /**
    * Loads the MemberSuite: Section Dues Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Section Dues Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteSectionDuesProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: MembershipOrganization
    * * Display Name: Membership Organization
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipOrganization(): string | null {
        return this.Get('MembershipOrganization');
    }
    set MembershipOrganization(value: string | null) {
        this.Set('MembershipOrganization', value);
    }

    /**
    * * Field Name: Section
    * * Display Name: Section
    * * SQL Data Type: uniqueidentifier
    */
    get Section(): string | null {
        return this.Get('Section');
    }
    set Section(value: string | null) {
        this.Set('Section', value);
    }

    /**
    * * Field Name: MembershipType
    * * Display Name: Membership Type
    * * SQL Data Type: uniqueidentifier
    */
    get MembershipType(): string | null {
        return this.Get('MembershipType');
    }
    set MembershipType(value: string | null) {
        this.Set('MembershipType', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Shipping Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: ShippingProduct
 * * Base View: vwShippingProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Shipping Products')
export class membersuiteShippingProductEntity extends BaseEntity<membersuiteShippingProductEntityType> {
    /**
    * Loads the MemberSuite: Shipping Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Shipping Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteShippingProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Subledger Entry Batches - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: subledger_entry_batches
 * * Base View: vwSubledger_entry_batches
 * * Primary Key: batch_id
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Subledger Entry Batches')
export class membersuitesubledger_entry_batchesEntity extends BaseEntity<membersuitesubledger_entry_batchesEntityType> {
    /**
    * Loads the MemberSuite: Subledger Entry Batches record from the database
    * @param batch_id: string - primary key value to load the MemberSuite: Subledger Entry Batches record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuitesubledger_entry_batchesEntity
    * @method
    * @override
    */
    public async Load(batch_id: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'batch_id', Value: batch_id });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: batch_id
    * * Display Name: Batch Id
    * * SQL Data Type: nvarchar(100)
    */
    get batch_id(): string {
        return this.Get('batch_id');
    }
    set batch_id(value: string) {
        this.Set('batch_id', value);
    }

    /**
    * * Field Name: fiscal_year_id
    * * Display Name: Fiscal Year Id
    * * SQL Data Type: nvarchar(100)
    */
    get fiscal_year_id(): string | null {
        return this.Get('fiscal_year_id');
    }
    set fiscal_year_id(value: string | null) {
        this.Set('fiscal_year_id', value);
    }

    /**
    * * Field Name: partition_key
    * * Display Name: Partition Key
    * * SQL Data Type: nvarchar(100)
    */
    get partition_key(): string | null {
        return this.Get('partition_key');
    }
    set partition_key(value: string | null) {
        this.Set('partition_key', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Subledger Entry Items - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: subledger_entry_items
 * * Base View: vwSubledger_entry_items
 * * Primary Keys: subledger_entry_id, list_index
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Subledger Entry Items')
export class membersuitesubledger_entry_itemsEntity extends BaseEntity<membersuitesubledger_entry_itemsEntityType> {
    /**
    * Loads the MemberSuite: Subledger Entry Items record from the database
    * @param subledger_entry_id: string - primary key value to load the MemberSuite: Subledger Entry Items record.
    * @param list_index: string - primary key value to load the MemberSuite: Subledger Entry Items record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuitesubledger_entry_itemsEntity
    * @method
    * @override
    */
    public async Load(subledger_entry_id: string, list_index: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'subledger_entry_id', Value: subledger_entry_id });
        compositeKey.KeyValuePairs.push({ FieldName: 'list_index', Value: list_index });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: subledger_entry_id
    * * Display Name: Subledger Entry Id
    * * SQL Data Type: nvarchar(100)
    */
    get subledger_entry_id(): string {
        return this.Get('subledger_entry_id');
    }
    set subledger_entry_id(value: string) {
        this.Set('subledger_entry_id', value);
    }

    /**
    * * Field Name: gl_account
    * * Display Name: Gl Account
    * * SQL Data Type: nvarchar(500)
    */
    get gl_account(): string | null {
        return this.Get('gl_account');
    }
    set gl_account(value: string | null) {
        this.Set('gl_account', value);
    }

    /**
    * * Field Name: gl_account_name
    * * Display Name: Gl Account Name
    * * SQL Data Type: nvarchar(500)
    */
    get gl_account_name(): string | null {
        return this.Get('gl_account_name');
    }
    set gl_account_name(value: string | null) {
        this.Set('gl_account_name', value);
    }

    /**
    * * Field Name: debits
    * * Display Name: debits
    * * SQL Data Type: decimal(19, 4)
    */
    get debits(): number | null {
        return this.Get('debits');
    }
    set debits(value: number | null) {
        this.Set('debits', value);
    }

    /**
    * * Field Name: credits
    * * Display Name: credits
    * * SQL Data Type: decimal(19, 4)
    */
    get credits(): number | null {
        return this.Get('credits');
    }
    set credits(value: number | null) {
        this.Set('credits', value);
    }

    /**
    * * Field Name: project_code
    * * Display Name: Project Code
    * * SQL Data Type: nvarchar(500)
    */
    get project_code(): string | null {
        return this.Get('project_code');
    }
    set project_code(value: string | null) {
        this.Set('project_code', value);
    }

    /**
    * * Field Name: project_description
    * * Display Name: Project Description
    * * SQL Data Type: nvarchar(500)
    */
    get project_description(): string | null {
        return this.Get('project_description');
    }
    set project_description(value: string | null) {
        this.Set('project_description', value);
    }

    /**
    * * Field Name: batch_id
    * * Display Name: Batch Id
    * * SQL Data Type: nvarchar(100)
    */
    get batch_id(): string | null {
        return this.Get('batch_id');
    }
    set batch_id(value: string | null) {
        this.Set('batch_id', value);
    }

    /**
    * * Field Name: batch_name
    * * Display Name: Batch Name
    * * SQL Data Type: nvarchar(500)
    */
    get batch_name(): string | null {
        return this.Get('batch_name');
    }
    set batch_name(value: string | null) {
        this.Set('batch_name', value);
    }

    /**
    * * Field Name: batch_date
    * * Display Name: Batch Date
    * * SQL Data Type: datetime2
    */
    get batch_date(): Date | null {
        return this.Get('batch_date');
    }
    set batch_date(value: Date | null) {
        this.Set('batch_date', value);
    }

    /**
    * * Field Name: business_unit_id
    * * Display Name: Business Unit Id
    * * SQL Data Type: nvarchar(100)
    */
    get business_unit_id(): string | null {
        return this.Get('business_unit_id');
    }
    set business_unit_id(value: string | null) {
        this.Set('business_unit_id', value);
    }

    /**
    * * Field Name: business_unit_name
    * * Display Name: Business Unit Name
    * * SQL Data Type: nvarchar(500)
    */
    get business_unit_name(): string | null {
        return this.Get('business_unit_name');
    }
    set business_unit_name(value: string | null) {
        this.Set('business_unit_name', value);
    }

    /**
    * * Field Name: transaction_id
    * * Display Name: Transaction Id
    * * SQL Data Type: nvarchar(100)
    */
    get transaction_id(): string | null {
        return this.Get('transaction_id');
    }
    set transaction_id(value: string | null) {
        this.Set('transaction_id', value);
    }

    /**
    * * Field Name: transaction_localid
    * * Display Name: Transaction Localid
    * * SQL Data Type: nvarchar(100)
    */
    get transaction_localid(): string | null {
        return this.Get('transaction_localid');
    }
    set transaction_localid(value: string | null) {
        this.Set('transaction_localid', value);
    }

    /**
    * * Field Name: transaction_name
    * * Display Name: Transaction Name
    * * SQL Data Type: nvarchar(500)
    */
    get transaction_name(): string | null {
        return this.Get('transaction_name');
    }
    set transaction_name(value: string | null) {
        this.Set('transaction_name', value);
    }

    /**
    * * Field Name: transaction_type
    * * Display Name: Transaction Type
    * * SQL Data Type: nvarchar(500)
    */
    get transaction_type(): string | null {
        return this.Get('transaction_type');
    }
    set transaction_type(value: string | null) {
        this.Set('transaction_type', value);
    }

    /**
    * * Field Name: type
    * * Display Name: type
    * * SQL Data Type: nvarchar(500)
    */
    get type(): string | null {
        return this.Get('type');
    }
    set type(value: string | null) {
        this.Set('type', value);
    }

    /**
    * * Field Name: type_name
    * * Display Name: Type Name
    * * SQL Data Type: nvarchar(500)
    */
    get type_name(): string | null {
        return this.Get('type_name');
    }
    set type_name(value: string | null) {
        this.Set('type_name', value);
    }

    /**
    * * Field Name: invoice_id
    * * Display Name: Invoice Id
    * * SQL Data Type: nvarchar(100)
    */
    get invoice_id(): string | null {
        return this.Get('invoice_id');
    }
    set invoice_id(value: string | null) {
        this.Set('invoice_id', value);
    }

    /**
    * * Field Name: invoice_lineitem_id
    * * Display Name: Invoice Lineitem Id
    * * SQL Data Type: nvarchar(100)
    */
    get invoice_lineitem_id(): string | null {
        return this.Get('invoice_lineitem_id');
    }
    set invoice_lineitem_id(value: string | null) {
        this.Set('invoice_lineitem_id', value);
    }

    /**
    * * Field Name: invoicelocalid
    * * Display Name: invoicelocalid
    * * SQL Data Type: nvarchar(100)
    */
    get invoicelocalid(): string | null {
        return this.Get('invoicelocalid');
    }
    set invoicelocalid(value: string | null) {
        this.Set('invoicelocalid', value);
    }

    /**
    * * Field Name: invoice_name
    * * Display Name: Invoice Name
    * * SQL Data Type: nvarchar(500)
    */
    get invoice_name(): string | null {
        return this.Get('invoice_name');
    }
    set invoice_name(value: string | null) {
        this.Set('invoice_name', value);
    }

    /**
    * * Field Name: invoicedate
    * * Display Name: invoicedate
    * * SQL Data Type: datetime2
    */
    get invoicedate(): Date | null {
        return this.Get('invoicedate');
    }
    set invoicedate(value: Date | null) {
        this.Set('invoicedate', value);
    }

    /**
    * * Field Name: invoiceduedate
    * * Display Name: invoiceduedate
    * * SQL Data Type: datetime2
    */
    get invoiceduedate(): Date | null {
        return this.Get('invoiceduedate');
    }
    set invoiceduedate(value: Date | null) {
        this.Set('invoiceduedate', value);
    }

    /**
    * * Field Name: invoicetotal
    * * Display Name: invoicetotal
    * * SQL Data Type: decimal(19, 4)
    */
    get invoicetotal(): number | null {
        return this.Get('invoicetotal');
    }
    set invoicetotal(value: number | null) {
        this.Set('invoicetotal', value);
    }

    /**
    * * Field Name: payment_id
    * * Display Name: Payment Id
    * * SQL Data Type: nvarchar(100)
    */
    get payment_id(): string | null {
        return this.Get('payment_id');
    }
    set payment_id(value: string | null) {
        this.Set('payment_id', value);
    }

    /**
    * * Field Name: payment_lineitem_id
    * * Display Name: Payment Lineitem Id
    * * SQL Data Type: nvarchar(100)
    */
    get payment_lineitem_id(): string | null {
        return this.Get('payment_lineitem_id');
    }
    set payment_lineitem_id(value: string | null) {
        this.Set('payment_lineitem_id', value);
    }

    /**
    * * Field Name: payment_name
    * * Display Name: Payment Name
    * * SQL Data Type: nvarchar(500)
    */
    get payment_name(): string | null {
        return this.Get('payment_name');
    }
    set payment_name(value: string | null) {
        this.Set('payment_name', value);
    }

    /**
    * * Field Name: credit_id
    * * Display Name: Credit Id
    * * SQL Data Type: nvarchar(100)
    */
    get credit_id(): string | null {
        return this.Get('credit_id');
    }
    set credit_id(value: string | null) {
        this.Set('credit_id', value);
    }

    /**
    * * Field Name: credit_name
    * * Display Name: Credit Name
    * * SQL Data Type: nvarchar(500)
    */
    get credit_name(): string | null {
        return this.Get('credit_name');
    }
    set credit_name(value: string | null) {
        this.Set('credit_name', value);
    }

    /**
    * * Field Name: credit_usage_id
    * * Display Name: Credit Usage Id
    * * SQL Data Type: nvarchar(100)
    */
    get credit_usage_id(): string | null {
        return this.Get('credit_usage_id');
    }
    set credit_usage_id(value: string | null) {
        this.Set('credit_usage_id', value);
    }

    /**
    * * Field Name: credit_usage_lineitem_id
    * * Display Name: Credit Usage Lineitem Id
    * * SQL Data Type: nvarchar(100)
    */
    get credit_usage_lineitem_id(): string | null {
        return this.Get('credit_usage_lineitem_id');
    }
    set credit_usage_lineitem_id(value: string | null) {
        this.Set('credit_usage_lineitem_id', value);
    }

    /**
    * * Field Name: credit_usage_name
    * * Display Name: Credit Usage Name
    * * SQL Data Type: nvarchar(500)
    */
    get credit_usage_name(): string | null {
        return this.Get('credit_usage_name');
    }
    set credit_usage_name(value: string | null) {
        this.Set('credit_usage_name', value);
    }

    /**
    * * Field Name: refund_id
    * * Display Name: Refund Id
    * * SQL Data Type: nvarchar(100)
    */
    get refund_id(): string | null {
        return this.Get('refund_id');
    }
    set refund_id(value: string | null) {
        this.Set('refund_id', value);
    }

    /**
    * * Field Name: refund_name
    * * Display Name: Refund Name
    * * SQL Data Type: nvarchar(500)
    */
    get refund_name(): string | null {
        return this.Get('refund_name');
    }
    set refund_name(value: string | null) {
        this.Set('refund_name', value);
    }

    /**
    * * Field Name: write_off_id
    * * Display Name: Write Off Id
    * * SQL Data Type: nvarchar(100)
    */
    get write_off_id(): string | null {
        return this.Get('write_off_id');
    }
    set write_off_id(value: string | null) {
        this.Set('write_off_id', value);
    }

    /**
    * * Field Name: write_off_name
    * * Display Name: Write Off Name
    * * SQL Data Type: nvarchar(500)
    */
    get write_off_name(): string | null {
        return this.Get('write_off_name');
    }
    set write_off_name(value: string | null) {
        this.Set('write_off_name', value);
    }

    /**
    * * Field Name: gift_id
    * * Display Name: Gift Id
    * * SQL Data Type: nvarchar(100)
    */
    get gift_id(): string | null {
        return this.Get('gift_id');
    }
    set gift_id(value: string | null) {
        this.Set('gift_id', value);
    }

    /**
    * * Field Name: gift_name
    * * Display Name: Gift Name
    * * SQL Data Type: nvarchar(500)
    */
    get gift_name(): string | null {
        return this.Get('gift_name');
    }
    set gift_name(value: string | null) {
        this.Set('gift_name', value);
    }

    /**
    * * Field Name: cogs_entry_id
    * * Display Name: Cogs Entry Id
    * * SQL Data Type: nvarchar(100)
    */
    get cogs_entry_id(): string | null {
        return this.Get('cogs_entry_id');
    }
    set cogs_entry_id(value: string | null) {
        this.Set('cogs_entry_id', value);
    }

    /**
    * * Field Name: cogs_entry_name
    * * Display Name: Cogs Entry Name
    * * SQL Data Type: nvarchar(500)
    */
    get cogs_entry_name(): string | null {
        return this.Get('cogs_entry_name');
    }
    set cogs_entry_name(value: string | null) {
        this.Set('cogs_entry_name', value);
    }

    /**
    * * Field Name: change_memo_id
    * * Display Name: Change Memo Id
    * * SQL Data Type: nvarchar(100)
    */
    get change_memo_id(): string | null {
        return this.Get('change_memo_id');
    }
    set change_memo_id(value: string | null) {
        this.Set('change_memo_id', value);
    }

    /**
    * * Field Name: change_memo_name
    * * Display Name: Change Memo Name
    * * SQL Data Type: nvarchar(500)
    */
    get change_memo_name(): string | null {
        return this.Get('change_memo_name');
    }
    set change_memo_name(value: string | null) {
        this.Set('change_memo_name', value);
    }

    /**
    * * Field Name: historical_deferral_id
    * * Display Name: Historical Deferral Id
    * * SQL Data Type: nvarchar(100)
    */
    get historical_deferral_id(): string | null {
        return this.Get('historical_deferral_id');
    }
    set historical_deferral_id(value: string | null) {
        this.Set('historical_deferral_id', value);
    }

    /**
    * * Field Name: historical_deferral_name
    * * Display Name: Historical Deferral Name
    * * SQL Data Type: nvarchar(500)
    */
    get historical_deferral_name(): string | null {
        return this.Get('historical_deferral_name');
    }
    set historical_deferral_name(value: string | null) {
        this.Set('historical_deferral_name', value);
    }

    /**
    * * Field Name: inventory_receipt_id
    * * Display Name: Inventory Receipt Id
    * * SQL Data Type: nvarchar(100)
    */
    get inventory_receipt_id(): string | null {
        return this.Get('inventory_receipt_id');
    }
    set inventory_receipt_id(value: string | null) {
        this.Set('inventory_receipt_id', value);
    }

    /**
    * * Field Name: inventory_receipt_name
    * * Display Name: Inventory Receipt Name
    * * SQL Data Type: nvarchar(500)
    */
    get inventory_receipt_name(): string | null {
        return this.Get('inventory_receipt_name');
    }
    set inventory_receipt_name(value: string | null) {
        this.Set('inventory_receipt_name', value);
    }

    /**
    * * Field Name: cash_account_id
    * * Display Name: Cash Account Id
    * * SQL Data Type: nvarchar(100)
    */
    get cash_account_id(): string | null {
        return this.Get('cash_account_id');
    }
    set cash_account_id(value: string | null) {
        this.Set('cash_account_id', value);
    }

    /**
    * * Field Name: cash_account_name
    * * Display Name: Cash Account Name
    * * SQL Data Type: nvarchar(500)
    */
    get cash_account_name(): string | null {
        return this.Get('cash_account_name');
    }
    set cash_account_name(value: string | null) {
        this.Set('cash_account_name', value);
    }

    /**
    * * Field Name: due_to_due_from_business_unit_id
    * * Display Name: Due To Due From Business Unit Id
    * * SQL Data Type: nvarchar(100)
    */
    get due_to_due_from_business_unit_id(): string | null {
        return this.Get('due_to_due_from_business_unit_id');
    }
    set due_to_due_from_business_unit_id(value: string | null) {
        this.Set('due_to_due_from_business_unit_id', value);
    }

    /**
    * * Field Name: due_to_due_from_business_unit_name
    * * Display Name: Due To Due From Business Unit Name
    * * SQL Data Type: nvarchar(500)
    */
    get due_to_due_from_business_unit_name(): string | null {
        return this.Get('due_to_due_from_business_unit_name');
    }
    set due_to_due_from_business_unit_name(value: string | null) {
        this.Set('due_to_due_from_business_unit_name', value);
    }

    /**
    * * Field Name: customer_id
    * * Display Name: Customer Id
    * * SQL Data Type: nvarchar(100)
    */
    get customer_id(): string | null {
        return this.Get('customer_id');
    }
    set customer_id(value: string | null) {
        this.Set('customer_id', value);
    }

    /**
    * * Field Name: customer_name
    * * Display Name: Customer Name
    * * SQL Data Type: nvarchar(500)
    */
    get customer_name(): string | null {
        return this.Get('customer_name');
    }
    set customer_name(value: string | null) {
        this.Set('customer_name', value);
    }

    /**
    * * Field Name: customer_number
    * * Display Name: Customer Number
    * * SQL Data Type: nvarchar(100)
    */
    get customer_number(): string | null {
        return this.Get('customer_number');
    }
    set customer_number(value: string | null) {
        this.Set('customer_number', value);
    }

    /**
    * * Field Name: customer_email_address
    * * Display Name: Customer Email Address
    * * SQL Data Type: nvarchar(500)
    */
    get customer_email_address(): string | null {
        return this.Get('customer_email_address');
    }
    set customer_email_address(value: string | null) {
        this.Set('customer_email_address', value);
    }

    /**
    * * Field Name: customer_type
    * * Display Name: Customer Type
    * * SQL Data Type: nvarchar(500)
    */
    get customer_type(): string | null {
        return this.Get('customer_type');
    }
    set customer_type(value: string | null) {
        this.Set('customer_type', value);
    }

    /**
    * * Field Name: firstname
    * * Display Name: firstname
    * * SQL Data Type: nvarchar(500)
    */
    get firstname(): string | null {
        return this.Get('firstname');
    }
    set firstname(value: string | null) {
        this.Set('firstname', value);
    }

    /**
    * * Field Name: lastname
    * * Display Name: lastname
    * * SQL Data Type: nvarchar(500)
    */
    get lastname(): string | null {
        return this.Get('lastname');
    }
    set lastname(value: string | null) {
        this.Set('lastname', value);
    }

    /**
    * * Field Name: product_id
    * * Display Name: Product Id
    * * SQL Data Type: nvarchar(100)
    */
    get product_id(): string | null {
        return this.Get('product_id');
    }
    set product_id(value: string | null) {
        this.Set('product_id', value);
    }

    /**
    * * Field Name: product_code
    * * Display Name: Product Code
    * * SQL Data Type: nvarchar(500)
    */
    get product_code(): string | null {
        return this.Get('product_code');
    }
    set product_code(value: string | null) {
        this.Set('product_code', value);
    }

    /**
    * * Field Name: product_name
    * * Display Name: Product Name
    * * SQL Data Type: nvarchar(500)
    */
    get product_name(): string | null {
        return this.Get('product_name');
    }
    set product_name(value: string | null) {
        this.Set('product_name', value);
    }

    /**
    * * Field Name: product_type
    * * Display Name: Product Type
    * * SQL Data Type: nvarchar(500)
    */
    get product_type(): string | null {
        return this.Get('product_type');
    }
    set product_type(value: string | null) {
        this.Set('product_type', value);
    }

    /**
    * * Field Name: productcategory
    * * Display Name: productcategory
    * * SQL Data Type: nvarchar(500)
    */
    get productcategory(): string | null {
        return this.Get('productcategory');
    }
    set productcategory(value: string | null) {
        this.Set('productcategory', value);
    }

    /**
    * * Field Name: membershiptypename
    * * Display Name: membershiptypename
    * * SQL Data Type: nvarchar(500)
    */
    get membershiptypename(): string | null {
        return this.Get('membershiptypename');
    }
    set membershiptypename(value: string | null) {
        this.Set('membershiptypename', value);
    }

    /**
    * * Field Name: fiscal_year_id
    * * Display Name: Fiscal Year Id
    * * SQL Data Type: nvarchar(100)
    */
    get fiscal_year_id(): string | null {
        return this.Get('fiscal_year_id');
    }
    set fiscal_year_id(value: string | null) {
        this.Set('fiscal_year_id', value);
    }

    /**
    * * Field Name: fiscal_year_name
    * * Display Name: Fiscal Year Name
    * * SQL Data Type: nvarchar(500)
    */
    get fiscal_year_name(): string | null {
        return this.Get('fiscal_year_name');
    }
    set fiscal_year_name(value: string | null) {
        this.Set('fiscal_year_name', value);
    }

    /**
    * * Field Name: fiscal_period
    * * Display Name: Fiscal Period
    * * SQL Data Type: nvarchar(100)
    */
    get fiscal_period(): string | null {
        return this.Get('fiscal_period');
    }
    set fiscal_period(value: string | null) {
        this.Set('fiscal_period', value);
    }

    /**
    * * Field Name: fiscal_period_name
    * * Display Name: Fiscal Period Name
    * * SQL Data Type: nvarchar(500)
    */
    get fiscal_period_name(): string | null {
        return this.Get('fiscal_period_name');
    }
    set fiscal_period_name(value: string | null) {
        this.Set('fiscal_period_name', value);
    }

    /**
    * * Field Name: currency_code
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(100)
    */
    get currency_code(): string | null {
        return this.Get('currency_code');
    }
    set currency_code(value: string | null) {
        this.Set('currency_code', value);
    }

    /**
    * * Field Name: date
    * * Display Name: date
    * * SQL Data Type: datetime2
    */
    get date(): Date | null {
        return this.Get('date');
    }
    set date(value: Date | null) {
        this.Set('date', value);
    }

    /**
    * * Field Name: credit_value_null_when_zero
    * * Display Name: Credit Value Null When Zero
    * * SQL Data Type: decimal(19, 4)
    */
    get credit_value_null_when_zero(): number | null {
        return this.Get('credit_value_null_when_zero');
    }
    set credit_value_null_when_zero(value: number | null) {
        this.Set('credit_value_null_when_zero', value);
    }

    /**
    * * Field Name: debit_value_null_when_zero
    * * Display Name: Debit Value Null When Zero
    * * SQL Data Type: decimal(19, 4)
    */
    get debit_value_null_when_zero(): number | null {
        return this.Get('debit_value_null_when_zero');
    }
    set debit_value_null_when_zero(value: number | null) {
        this.Set('debit_value_null_when_zero', value);
    }

    /**
    * * Field Name: company
    * * Display Name: company
    * * SQL Data Type: nvarchar(500)
    */
    get company(): string | null {
        return this.Get('company');
    }
    set company(value: string | null) {
        this.Set('company', value);
    }

    /**
    * * Field Name: list_index
    * * Display Name: List Index
    * * SQL Data Type: nvarchar(50)
    */
    get list_index(): string {
        return this.Get('list_index');
    }
    set list_index(value: string) {
        this.Set('list_index', value);
    }

    /**
    * * Field Name: created_by_id
    * * Display Name: Created By Id
    * * SQL Data Type: nvarchar(100)
    */
    get created_by_id(): string | null {
        return this.Get('created_by_id');
    }
    set created_by_id(value: string | null) {
        this.Set('created_by_id', value);
    }

    /**
    * * Field Name: created_by_name
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get created_by_name(): string | null {
        return this.Get('created_by_name');
    }
    set created_by_name(value: string | null) {
        this.Set('created_by_name', value);
    }

    /**
    * * Field Name: created_date
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get created_date(): Date | null {
        return this.Get('created_date');
    }
    set created_date(value: Date | null) {
        this.Set('created_date', value);
    }

    /**
    * * Field Name: clover_etl_date
    * * Display Name: Clover Etl Date
    * * SQL Data Type: datetime2
    */
    get clover_etl_date(): Date | null {
        return this.Get('clover_etl_date');
    }
    set clover_etl_date(value: Date | null) {
        this.Set('clover_etl_date', value);
    }

    /**
    * * Field Name: clover_etl_job
    * * Display Name: Clover Etl Job
    * * SQL Data Type: nvarchar(500)
    */
    get clover_etl_job(): string | null {
        return this.Get('clover_etl_job');
    }
    set clover_etl_job(value: string | null) {
        this.Set('clover_etl_job', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company_Virtual
    * * Display Name: Company Virtual
    * * SQL Data Type: nvarchar(50)
    */
    get Company_Virtual(): string {
        return this.Get('Company_Virtual');
    }
}


/**
 * MemberSuite: Subscription Fees - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: SubscriptionFee
 * * Base View: vwSubscriptionFees
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Subscription Fees')
export class membersuiteSubscriptionFeeEntity extends BaseEntity<membersuiteSubscriptionFeeEntityType> {
    /**
    * Loads the MemberSuite: Subscription Fees record from the database
    * @param ID: string - primary key value to load the MemberSuite: Subscription Fees record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteSubscriptionFeeEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: Publication
    * * Display Name: Publication
    * * SQL Data Type: uniqueidentifier
    */
    get Publication(): string | null {
        return this.Get('Publication');
    }
    set Publication(value: string | null) {
        this.Set('Publication', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: ExpirationType
    * * Display Name: Expiration Type
    * * SQL Data Type: nvarchar(100)
    */
    get ExpirationType(): string | null {
        return this.Get('ExpirationType');
    }
    set ExpirationType(value: string | null) {
        this.Set('ExpirationType', value);
    }

    /**
    * * Field Name: Availability
    * * Display Name: Availability
    * * SQL Data Type: nvarchar(100)
    */
    get Availability(): string | null {
        return this.Get('Availability');
    }
    set Availability(value: string | null) {
        this.Set('Availability', value);
    }

    /**
    * * Field Name: StartDate
    * * Display Name: Start Date
    * * SQL Data Type: date
    */
    get StartDate(): Date | null {
        return this.Get('StartDate');
    }
    set StartDate(value: Date | null) {
        this.Set('StartDate', value);
    }

    /**
    * * Field Name: SellForNextYearAfter
    * * Display Name: Sell For Next Year After
    * * SQL Data Type: date
    */
    get SellForNextYearAfter(): Date | null {
        return this.Get('SellForNextYearAfter');
    }
    set SellForNextYearAfter(value: Date | null) {
        this.Set('SellForNextYearAfter', value);
    }

    /**
    * * Field Name: SetDatesBasedOnPaymentDate
    * * Display Name: Set Dates Based On Payment Date
    * * SQL Data Type: bit
    */
    get SetDatesBasedOnPaymentDate(): boolean | null {
        return this.Get('SetDatesBasedOnPaymentDate');
    }
    set SetDatesBasedOnPaymentDate(value: boolean | null) {
        this.Set('SetDatesBasedOnPaymentDate', value);
    }

    /**
    * * Field Name: SellForNextMonthAfterDay
    * * Display Name: Sell For Next Month After Day
    * * SQL Data Type: bigint
    */
    get SellForNextMonthAfterDay(): number | null {
        return this.Get('SellForNextMonthAfterDay');
    }
    set SellForNextMonthAfterDay(value: number | null) {
        this.Set('SellForNextMonthAfterDay', value);
    }

    /**
    * * Field Name: StartDay
    * * Display Name: Start Day
    * * SQL Data Type: bigint
    */
    get StartDay(): number | null {
        return this.Get('StartDay');
    }
    set StartDay(value: number | null) {
        this.Set('StartDay', value);
    }

    /**
    * * Field Name: AllowMidMonthExpirations
    * * Display Name: Allow Mid Month Expirations
    * * SQL Data Type: bit
    */
    get AllowMidMonthExpirations(): boolean | null {
        return this.Get('AllowMidMonthExpirations');
    }
    set AllowMidMonthExpirations(value: boolean | null) {
        this.Set('AllowMidMonthExpirations', value);
    }

    /**
    * * Field Name: TermLength
    * * Display Name: Term Length
    * * SQL Data Type: bigint
    */
    get TermLength(): number | null {
        return this.Get('TermLength');
    }
    set TermLength(value: number | null) {
        this.Set('TermLength', value);
    }

    /**
    * * Field Name: TermType
    * * Display Name: Term Type
    * * SQL Data Type: nvarchar(100)
    */
    get TermType(): string | null {
        return this.Get('TermType');
    }
    set TermType(value: string | null) {
        this.Set('TermType', value);
    }

    /**
    * * Field Name: UpdateDatesWhen
    * * Display Name: Update Dates When
    * * SQL Data Type: nvarchar(100)
    */
    get UpdateDatesWhen(): string | null {
        return this.Get('UpdateDatesWhen');
    }
    set UpdateDatesWhen(value: string | null) {
        this.Set('UpdateDatesWhen', value);
    }

    /**
    * * Field Name: RequiresApproval
    * * Display Name: Requires Approval
    * * SQL Data Type: bit
    */
    get RequiresApproval(): boolean | null {
        return this.Get('RequiresApproval');
    }
    set RequiresApproval(value: boolean | null) {
        this.Set('RequiresApproval', value);
    }

    /**
    * * Field Name: RenewalTerms
    * * Display Name: Renewal Terms
    * * SQL Data Type: uniqueidentifier
    */
    get RenewalTerms(): string | null {
        return this.Get('RenewalTerms');
    }
    set RenewalTerms(value: string | null) {
        this.Set('RenewalTerms', value);
    }

    /**
    * * Field Name: ProFormaRenewalInvoices
    * * Display Name: Pro Forma Renewal Invoices
    * * SQL Data Type: bit
    */
    get ProFormaRenewalInvoices(): boolean | null {
        return this.Get('ProFormaRenewalInvoices');
    }
    set ProFormaRenewalInvoices(value: boolean | null) {
        this.Set('ProFormaRenewalInvoices', value);
    }

    /**
    * * Field Name: GracePeriod
    * * Display Name: Grace Period
    * * SQL Data Type: bigint
    */
    get GracePeriod(): number | null {
        return this.Get('GracePeriod');
    }
    set GracePeriod(value: number | null) {
        this.Set('GracePeriod', value);
    }

    /**
    * * Field Name: BillPrimaryOrganization
    * * Display Name: Bill Primary Organization
    * * SQL Data Type: bit
    */
    get BillPrimaryOrganization(): boolean | null {
        return this.Get('BillPrimaryOrganization');
    }
    set BillPrimaryOrganization(value: boolean | null) {
        this.Set('BillPrimaryOrganization', value);
    }

    /**
    * * Field Name: ReinstatementPeriod
    * * Display Name: Reinstatement Period
    * * SQL Data Type: bigint
    */
    get ReinstatementPeriod(): number | null {
        return this.Get('ReinstatementPeriod');
    }
    set ReinstatementPeriod(value: number | null) {
        this.Set('ReinstatementPeriod', value);
    }

    /**
    * * Field Name: UseFreshJoinDateForReinstatedMembers
    * * Display Name: Use Fresh Join Date For Reinstated Members
    * * SQL Data Type: bit
    */
    get UseFreshJoinDateForReinstatedMembers(): boolean | null {
        return this.Get('UseFreshJoinDateForReinstatedMembers');
    }
    set UseFreshJoinDateForReinstatedMembers(value: boolean | null) {
        this.Set('UseFreshJoinDateForReinstatedMembers', value);
    }

    /**
    * * Field Name: GiveRenewalPricingDuringReinstatementPeriod
    * * Display Name: Give Renewal Pricing During Reinstatement Period
    * * SQL Data Type: bit
    */
    get GiveRenewalPricingDuringReinstatementPeriod(): boolean | null {
        return this.Get('GiveRenewalPricingDuringReinstatementPeriod');
    }
    set GiveRenewalPricingDuringReinstatementPeriod(value: boolean | null) {
        this.Set('GiveRenewalPricingDuringReinstatementPeriod', value);
    }

    /**
    * * Field Name: UseCurrentDateAsBasisForExpirationOfReinstatedMembership
    * * Display Name: Use Current Date As Basis For Expiration Of Reinstated Membership
    * * SQL Data Type: bit
    */
    get UseCurrentDateAsBasisForExpirationOfReinstatedMembership(): boolean | null {
        return this.Get('UseCurrentDateAsBasisForExpirationOfReinstatedMembership');
    }
    set UseCurrentDateAsBasisForExpirationOfReinstatedMembership(value: boolean | null) {
        this.Set('UseCurrentDateAsBasisForExpirationOfReinstatedMembership', value);
    }

    /**
    * * Field Name: InitialBillingEmail
    * * Display Name: Initial Billing Email
    * * SQL Data Type: uniqueidentifier
    */
    get InitialBillingEmail(): string | null {
        return this.Get('InitialBillingEmail');
    }
    set InitialBillingEmail(value: string | null) {
        this.Set('InitialBillingEmail', value);
    }

    /**
    * * Field Name: FirstReminderEmail
    * * Display Name: First Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get FirstReminderEmail(): string | null {
        return this.Get('FirstReminderEmail');
    }
    set FirstReminderEmail(value: string | null) {
        this.Set('FirstReminderEmail', value);
    }

    /**
    * * Field Name: SecondReminderEmail
    * * Display Name: Second Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get SecondReminderEmail(): string | null {
        return this.Get('SecondReminderEmail');
    }
    set SecondReminderEmail(value: string | null) {
        this.Set('SecondReminderEmail', value);
    }

    /**
    * * Field Name: ThirdReminderEmail
    * * Display Name: Third Reminder Email
    * * SQL Data Type: uniqueidentifier
    */
    get ThirdReminderEmail(): string | null {
        return this.Get('ThirdReminderEmail');
    }
    set ThirdReminderEmail(value: string | null) {
        this.Set('ThirdReminderEmail', value);
    }

    /**
    * * Field Name: DropEmail
    * * Display Name: Drop Email
    * * SQL Data Type: uniqueidentifier
    */
    get DropEmail(): string | null {
        return this.Get('DropEmail');
    }
    set DropEmail(value: string | null) {
        this.Set('DropEmail', value);
    }

    /**
    * * Field Name: InvoicePercentage
    * * Display Name: Invoice Percentage
    * * SQL Data Type: decimal(19, 4)
    */
    get InvoicePercentage(): number | null {
        return this.Get('InvoicePercentage');
    }
    set InvoicePercentage(value: number | null) {
        this.Set('InvoicePercentage', value);
    }

    /**
    * * Field Name: InvoiceType
    * * Display Name: Invoice Type
    * * SQL Data Type: uniqueidentifier
    */
    get InvoiceType(): string | null {
        return this.Get('InvoiceType');
    }
    set InvoiceType(value: string | null) {
        this.Set('InvoiceType', value);
    }

    /**
    * * Field Name: AutoRenew
    * * Display Name: Auto Renew
    * * SQL Data Type: bit
    */
    get AutoRenew(): boolean | null {
        return this.Get('AutoRenew');
    }
    set AutoRenew(value: boolean | null) {
        this.Set('AutoRenew', value);
    }

    /**
    * * Field Name: RenewsWith
    * * Display Name: Renews With
    * * SQL Data Type: uniqueidentifier
    */
    get RenewsWith(): string | null {
        return this.Get('RenewsWith');
    }
    set RenewsWith(value: string | null) {
        this.Set('RenewsWith', value);
    }

    /**
    * * Field Name: Type
    * * Display Name: Type
    * * SQL Data Type: nvarchar(100)
    */
    get Type(): string | null {
        return this.Get('Type');
    }
    set Type(value: string | null) {
        this.Set('Type', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Tax Products - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: TaxProduct
 * * Base View: vwTaxProducts
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Tax Products')
export class membersuiteTaxProductEntity extends BaseEntity<membersuiteTaxProductEntityType> {
    /**
    * Loads the MemberSuite: Tax Products record from the database
    * @param ID: string - primary key value to load the MemberSuite: Tax Products record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteTaxProductEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: IsDiyImported
    * * Display Name: Is Diy Imported
    * * SQL Data Type: bit
    */
    get IsDiyImported(): boolean | null {
        return this.Get('IsDiyImported');
    }
    set IsDiyImported(value: boolean | null) {
        this.Set('IsDiyImported', value);
    }

    /**
    * * Field Name: Code
    * * Display Name: Code
    * * SQL Data Type: nvarchar(500)
    */
    get Code(): string | null {
        return this.Get('Code');
    }
    set Code(value: string | null) {
        this.Set('Code', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: Category
    * * Display Name: Category
    * * SQL Data Type: uniqueidentifier
    */
    get Category(): string | null {
        return this.Get('Category');
    }
    set Category(value: string | null) {
        this.Set('Category', value);
    }

    /**
    * * Field Name: DisplayOrder
    * * Display Name: Display Order
    * * SQL Data Type: bigint
    */
    get DisplayOrder(): number | null {
        return this.Get('DisplayOrder');
    }
    set DisplayOrder(value: number | null) {
        this.Set('DisplayOrder', value);
    }

    /**
    * * Field Name: Description
    * * Display Name: Description
    * * SQL Data Type: decimal(19, 4)
    */
    get Description(): number | null {
        return this.Get('Description');
    }
    set Description(value: number | null) {
        this.Set('Description', value);
    }

    /**
    * * Field Name: ConfirmationEmail
    * * Display Name: Confirmation Email
    * * SQL Data Type: uniqueidentifier
    */
    get ConfirmationEmail(): string | null {
        return this.Get('ConfirmationEmail');
    }
    set ConfirmationEmail(value: string | null) {
        this.Set('ConfirmationEmail', value);
    }

    /**
    * * Field Name: SellOnline
    * * Display Name: Sell Online
    * * SQL Data Type: bit
    */
    get SellOnline(): boolean | null {
        return this.Get('SellOnline');
    }
    set SellOnline(value: boolean | null) {
        this.Set('SellOnline', value);
    }

    /**
    * * Field Name: SellFrom
    * * Display Name: Sell From
    * * SQL Data Type: datetime2
    */
    get SellFrom(): Date | null {
        return this.Get('SellFrom');
    }
    set SellFrom(value: Date | null) {
        this.Set('SellFrom', value);
    }

    /**
    * * Field Name: SellUntil
    * * Display Name: Sell Until
    * * SQL Data Type: datetime2
    */
    get SellUntil(): Date | null {
        return this.Get('SellUntil');
    }
    set SellUntil(value: Date | null) {
        this.Set('SellUntil', value);
    }

    /**
    * * Field Name: NewUntil
    * * Display Name: New Until
    * * SQL Data Type: datetime2
    */
    get NewUntil(): Date | null {
        return this.Get('NewUntil');
    }
    set NewUntil(value: Date | null) {
        this.Set('NewUntil', value);
    }

    /**
    * * Field Name: Price
    * * Display Name: Price
    * * SQL Data Type: decimal(19, 4)
    */
    get Price(): number | null {
        return this.Get('Price');
    }
    set Price(value: number | null) {
        this.Set('Price', value);
    }

    /**
    * * Field Name: InventoryCostingMethod
    * * Display Name: Inventory Costing Method
    * * SQL Data Type: nvarchar(100)
    */
    get InventoryCostingMethod(): string | null {
        return this.Get('InventoryCostingMethod');
    }
    set InventoryCostingMethod(value: string | null) {
        this.Set('InventoryCostingMethod', value);
    }

    /**
    * * Field Name: AllowCustomersToPayLater
    * * Display Name: Allow Customers To Pay Later
    * * SQL Data Type: bit
    */
    get AllowCustomersToPayLater(): boolean | null {
        return this.Get('AllowCustomersToPayLater');
    }
    set AllowCustomersToPayLater(value: boolean | null) {
        this.Set('AllowCustomersToPayLater', value);
    }

    /**
    * * Field Name: MemberPrice
    * * Display Name: Member Price
    * * SQL Data Type: decimal(19, 4)
    */
    get MemberPrice(): number | null {
        return this.Get('MemberPrice');
    }
    set MemberPrice(value: number | null) {
        this.Set('MemberPrice', value);
    }

    /**
    * * Field Name: UseSpecialPricesOnly
    * * Display Name: Use Special Prices Only
    * * SQL Data Type: bit
    */
    get UseSpecialPricesOnly(): boolean | null {
        return this.Get('UseSpecialPricesOnly');
    }
    set UseSpecialPricesOnly(value: boolean | null) {
        this.Set('UseSpecialPricesOnly', value);
    }

    /**
    * * Field Name: DisplayPriceAs
    * * Display Name: Display Price As
    * * SQL Data Type: nvarchar(500)
    */
    get DisplayPriceAs(): string | null {
        return this.Get('DisplayPriceAs');
    }
    set DisplayPriceAs(value: string | null) {
        this.Set('DisplayPriceAs', value);
    }

    /**
    * * Field Name: TrackInventory
    * * Display Name: Track Inventory
    * * SQL Data Type: bit
    */
    get TrackInventory(): boolean | null {
        return this.Get('TrackInventory');
    }
    set TrackInventory(value: boolean | null) {
        this.Set('TrackInventory', value);
    }

    /**
    * * Field Name: LateFeeRuleSet
    * * Display Name: Late Fee Rule Set
    * * SQL Data Type: uniqueidentifier
    */
    get LateFeeRuleSet(): string | null {
        return this.Get('LateFeeRuleSet');
    }
    set LateFeeRuleSet(value: string | null) {
        this.Set('LateFeeRuleSet', value);
    }

    /**
    * * Field Name: Weight
    * * Display Name: Weight
    * * SQL Data Type: decimal(19, 4)
    */
    get Weight(): number | null {
        return this.Get('Weight');
    }
    set Weight(value: number | null) {
        this.Set('Weight', value);
    }

    /**
    * * Field Name: AllowBackOrders
    * * Display Name: Allow Back Orders
    * * SQL Data Type: bit
    */
    get AllowBackOrders(): boolean | null {
        return this.Get('AllowBackOrders');
    }
    set AllowBackOrders(value: boolean | null) {
        this.Set('AllowBackOrders', value);
    }

    /**
    * * Field Name: PaymentCaptureTimingBehavior
    * * Display Name: Payment Capture Timing Behavior
    * * SQL Data Type: nvarchar(100)
    */
    get PaymentCaptureTimingBehavior(): string | null {
        return this.Get('PaymentCaptureTimingBehavior');
    }
    set PaymentCaptureTimingBehavior(value: string | null) {
        this.Set('PaymentCaptureTimingBehavior', value);
    }

    /**
    * * Field Name: EligibleForShippingCharges
    * * Display Name: Eligible For Shipping Charges
    * * SQL Data Type: bit
    */
    get EligibleForShippingCharges(): boolean | null {
        return this.Get('EligibleForShippingCharges');
    }
    set EligibleForShippingCharges(value: boolean | null) {
        this.Set('EligibleForShippingCharges', value);
    }

    /**
    * * Field Name: Taxable
    * * Display Name: Taxable
    * * SQL Data Type: bit
    */
    get Taxable(): boolean | null {
        return this.Get('Taxable');
    }
    set Taxable(value: boolean | null) {
        this.Set('Taxable', value);
    }

    /**
    * * Field Name: TaxTable
    * * Display Name: Tax Table
    * * SQL Data Type: uniqueidentifier
    */
    get TaxTable(): string | null {
        return this.Get('TaxTable');
    }
    set TaxTable(value: string | null) {
        this.Set('TaxTable', value);
    }

    /**
    * * Field Name: ProrationTable
    * * Display Name: Proration Table
    * * SQL Data Type: uniqueidentifier
    */
    get ProrationTable(): string | null {
        return this.Get('ProrationTable');
    }
    set ProrationTable(value: string | null) {
        this.Set('ProrationTable', value);
    }

    /**
    * * Field Name: Project
    * * Display Name: Project
    * * SQL Data Type: uniqueidentifier
    */
    get Project(): string | null {
        return this.Get('Project');
    }
    set Project(value: string | null) {
        this.Set('Project', value);
    }

    /**
    * * Field Name: ARAccount
    * * Display Name: AR Account
    * * SQL Data Type: uniqueidentifier
    */
    get ARAccount(): string | null {
        return this.Get('ARAccount');
    }
    set ARAccount(value: string | null) {
        this.Set('ARAccount', value);
    }

    /**
    * * Field Name: Vendor
    * * Display Name: Vendor
    * * SQL Data Type: uniqueidentifier
    */
    get Vendor(): string | null {
        return this.Get('Vendor');
    }
    set Vendor(value: string | null) {
        this.Set('Vendor', value);
    }

    /**
    * * Field Name: DeferredRevenueAccount
    * * Display Name: Deferred Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get DeferredRevenueAccount(): string | null {
        return this.Get('DeferredRevenueAccount');
    }
    set DeferredRevenueAccount(value: string | null) {
        this.Set('DeferredRevenueAccount', value);
    }

    /**
    * * Field Name: WriteOffAccount
    * * Display Name: Write Off Account
    * * SQL Data Type: uniqueidentifier
    */
    get WriteOffAccount(): string | null {
        return this.Get('WriteOffAccount');
    }
    set WriteOffAccount(value: string | null) {
        this.Set('WriteOffAccount', value);
    }

    /**
    * * Field Name: InventoryAccount
    * * Display Name: Inventory Account
    * * SQL Data Type: uniqueidentifier
    */
    get InventoryAccount(): string | null {
        return this.Get('InventoryAccount');
    }
    set InventoryAccount(value: string | null) {
        this.Set('InventoryAccount', value);
    }

    /**
    * * Field Name: COGSAccount
    * * Display Name: COGS Account
    * * SQL Data Type: uniqueidentifier
    */
    get COGSAccount(): string | null {
        return this.Get('COGSAccount');
    }
    set COGSAccount(value: string | null) {
        this.Set('COGSAccount', value);
    }

    /**
    * * Field Name: CancellationFeeProduct
    * * Display Name: Cancellation Fee Product
    * * SQL Data Type: uniqueidentifier
    */
    get CancellationFeeProduct(): string | null {
        return this.Get('CancellationFeeProduct');
    }
    set CancellationFeeProduct(value: string | null) {
        this.Set('CancellationFeeProduct', value);
    }

    /**
    * * Field Name: CancellationFee
    * * Display Name: Cancellation Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get CancellationFee(): number | null {
        return this.Get('CancellationFee');
    }
    set CancellationFee(value: number | null) {
        this.Set('CancellationFee', value);
    }

    /**
    * * Field Name: RestockingFee
    * * Display Name: Restocking Fee
    * * SQL Data Type: decimal(19, 4)
    */
    get RestockingFee(): number | null {
        return this.Get('RestockingFee');
    }
    set RestockingFee(value: number | null) {
        this.Set('RestockingFee', value);
    }

    /**
    * * Field Name: RevenueRecognitionTemplate
    * * Display Name: Revenue Recognition Template
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueRecognitionTemplate(): string | null {
        return this.Get('RevenueRecognitionTemplate');
    }
    set RevenueRecognitionTemplate(value: string | null) {
        this.Set('RevenueRecognitionTemplate', value);
    }

    /**
    * * Field Name: RevenueAccount
    * * Display Name: Revenue Account
    * * SQL Data Type: uniqueidentifier
    */
    get RevenueAccount(): string | null {
        return this.Get('RevenueAccount');
    }
    set RevenueAccount(value: string | null) {
        this.Set('RevenueAccount', value);
    }

    /**
    * * Field Name: BillingTemplate
    * * Display Name: Billing Template
    * * SQL Data Type: uniqueidentifier
    */
    get BillingTemplate(): string | null {
        return this.Get('BillingTemplate');
    }
    set BillingTemplate(value: string | null) {
        this.Set('BillingTemplate', value);
    }

    /**
    * * Field Name: DefaultWarehouse
    * * Display Name: Default Warehouse
    * * SQL Data Type: uniqueidentifier
    */
    get DefaultWarehouse(): string | null {
        return this.Get('DefaultWarehouse');
    }
    set DefaultWarehouse(value: string | null) {
        this.Set('DefaultWarehouse', value);
    }

    /**
    * * Field Name: ShowOnMembershipForm
    * * Display Name: Show On Membership Form
    * * SQL Data Type: bit
    */
    get ShowOnMembershipForm(): boolean | null {
        return this.Get('ShowOnMembershipForm');
    }
    set ShowOnMembershipForm(value: boolean | null) {
        this.Set('ShowOnMembershipForm', value);
    }

    /**
    * * Field Name: ShowDuringEventRegistrations
    * * Display Name: Show During Event Registrations
    * * SQL Data Type: bit
    */
    get ShowDuringEventRegistrations(): boolean | null {
        return this.Get('ShowDuringEventRegistrations');
    }
    set ShowDuringEventRegistrations(value: boolean | null) {
        this.Set('ShowDuringEventRegistrations', value);
    }

    /**
    * * Field Name: UseShipToForPriceCalculation
    * * Display Name: Use Ship To For Price Calculation
    * * SQL Data Type: bit
    */
    get UseShipToForPriceCalculation(): boolean | null {
        return this.Get('UseShipToForPriceCalculation');
    }
    set UseShipToForPriceCalculation(value: boolean | null) {
        this.Set('UseShipToForPriceCalculation', value);
    }

    /**
    * * Field Name: ReorderPoint
    * * Display Name: Reorder Point
    * * SQL Data Type: decimal(19, 4)
    */
    get ReorderPoint(): number | null {
        return this.Get('ReorderPoint');
    }
    set ReorderPoint(value: number | null) {
        this.Set('ReorderPoint', value);
    }

    /**
    * * Field Name: IsActive
    * * Display Name: Is Active
    * * SQL Data Type: bit
    */
    get IsActive(): boolean | null {
        return this.Get('IsActive');
    }
    set IsActive(value: boolean | null) {
        this.Set('IsActive', value);
    }

    /**
    * * Field Name: HasSpecialPrices
    * * Display Name: Has Special Prices
    * * SQL Data Type: bit
    */
    get HasSpecialPrices(): boolean | null {
        return this.Get('HasSpecialPrices');
    }
    set HasSpecialPrices(value: boolean | null) {
        this.Set('HasSpecialPrices', value);
    }

    /**
    * * Field Name: HasEligibilityRestrictions
    * * Display Name: Has Eligibility Restrictions
    * * SQL Data Type: bit
    */
    get HasEligibilityRestrictions(): boolean | null {
        return this.Get('HasEligibilityRestrictions');
    }
    set HasEligibilityRestrictions(value: boolean | null) {
        this.Set('HasEligibilityRestrictions', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}


/**
 * MemberSuite: Write Offs - strongly typed entity sub-class
 * * Schema: membersuite
 * * Base Table: WriteOff
 * * Base View: vwWriteOffs
 * * Primary Key: ID
 * @extends {BaseEntity}
 * @class
 * @public
 */
@RegisterClass(BaseEntity, 'MemberSuite: Write Offs')
export class membersuiteWriteOffEntity extends BaseEntity<membersuiteWriteOffEntityType> {
    /**
    * Loads the MemberSuite: Write Offs record from the database
    * @param ID: string - primary key value to load the MemberSuite: Write Offs record.
    * @param EntityRelationshipsToLoad - (optional) the relationships to load
    * @returns {Promise<boolean>} - true if successful, false otherwise
    * @public
    * @async
    * @memberof membersuiteWriteOffEntity
    * @method
    * @override
    */
    public async Load(ID: string, EntityRelationshipsToLoad?: string[]) : Promise<boolean> {
        const compositeKey: CompositeKey = new CompositeKey();
        compositeKey.KeyValuePairs.push({ FieldName: 'ID', Value: ID });
        return await super.InnerLoad(compositeKey, EntityRelationshipsToLoad);
    }

    /**
    * * Field Name: ID
    * * Display Name: ID
    * * SQL Data Type: uniqueidentifier
    */
    get ID(): string {
        return this.Get('ID');
    }
    set ID(value: string) {
        this.Set('ID', value);
    }

    /**
    * * Field Name: Name
    * * Display Name: Name
    * * SQL Data Type: nvarchar(500)
    */
    get Name(): string | null {
        return this.Get('Name');
    }
    set Name(value: string | null) {
        this.Set('Name', value);
    }

    /**
    * * Field Name: Keywords
    * * Display Name: Keywords
    * * SQL Data Type: nvarchar(500)
    */
    get Keywords(): string | null {
        return this.Get('Keywords');
    }
    set Keywords(value: string | null) {
        this.Set('Keywords', value);
    }

    /**
    * * Field Name: LastModifiedBy
    * * Display Name: Last Modified By
    * * SQL Data Type: uniqueidentifier
    */
    get LastModifiedBy(): string | null {
        return this.Get('LastModifiedBy');
    }
    set LastModifiedBy(value: string | null) {
        this.Set('LastModifiedBy', value);
    }

    /**
    * * Field Name: LastModifiedDate
    * * Display Name: Last Modified Date
    * * SQL Data Type: datetime2
    */
    get LastModifiedDate(): Date | null {
        return this.Get('LastModifiedDate');
    }
    set LastModifiedDate(value: Date | null) {
        this.Set('LastModifiedDate', value);
    }

    /**
    * * Field Name: CreatedDate
    * * Display Name: Created Date
    * * SQL Data Type: datetime2
    */
    get CreatedDate(): Date | null {
        return this.Get('CreatedDate');
    }
    set CreatedDate(value: Date | null) {
        this.Set('CreatedDate', value);
    }

    /**
    * * Field Name: CreatedBy
    * * Display Name: Created By
    * * SQL Data Type: uniqueidentifier
    */
    get CreatedBy(): string | null {
        return this.Get('CreatedBy');
    }
    set CreatedBy(value: string | null) {
        this.Set('CreatedBy', value);
    }

    /**
    * * Field Name: LockedForDeletion
    * * Display Name: Locked For Deletion
    * * SQL Data Type: bit
    */
    get LockedForDeletion(): boolean | null {
        return this.Get('LockedForDeletion');
    }
    set LockedForDeletion(value: boolean | null) {
        this.Set('LockedForDeletion', value);
    }

    /**
    * * Field Name: IsConfiguration
    * * Display Name: Is Configuration
    * * SQL Data Type: bit
    */
    get IsConfiguration(): boolean | null {
        return this.Get('IsConfiguration');
    }
    set IsConfiguration(value: boolean | null) {
        this.Set('IsConfiguration', value);
    }

    /**
    * * Field Name: IsSealed
    * * Display Name: Is Sealed
    * * SQL Data Type: bit
    */
    get IsSealed(): boolean | null {
        return this.Get('IsSealed');
    }
    set IsSealed(value: boolean | null) {
        this.Set('IsSealed', value);
    }

    /**
    * * Field Name: CreatedByName
    * * Display Name: Created By Name
    * * SQL Data Type: nvarchar(500)
    */
    get CreatedByName(): string | null {
        return this.Get('CreatedByName');
    }
    set CreatedByName(value: string | null) {
        this.Set('CreatedByName', value);
    }

    /**
    * * Field Name: LastModifiedByName
    * * Display Name: Last Modified By Name
    * * SQL Data Type: nvarchar(500)
    */
    get LastModifiedByName(): string | null {
        return this.Get('LastModifiedByName');
    }
    set LastModifiedByName(value: string | null) {
        this.Set('LastModifiedByName', value);
    }

    /**
    * * Field Name: LocalID
    * * Display Name: Local ID
    * * SQL Data Type: bigint
    */
    get LocalID(): number | null {
        return this.Get('LocalID');
    }
    set LocalID(value: number | null) {
        this.Set('LocalID', value);
    }

    /**
    * * Field Name: OrderCancellation
    * * Display Name: Order Cancellation
    * * SQL Data Type: uniqueidentifier
    */
    get OrderCancellation(): string | null {
        return this.Get('OrderCancellation');
    }
    set OrderCancellation(value: string | null) {
        this.Set('OrderCancellation', value);
    }

    /**
    * * Field Name: Return
    * * Display Name: Return
    * * SQL Data Type: uniqueidentifier
    */
    get Return(): string | null {
        return this.Get('Return');
    }
    set Return(value: string | null) {
        this.Set('Return', value);
    }

    /**
    * * Field Name: Order
    * * Display Name: Order
    * * SQL Data Type: uniqueidentifier
    */
    get Order(): string | null {
        return this.Get('Order');
    }
    set Order(value: string | null) {
        this.Set('Order', value);
    }

    /**
    * * Field Name: Date
    * * Display Name: Date
    * * SQL Data Type: date
    */
    get Date(): Date | null {
        return this.Get('Date');
    }
    set Date(value: Date | null) {
        this.Set('Date', value);
    }

    /**
    * * Field Name: Memo
    * * Display Name: Memo
    * * SQL Data Type: nvarchar(500)
    */
    get Memo(): string | null {
        return this.Get('Memo');
    }
    set Memo(value: string | null) {
        this.Set('Memo', value);
    }

    /**
    * * Field Name: Notes
    * * Display Name: Notes
    * * SQL Data Type: nvarchar(MAX)
    */
    get Notes(): string | null {
        return this.Get('Notes');
    }
    set Notes(value: string | null) {
        this.Set('Notes', value);
    }

    /**
    * * Field Name: BadDebtsExpenseAccount
    * * Display Name: Bad Debts Expense Account
    * * SQL Data Type: uniqueidentifier
    */
    get BadDebtsExpenseAccount(): string | null {
        return this.Get('BadDebtsExpenseAccount');
    }
    set BadDebtsExpenseAccount(value: string | null) {
        this.Set('BadDebtsExpenseAccount', value);
    }

    /**
    * * Field Name: Method
    * * Display Name: Method
    * * SQL Data Type: nvarchar(100)
    */
    get Method(): string | null {
        return this.Get('Method');
    }
    set Method(value: string | null) {
        this.Set('Method', value);
    }

    /**
    * * Field Name: Batch
    * * Display Name: Batch
    * * SQL Data Type: uniqueidentifier
    */
    get Batch(): string | null {
        return this.Get('Batch');
    }
    set Batch(value: string | null) {
        this.Set('Batch', value);
    }

    /**
    * * Field Name: SourceCode
    * * Display Name: Source Code
    * * SQL Data Type: uniqueidentifier
    */
    get SourceCode(): string | null {
        return this.Get('SourceCode');
    }
    set SourceCode(value: string | null) {
        this.Set('SourceCode', value);
    }

    /**
    * * Field Name: MediaCode
    * * Display Name: Media Code
    * * SQL Data Type: uniqueidentifier
    */
    get MediaCode(): string | null {
        return this.Get('MediaCode');
    }
    set MediaCode(value: string | null) {
        this.Set('MediaCode', value);
    }

    /**
    * * Field Name: Invoice
    * * Display Name: Invoice
    * * SQL Data Type: uniqueidentifier
    */
    get Invoice(): string | null {
        return this.Get('Invoice');
    }
    set Invoice(value: string | null) {
        this.Set('Invoice', value);
    }

    /**
    * * Field Name: Total
    * * Display Name: Total
    * * SQL Data Type: decimal(19, 4)
    */
    get Total(): number | null {
        return this.Get('Total');
    }
    set Total(value: number | null) {
        this.Set('Total', value);
    }

    /**
    * * Field Name: TotalInBaseCurrency
    * * Display Name: Total In Base Currency
    * * SQL Data Type: decimal(19, 4)
    */
    get TotalInBaseCurrency(): number | null {
        return this.Get('TotalInBaseCurrency');
    }
    set TotalInBaseCurrency(value: number | null) {
        this.Set('TotalInBaseCurrency', value);
    }

    /**
    * * Field Name: BusinessUnit
    * * Display Name: Business Unit
    * * SQL Data Type: uniqueidentifier
    */
    get BusinessUnit(): string | null {
        return this.Get('BusinessUnit');
    }
    set BusinessUnit(value: string | null) {
        this.Set('BusinessUnit', value);
    }

    /**
    * * Field Name: CurrencyCode
    * * Display Name: Currency Code
    * * SQL Data Type: nvarchar(500)
    */
    get CurrencyCode(): string | null {
        return this.Get('CurrencyCode');
    }
    set CurrencyCode(value: string | null) {
        this.Set('CurrencyCode', value);
    }

    /**
    * * Field Name: _PulledAt
    * * Display Name: Pulled At
    * * SQL Data Type: datetime2
    * * Default Value: sysutcdatetime()
    */
    get _PulledAt(): Date {
        return this.Get('_PulledAt');
    }
    set _PulledAt(value: Date) {
        this.Set('_PulledAt', value);
    }

    /**
    * * Field Name: _RawJson
    * * Display Name: Raw Json
    * * SQL Data Type: nvarchar(MAX)
    */
    get _RawJson(): string | null {
        return this.Get('_RawJson');
    }
    set _RawJson(value: string | null) {
        this.Set('_RawJson', value);
    }

    /**
    * * Field Name: CompanyIntegrationID
    * * Display Name: Company Integration ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Company Integrations (vwCompanyIntegrations.ID)
    * * Default Value: F53F3DCE-6EBC-4D66-BDAD-38A6336F9D34
    */
    get CompanyIntegrationID(): string {
        return this.Get('CompanyIntegrationID');
    }
    set CompanyIntegrationID(value: string) {
        this.Set('CompanyIntegrationID', value);
    }

    /**
    * * Field Name: CompanyID
    * * Display Name: Company ID
    * * SQL Data Type: uniqueidentifier
    * * Related Entity/Foreign Key: MJ: Companies (vwCompanies.ID)
    * * Default Value: 1B159DCA-ABF4-F011-8D4B-7C1E528BAA8C
    */
    get CompanyID(): string {
        return this.Get('CompanyID');
    }
    set CompanyID(value: string) {
        this.Set('CompanyID', value);
    }

    /**
    * * Field Name: __mj_CreatedAt
    * * Display Name: Created At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_CreatedAt(): Date {
        return this.Get('__mj_CreatedAt');
    }

    /**
    * * Field Name: __mj_UpdatedAt
    * * Display Name: Updated At
    * * SQL Data Type: datetimeoffset
    * * Default Value: getutcdate()
    */
    get __mj_UpdatedAt(): Date {
        return this.Get('__mj_UpdatedAt');
    }

    /**
    * * Field Name: CompanyIntegration
    * * Display Name: Company Integration
    * * SQL Data Type: nvarchar(255)
    */
    get CompanyIntegration(): string {
        return this.Get('CompanyIntegration');
    }

    /**
    * * Field Name: Company
    * * Display Name: Company
    * * SQL Data Type: nvarchar(50)
    */
    get Company(): string {
        return this.Get('Company');
    }
}
